import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Upload: any;
};

export type Account = {
  __typename?: 'Account';
  accountStatus?: Maybe<AccountStatus>;
  accountType?: Maybe<AccountType>;
  allocatedFunds?: Maybe<Array<Maybe<AccountFundAllocation>>>;
  availableBalance: Money;
  balance: Money;
  balanceLastUpdatedAt?: Maybe<Scalars['String']>;
  balances: Array<AccountBalancesGrouped>;
  cards: Array<Card>;
  createdAt: Scalars['Date'];
  deposits: Money;
  externalAccountId?: Maybe<Scalars['String']>;
  externalAccountName: Scalars['String'];
  externalAccountNumber: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  externalRoutingNumber: Scalars['String'];
  id: Scalars['ID'];
  last4?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  organizationDefault: Scalars['Boolean'];
  organizationId: Scalars['String'];
  ownerUserIds?: Maybe<Array<Maybe<UserAndOrgIds>>>;
  owners: Array<User>;
  pendingBalance?: Maybe<Money>;
  selected?: Maybe<Scalars['Boolean']>;
  spent: Money;
  statements: Array<Statement>;
  totalBalance: Money;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type AccountBalancesArgs = {
  groupBy?: InputMaybe<BalancesGrouping>;
  timeframe?: InputMaybe<BalancesTimeframe>;
};


export type AccountOwnersArgs = {
  selectedId?: InputMaybe<Scalars['String']>;
};

export type AccountBalancesGrouped = {
  __typename?: 'AccountBalancesGrouped';
  balance: Money;
  percentage?: Maybe<Percentage>;
  period: Scalars['String'];
};

export type AccountFundAllocation = {
  __typename?: 'AccountFundAllocation';
  amount: Money;
  entityId: Scalars['String'];
  entityTopic: EntityTopic;
  id?: Maybe<Scalars['ID']>;
};

export type AccountHolder = {
  __typename?: 'AccountHolder';
  address: CounterpartyAddress;
  name: Scalars['String'];
};

export enum AccountRef {
  Checking = 'Checking',
  External = 'External'
}

export enum AccountStatus {
  Closed = 'Closed',
  Open = 'Open'
}

export enum AccountType {
  Crypto = 'Crypto',
  UnitDeposit = 'UnitDeposit'
}

export type AccountUserIdInput = {
  accountIds?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['String'];
};

export enum AccreditationMethod {
  Balance = 'Balance',
  Review = 'Review'
}

export type AddEmailToLineAuctionWaitlistInput = {
  email: Scalars['String'];
  upcomingAuctions: Array<UpcomingAuctionInput>;
};

export type AddOwnersToCheckingAccountInput = {
  accountId: Scalars['String'];
  userId: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type Alert = {
  __typename?: 'Alert';
  alertType?: Maybe<AlertType>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  meta?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export enum AlertType {
  PlaidEnrollmentUpdate = 'PlaidEnrollmentUpdate',
  UserVerification = 'UserVerification'
}

export type Alerts = {
  __typename?: 'Alerts';
  alerts?: Maybe<Array<Maybe<Alert>>>;
};

export type AmortizationCalculation = {
  __typename?: 'AmortizationCalculation';
  interestRatePercent: Scalars['Int'];
  monthlyPaymentAmount: Money;
  monthlyRepaymentFeePercent: Percentage;
  projectedPayoffDate: Scalars['String'];
  schedule: Array<AmortizationPayment>;
  termLengthInMonths: Scalars['Int'];
  totalAmountBorrowed: Money;
  totalInterestAmount: Money;
};

export type AmortizationCalculationInput = {
  amount: Scalars['Int'];
  termLengthInMonths?: InputMaybe<Scalars['Int']>;
};

export type AmortizationPayment = {
  __typename?: 'AmortizationPayment';
  interestAmountPaid: Money;
  paymentDate: Scalars['String'];
  paymentMonthDate?: Maybe<Scalars['String']>;
  principalAmountPaid: Money;
  remainingAmount: Money;
};

export type Asset = {
  __typename?: 'Asset';
  accountId?: Maybe<Scalars['String']>;
  balances?: Maybe<Array<Maybe<AccountBalancesGrouped>>>;
  category?: Maybe<AssetCategory>;
  connectedAccountId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Money>;
};


export type AssetBalancesArgs = {
  timeframe?: InputMaybe<BalancesTimeframe>;
};

export enum AssetCategory {
  Cash = 'Cash',
  Crypto = 'Crypto',
  Stocks = 'Stocks'
}

export type AssetData = {
  __typename?: 'AssetData';
  balances?: Maybe<Array<Maybe<AccountBalancesGrouped>>>;
  category: AssetCategory;
  isAsset?: Maybe<Scalars['Boolean']>;
  list: Array<Asset>;
};


export type AssetDataBalancesArgs = {
  timeframe?: InputMaybe<BalancesTimeframe>;
};

export type Assets = {
  __typename?: 'Assets';
  assets?: Maybe<Array<Maybe<AssetData>>>;
};

export type AuctionDate = {
  end: Scalars['String'];
  start: Scalars['String'];
};

export enum AuctionHouse {
  Bloodstock = 'Bloodstock',
  Triangle = 'Triangle'
}

export type AuthenticationInput = {
  email: Scalars['String'];
  inviteCode?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  recaptchaScore?: InputMaybe<Scalars['Float']>;
};

export enum BalancesGrouping {
  Day = 'Day',
  Month = 'Month',
  Year = 'Year'
}

export enum BalancesTimeframe {
  AllTime = 'AllTime',
  LastSeven = 'LastSeven',
  LastThirty = 'LastThirty',
  ThisYear = 'ThisYear',
  Today = 'Today'
}

export type BankAccounts = {
  __typename?: 'BankAccounts';
  accounts?: Maybe<Array<Maybe<Account>>>;
};

export type BankAccountsInput = {
  accountRef?: InputMaybe<Array<AccountRef>>;
  organizationId?: InputMaybe<Scalars['String']>;
  selectedId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type BankInstitution = {
  __typename?: 'BankInstitution';
  address?: Maybe<Scalars['String']>;
  isAchSupported?: Maybe<Scalars['Boolean']>;
  isWireSupported?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export type BeneficialOwner = {
  __typename?: 'BeneficialOwner';
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  dob?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  ownershipPercentage: Scalars['String'];
  phone: Scalars['String'];
  primaryContact?: Maybe<Scalars['Boolean']>;
  primaryOfficer?: Maybe<Scalars['Boolean']>;
  ssn?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type BeneficialOwnerInput = {
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  ownershipPercentage: Scalars['String'];
  phone: Scalars['String'];
  primaryContact: Scalars['Boolean'];
  primaryOfficer: Scalars['Boolean'];
  ssn?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

export enum BusinessEntityType {
  Corporation = 'Corporation',
  Llc = 'LLC',
  Partnership = 'Partnership'
}

export type BusinessOrgInput = {
  contactEmail: Scalars['String'];
  contactFirstName: Scalars['String'];
  contactLastName: Scalars['String'];
  contactPhoneNumber: Scalars['String'];
  dba?: InputMaybe<Scalars['String']>;
  officerCity: Scalars['String'];
  officerDateOfBirth: Scalars['String'];
  officerEmail: Scalars['String'];
  officerFirstName: Scalars['String'];
  officerLastName: Scalars['String'];
  officerPhoneNumber: Scalars['String'];
  officerPostalCode: Scalars['String'];
  officerSsn: Scalars['String'];
  officerState: Scalars['String'];
  officerStreetAddress: Scalars['String'];
  officerTitle: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CalculateLineTermsInput = {
  lineTypeId: Scalars['String'];
  loanAmount: Scalars['Float'];
  termLengthInMonths: Scalars['Int'];
};

export type Card = {
  __typename?: 'Card';
  accountId: Scalars['String'];
  address: Address;
  cardHolderEmail?: Maybe<Scalars['String']>;
  cardHolderFirstName?: Maybe<Scalars['String']>;
  cardHolderLastName?: Maybe<Scalars['String']>;
  cardHolderUserId?: Maybe<Scalars['String']>;
  design?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  externalAccountId?: Maybe<Scalars['String']>;
  externalCardHolderId?: Maybe<Scalars['String']>;
  externalCardId: Scalars['String'];
  id: Scalars['ID'];
  last4?: Maybe<Scalars['String']>;
  limit: Money;
  limitBehaviour?: Maybe<CardLimitBehaviourType>;
  limitEnabled?: Maybe<Scalars['Boolean']>;
  organizationId: Scalars['String'];
  spent: Money;
  spentThisMonth: Money;
  spentToday: Money;
  status: CardStatusType;
  type?: Maybe<CardType>;
};


export type CardSpentArgs = {
  timeframe?: InputMaybe<SpendTimeframe>;
};

export enum CardLimitBehaviourType {
  Monthly = 'Monthly',
  Refill = 'Refill'
}

export type CardSession = {
  __typename?: 'CardSession';
  challenge?: Maybe<Scalars['Boolean']>;
  externalCardId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type CardSessionInput = {
  cardId: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
};

export enum CardStatusType {
  Active = 'Active',
  ClosedByCustomer = 'ClosedByCustomer',
  Frozen = 'Frozen',
  Inactive = 'Inactive',
  Lost = 'Lost',
  Stolen = 'Stolen',
  SuspectedFraud = 'SuspectedFraud'
}

export enum CardType {
  Physical = 'Physical',
  Virtual = 'Virtual'
}

export type CardUserAccess = {
  cardId: Scalars['String'];
  role: Role;
  userId: Scalars['String'];
};

export type ChangeCardLimitInput = {
  cardId: Scalars['String'];
  limit?: InputMaybe<Scalars['Float']>;
  limitBehaviour?: InputMaybe<CardLimitBehaviourType>;
  limitEnabled?: InputMaybe<Scalars['Boolean']>;
};

export enum CheckStatus {
  Failed = 'Failed',
  NotStarted = 'NotStarted',
  Passed = 'Passed'
}

export type CloseCardInput = {
  cardId: Scalars['String'];
};

export type CloseCheckingAccountInput = {
  accountId: Scalars['String'];
};

export type Collateral = {
  __typename?: 'Collateral';
  collateralType: CollateralType;
  currentValue: Money;
  description: Scalars['String'];
  identification?: Maybe<Scalars['String']>;
  originalValue: Money;
};

export enum CollateralType {
  Horse = 'Horse'
}

export type CommitToDealInput = {
  committedAmount?: InputMaybe<Scalars['Float']>;
  dealCommitmentId?: InputMaybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealInvestorId?: InputMaybe<Scalars['String']>;
  executionDirection?: InputMaybe<DealExecutionDirection>;
  fundingAccountId: Scalars['String'];
  numberOfShares?: InputMaybe<Scalars['Float']>;
};

export type ConnectedAccount = {
  __typename?: 'ConnectedAccount';
  accountNumber?: Maybe<Scalars['String']>;
  availableBalance: Money;
  balance: Money;
  balanceLastUpdatedAt?: Maybe<Scalars['String']>;
  balances: Array<AccountBalancesGrouped>;
  connectedInstitutionId?: Maybe<Scalars['String']>;
  connectedInstitutionLogo?: Maybe<Scalars['String']>;
  connectedInstitutionName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isTesting?: Maybe<Scalars['Boolean']>;
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  provider: ConnectedAccountProvider;
  providerAccountId: Scalars['String'];
  providerEnrollmentId?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
  status?: Maybe<ConnectedAccountStatus>;
  subType?: Maybe<Scalars['String']>;
  totalBalance: Money;
  transactionsLastFetched?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type ConnectedAccountBalancesArgs = {
  groupBy?: InputMaybe<BalancesGrouping>;
  timeframe?: InputMaybe<BalancesTimeframe>;
};

export type ConnectedAccountConnectInput = {
  enrollmentId?: InputMaybe<Scalars['String']>;
  provider: ConnectedAccountProvider;
  token: Scalars['String'];
};

export type ConnectedAccountListParams = {
  groupBy?: InputMaybe<BalancesGrouping>;
  moveMoneyCapable?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['String']>;
  selectedId?: InputMaybe<Scalars['String']>;
  timeframe?: InputMaybe<BalancesTimeframe>;
  userId?: InputMaybe<Scalars['String']>;
};

export enum ConnectedAccountProvider {
  LetterTesting = 'LetterTesting',
  Plaid = 'Plaid',
  Teller = 'Teller',
  Vezgo = 'Vezgo'
}

export enum ConnectedAccountStatus {
  Disconnected = 'Disconnected',
  ExpiringSoon = 'ExpiringSoon',
  Locked = 'Locked',
  LoginRequired = 'LoginRequired',
  MfaBlocked = 'MfaBlocked',
  Ok = 'Ok',
  Outdated = 'Outdated',
  Syncing = 'Syncing'
}

export type ConnectedAccountsList = {
  __typename?: 'ConnectedAccountsList';
  connectedAccounts?: Maybe<Array<Maybe<ConnectedAccount>>>;
  flaggedEnrollmentsList?: Maybe<Array<Maybe<FlaggedEnrollment>>>;
};

export type CounterpartyAddress = {
  __typename?: 'CounterpartyAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type CounterpartyAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type CreateCardInput = {
  accountId: Scalars['String'];
  cardHolderEmail?: InputMaybe<Scalars['String']>;
  cardHolderFirstName?: InputMaybe<Scalars['String']>;
  cardHolderLastName?: InputMaybe<Scalars['String']>;
  cardHolderUserId?: InputMaybe<Scalars['String']>;
  design?: InputMaybe<Scalars['String']>;
  limit: Scalars['Float'];
  limitBehaviour?: InputMaybe<CardLimitBehaviourType>;
  role: Role;
  type?: InputMaybe<CardType>;
};

export type CreateDepositInput = {
  amount: Scalars['Float'];
  backOfCheck?: InputMaybe<Scalars['Upload']>;
  description: Scalars['String'];
  frontOfCheck?: InputMaybe<Scalars['Upload']>;
  targetAccountId: Scalars['ID'];
};

export type CreateLineInput = {
  amount: Scalars['Float'];
  auctionDate?: InputMaybe<AuctionDate>;
  lineTypeId: Scalars['String'];
  termLengthInMonths: Scalars['Int'];
};

export type CreateLinePaymentInput = {
  accountId: Scalars['String'];
  lineId: Scalars['String'];
  paymentType: LinePaymentType;
};

export type CreateOrUpdateOrgInput = {
  businessPhoneNumber?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  legalStructure?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  orgType: OrganizationType;
  organizationId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateOfIncorporation?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxStatus?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateOrUpdateOwnersInput = {
  beneficialOwners: Array<BeneficialOwnerInput>;
  organizationId: Scalars['String'];
};

export type CreatePaymentInput = {
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  direction: UnitAchDirection;
  lineId?: InputMaybe<Scalars['String']>;
  sourceAccountId: Scalars['String'];
  targetAccountId: Scalars['String'];
  targetAccountType: TargetAccountType;
};

export type CreatePullFundsInput = {
  amount: Scalars['Float'];
  sourceAccountId: Scalars['String'];
  targetAccountId: Scalars['String'];
};

export type CreateRecipientInput = {
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  routingNumber: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  transferType?: InputMaybe<TransferRecipientType>;
  wireDescription?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CreateWirePaymentInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<CounterpartyAddressInput>;
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  lineId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  recipientId?: InputMaybe<Scalars['String']>;
  routingNumber?: InputMaybe<Scalars['String']>;
  sourceAccountId: Scalars['String'];
};

export type CurrencyList = {
  __typename?: 'CurrencyList';
  list?: Maybe<Array<Scalars['String']>>;
  resourceType: Scalars['String'];
  type: Scalars['String'];
};

export type CurrencyListInput = {
  list?: InputMaybe<Array<Scalars['String']>>;
  resourceType: Scalars['String'];
  type: Scalars['String'];
};

export type DateRange = {
  __typename?: 'DateRange';
  end: Scalars['String'];
  start: Scalars['String'];
};

export type Deal = {
  __typename?: 'Deal';
  buyThreshold?: Maybe<Money>;
  caption?: Maybe<Scalars['String']>;
  closeDate: Scalars['String'];
  committedAmount?: Maybe<Money>;
  committedAmountBought?: Maybe<Money>;
  committedAmountSold?: Maybe<Money>;
  createdAt: Scalars['Date'];
  currentBatchId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  discount?: Maybe<Percentage>;
  distributions?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  impliedValuation?: Maybe<Money>;
  infoLink: Scalars['String'];
  lastRound?: Maybe<Scalars['String']>;
  lastValuation?: Maybe<Money>;
  letterFee?: Maybe<Money>;
  listingType?: Maybe<DealListingType>;
  logoImage?: Maybe<Scalars['String']>;
  minBuy?: Maybe<Money>;
  minInvestment: Money;
  minSell?: Maybe<Money>;
  name: Scalars['String'];
  sellThreshold?: Maybe<Money>;
  sharePrice?: Maybe<Money>;
  slug?: Maybe<Scalars['String']>;
  structure?: Maybe<Scalars['String']>;
  targetAmount: Money;
  targetedTotalReturn: Money;
  termLength: Scalars['String'];
  transactionAmountBought?: Maybe<Money>;
  transactionAmountSold?: Maybe<Money>;
};

export type DealCommitment = {
  __typename?: 'DealCommitment';
  amount?: Maybe<Money>;
  commitmentDate?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealInvestorId: Scalars['String'];
  executionDate?: Maybe<Scalars['String']>;
  executionDirection?: Maybe<DealExecutionDirection>;
  fundingAccountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  numberOfShares?: Maybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  status?: Maybe<DealCommitmentStatus>;
  userId: Scalars['String'];
};

export enum DealCommitmentStatus {
  Created = 'Created',
  Executed = 'Executed'
}

export enum DealEntityTypes {
  Btc = 'BTC',
  Eth = 'ETH',
  Sol = 'SOL',
  Share = 'Share',
  Usdc = 'USDC'
}

export enum DealExecutionDirection {
  Buy = 'Buy',
  Sell = 'Sell'
}

export type DealInvestor = {
  __typename?: 'DealInvestor';
  commitments?: Maybe<Array<Maybe<DealCommitment>>>;
  committedAmount?: Maybe<Money>;
  committedAmountBought?: Maybe<Money>;
  committedAmountSold?: Maybe<Money>;
  dealId: Scalars['String'];
  fundingAccountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organizationId: Scalars['String'];
  transactionAmountBought?: Maybe<Money>;
  transactionAmountSold?: Maybe<Money>;
  transactions?: Maybe<Array<Maybe<DealTransaction>>>;
  userId: Scalars['String'];
};

export enum DealListingType {
  Investment = 'Investment',
  Secondary = 'Secondary'
}

export type DealTransaction = {
  __typename?: 'DealTransaction';
  amount?: Maybe<Money>;
  committedAmount?: Maybe<Money>;
  createdAt?: Maybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealInvestorId: Scalars['String'];
  entityQuantity?: Maybe<Scalars['String']>;
  entityType?: Maybe<DealEntityTypes>;
  executionDirection?: Maybe<DealExecutionDirection>;
  formattedDate?: Maybe<Scalars['String']>;
  fundingAccountId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastUpdatedAt?: Maybe<Scalars['String']>;
  numberOfShares?: Maybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  sharePrice?: Maybe<Money>;
  status?: Maybe<DealTransactionStatuses>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionType?: Maybe<DealTransactionTypes>;
  userId: Scalars['String'];
};

export type DealTransactionList = {
  __typename?: 'DealTransactionList';
  dealTransactionList?: Maybe<Array<Maybe<DealTransaction>>>;
};

export enum DealTransactionStatuses {
  Buy = 'Buy',
  Sell = 'Sell'
}

export enum DealTransactionTypes {
  Canceled = 'Canceled',
  Clearing = 'Clearing',
  Committed = 'Committed',
  Completed = 'Completed',
  Held = 'Held',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Sent = 'Sent'
}

export type Deals = {
  __typename?: 'Deals';
  deals?: Maybe<Array<Maybe<Deal>>>;
};

export type DeleteDealCommitmentInput = {
  dealCommitmentId?: InputMaybe<Scalars['String']>;
  dealId: Scalars['String'];
  dealInvestorId?: InputMaybe<Scalars['String']>;
};

export type DeleteOrganizationInput = {
  orgId: Scalars['String'];
};

export type DepositCheckInput = {
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
};

export type DepositResult = {
  __typename?: 'DepositResult';
  amount: Money;
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type DisconnectConnectedAccountInput = {
  accountId?: InputMaybe<Scalars['String']>;
  idList?: InputMaybe<Array<Scalars['String']>>;
};

export type DismissConnectedAccountAlertInput = {
  alertId: Scalars['String'];
  alertType: Scalars['String'];
};

export type DocumentUrl = {
  __typename?: 'DocumentUrl';
  envelopeId: Scalars['String'];
  url: Scalars['String'];
};

export type EditCheckingAccountInput = {
  accountId: Scalars['String'];
  nickname: Scalars['String'];
};

export type EditConnectedAccountInput = {
  accountId: Scalars['String'];
  nickname: Scalars['String'];
};

export type EmailInviteToOrgUserInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export enum EntityTopic {
  Account = 'Account',
  Asset = 'Asset',
  Card = 'Card',
  ConnectedAccount = 'ConnectedAccount',
  Deal = 'Deal',
  Line = 'Line',
  Organization = 'Organization',
  Payment = 'Payment',
  Recipient = 'Recipient',
  Transaction = 'Transaction',
  User = 'User'
}

export enum EntityType {
  Account = 'Account',
  Card = 'Card'
}

export type ExternalAccountInstitution = {
  __typename?: 'ExternalAccountInstitution';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ExternalAccountLinks = {
  __typename?: 'ExternalAccountLinks';
  balances: Scalars['String'];
  details: Scalars['String'];
  self: Scalars['String'];
  transactions: Scalars['String'];
};

export type ExternalAccounts = {
  __typename?: 'ExternalAccounts';
  currency_code: Scalars['String'];
  enrollment_id: Scalars['String'];
  id: Scalars['ID'];
  institution?: Maybe<ExternalAccountInstitution>;
  last_four: Scalars['String'];
  links?: Maybe<ExternalAccountLinks>;
  name: Scalars['String'];
  subtype: Scalars['String'];
  type: Scalars['String'];
};

export type ExternalTransactionLinks = {
  __typename?: 'ExternalTransactionLinks';
  account: Scalars['String'];
  self: Scalars['String'];
};

export type ExternalTransactions = {
  __typename?: 'ExternalTransactions';
  account_id: Scalars['String'];
  amount: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  links?: Maybe<ExternalTransactionLinks>;
  running_balance: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type FileUploadSession = {
  __typename?: 'FileUploadSession';
  sessionId: Scalars['String'];
};

export type FlaggedEnrollment = {
  __typename?: 'FlaggedEnrollment';
  consentExpirationTime?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  providerEnrollmentId: Scalars['String'];
  transactions?: Maybe<Scalars['String']>;
  updateType?: Maybe<Scalars['String']>;
};

export type FreezeCardInput = {
  cardId: Scalars['String'];
};

export type GenericResult = {
  __typename?: 'GenericResult';
  success: Scalars['Boolean'];
};

export type ImpersonationResponse = {
  allow: Scalars['Boolean'];
  id: Scalars['String'];
};

export type InviteOrgUserInput = {
  email: Scalars['String'];
  permissionLevel: PermissionLevel;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
};

export type InviteUserToOrgResponse = {
  __typename?: 'InviteUserToOrgResponse';
  token: Scalars['String'];
  userId: Scalars['String'];
};

export type Line = {
  __typename?: 'Line';
  amountBorrowed: Money;
  amountPaidOff: Money;
  auctionDate?: Maybe<DateRange>;
  auctionHouse?: Maybe<AuctionHouse>;
  collateral: Array<Collateral>;
  collateralType: CollateralType;
  completedPaymentIds: Array<Scalars['String']>;
  createdAt: Scalars['String'];
  documents: Array<LineDocument>;
  downPaymentAccountId: Scalars['String'];
  downPaymentAmount: Money;
  finalized?: Maybe<Scalars['Boolean']>;
  fundStatus?: Maybe<CheckStatus>;
  id: Scalars['ID'];
  interestAmountPaidOff: Money;
  interestRate: Percentage;
  latePaymentIds: Array<Scalars['String']>;
  lineType: LineType;
  lineTypeId: Scalars['String'];
  loanAmount: Money;
  loanFundedAt?: Maybe<Scalars['String']>;
  loanInterestAmount: Money;
  loanType: LoanType;
  ltvPercent: Percentage;
  monthlyRepaymentAmount: Money;
  monthsRemaining: Scalars['Int'];
  monthsTotal: Scalars['Int'];
  organizationId: Scalars['String'];
  originationStatus: LineOriginationStatus;
  outstandingBalance: Money;
  paidOffDate?: Maybe<Scalars['String']>;
  paymentSchedule?: Maybe<Array<Maybe<AmortizationPayment>>>;
  personalGuarantee: Scalars['Boolean'];
  preApprovalAmount?: Maybe<Money>;
  preApprovalExpirationDate: Scalars['String'];
  preApprovalId?: Maybe<Scalars['String']>;
  principalAmountPaidOff: Money;
  principalRemaining: Money;
  projectedPayoffDate: Scalars['String'];
  proofOfInsuranceUploaded: Scalars['Boolean'];
  purchaseAmount?: Maybe<Money>;
  purchaseStatus?: Maybe<CheckStatus>;
  repaymentDate: Scalars['Int'];
  status: LineStatus;
  subscription?: Maybe<Subscription>;
  subscriptionId: Scalars['String'];
  termLengthInMonths: Scalars['Int'];
  userId: Scalars['String'];
};

export type LineDocument = {
  __typename?: 'LineDocument';
  documentDownload?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  documentStatus: LineDocumentStatus;
  documentType: LineDocumentType;
  signed: Scalars['Boolean'];
  signedOn?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type LineDocumentPdf = {
  __typename?: 'LineDocumentPDF';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type LineDocumentPdfList = {
  __typename?: 'LineDocumentPDFList';
  documents: Array<Maybe<LineDocumentPdf>>;
};

export enum LineDocumentStatus {
  Failed = 'Failed',
  Sent = 'Sent',
  Signed = 'Signed',
  Unsigned = 'Unsigned'
}

export enum LineDocumentType {
  ClosingDocuments = 'ClosingDocuments',
  Collateral = 'Collateral',
  Loan = 'Loan'
}

export enum LineOriginationStatus {
  AcceptedTerms = 'AcceptedTerms',
  ClosingDocumentsSigned = 'ClosingDocumentsSigned',
  Created = 'Created',
  DownPaymentAccountAllocated = 'DownPaymentAccountAllocated',
  DownPaymentInitiated = 'DownPaymentInitiated',
  LoanDocsSigned = 'LoanDocsSigned',
  LoanFunded = 'LoanFunded',
  PurchaseComplete = 'PurchaseComplete'
}

export enum LinePaymentType {
  DownPayment = 'DownPayment',
  InDefaultPayment = 'InDefaultPayment',
  OneOffPayment = 'OneOffPayment'
}

export enum LineStatus {
  ApprovalCompleted = 'ApprovalCompleted',
  AwaitingApproval = 'AwaitingApproval',
  AwaitingDeposit = 'AwaitingDeposit',
  AwaitingLoanSignature = 'AwaitingLoanSignature',
  Canceled = 'Canceled',
  ClosingDocumentsSigned = 'ClosingDocumentsSigned',
  DepositReceived = 'DepositReceived',
  GoodStanding = 'GoodStanding',
  InDefault = 'InDefault',
  LatePayment = 'LatePayment',
  PaidOff = 'PaidOff'
}

export type LineTermsCalculation = {
  __typename?: 'LineTermsCalculation';
  downPaymentAmount: Money;
  interestRate: Percentage;
};

export type LineTotals = {
  __typename?: 'LineTotals';
  approxPayOffDate: Scalars['String'];
  availableToBorrow: Money;
  monthsRemaining: Scalars['Int'];
  monthsTotal: Scalars['Int'];
  openLines: Scalars['Int'];
  outstandingBalance: Money;
  totalAmountBorrowed: Money;
  totalAmountPaidOff: Money;
  totalMonthlyPayment: Money;
};

export type LineType = {
  __typename?: 'LineType';
  apyRange: PercentageRange;
  collateralType: CollateralType;
  description: Scalars['String'];
  id: Scalars['ID'];
  ltvRange: PercentageRange;
  maxOfferingAmount: Money;
  requiredDeposit?: Maybe<Money>;
  termLengthMonths?: Maybe<Array<Maybe<Scalars['Int']>>>;
  termMonthRange: NumberRange;
  title: Scalars['String'];
};

export enum LoanType {
  FullyAmortized = 'FullyAmortized'
}

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  display: Scalars['String'];
};

export type MultiFactor = {
  __typename?: 'MultiFactor';
  qr: Scalars['String'];
  secret: Scalars['String'];
  uri: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptLineTerms?: Maybe<Line>;
  addCardToUser?: Maybe<User>;
  addCryptoAccount?: Maybe<GenericResult>;
  addEmailToLineAuctionWaitlist?: Maybe<GenericResult>;
  addEmailToWaitlist?: Maybe<GenericResult>;
  addOwnersToCheckingAccount?: Maybe<Account>;
  addPersonalInformationToUser?: Maybe<User>;
  addUserToAccounts?: Maybe<GenericResult>;
  addUserToConnectedAccounts?: Maybe<GenericResult>;
  addVerificationToUser?: Maybe<User>;
  allocateLineDownPaymentAccountId?: Maybe<Line>;
  allocateRepaymentAccountId?: Maybe<Organization>;
  calculateLineTerms?: Maybe<LineTermsCalculation>;
  cancelAccount?: Maybe<GenericResult>;
  cancelLine?: Maybe<GenericResult>;
  changeCardLimit?: Maybe<Card>;
  changePassword?: Maybe<GenericResult>;
  closeCard?: Maybe<Card>;
  closeCheckingAccount?: Maybe<GenericResult>;
  commitToDeal?: Maybe<GenericResult>;
  completeCardSession?: Maybe<CardSession>;
  connectConnectedAccountProvider?: Maybe<ProviderConnectResult>;
  createCard?: Maybe<Card>;
  createCardSession?: Maybe<CardSession>;
  createDeposit?: Maybe<DepositResult>;
  createFileUploadSession?: Maybe<FileUploadSession>;
  createLine?: Maybe<Line>;
  createLinePayment?: Maybe<GenericResult>;
  createOnfidoApplication?: Maybe<OnfidoApplication>;
  createOnfidoCheck?: Maybe<GenericResult>;
  createOrUpdateOrganization?: Maybe<Organization>;
  createPayment?: Maybe<Payment>;
  createRecipient?: Maybe<Recipient>;
  createUser?: Maybe<User>;
  createWirePayment?: Maybe<Payment>;
  deleteAsset?: Maybe<GenericResult>;
  deleteDealCommitment?: Maybe<GenericResult>;
  deleteOrganization?: Maybe<GenericResult>;
  deleteRecipient?: Maybe<GenericResult>;
  depositCheck?: Maybe<GenericResult>;
  disconnectConnectedAccount?: Maybe<GenericResult>;
  dismissConnectedAccountAlert?: Maybe<GenericResult>;
  editBasicUserInformation?: Maybe<User>;
  editCardUserAccess?: Maybe<GenericResult>;
  editCheckingAccount?: Maybe<Account>;
  editConnectedAccount?: Maybe<ConnectedAccount>;
  editOrgUserAccess?: Maybe<GenericResult>;
  editUserDeviceToken?: Maybe<User>;
  editUserNotificationSettings?: Maybe<User>;
  freezeCard?: Maybe<Card>;
  freezeOrgUser?: Maybe<GenericResult>;
  generateMultiFactor?: Maybe<MultiFactor>;
  getConnectedToken?: Maybe<TokenResult>;
  initiateLineDownPayment?: Maybe<Line>;
  inviteUserToOrg?: Maybe<InviteUserToOrgResponse>;
  login: Session;
  logout?: Maybe<GenericResult>;
  openAccount?: Maybe<User>;
  openCheckingAccount?: Maybe<Account>;
  reIssueToken: Session;
  recaptchaSiteVerify?: Maybe<Recaptcha>;
  refreshAccountBalance?: Maybe<BankAccounts>;
  refreshConnectedAccount?: Maybe<ConnectedAccount>;
  refreshConnectedAccounts?: Maybe<GenericResult>;
  removeCardFromUser?: Maybe<User>;
  removeOrgUser?: Maybe<GenericResult>;
  removeOwnersFromCheckingAccount?: Maybe<GenericResult>;
  removeUserFromAccounts?: Maybe<GenericResult>;
  removeUserFromConnectedAccounts?: Maybe<GenericResult>;
  replaceCard?: Maybe<GenericResult>;
  reportCardLost?: Maybe<Card>;
  reportCardStolen?: Maybe<Card>;
  requestAccreditation?: Maybe<GenericResult>;
  requestMoreReferrals?: Maybe<GenericResult>;
  requestPasswordReset?: Maybe<GenericResult>;
  resetPassword?: Maybe<User>;
  respondToImpersonationRequest?: Maybe<GenericResult>;
  revokeInviteToOrg?: Maybe<GenericResult>;
  runCreditCheck?: Maybe<Organization>;
  thawOrgUser?: Maybe<GenericResult>;
  transferBetweenAccounts?: Maybe<Transaction>;
  triggerVerification?: Maybe<GenericResult>;
  unfreezeCard?: Maybe<Card>;
  unlockAccount?: Maybe<User>;
  updateAndResetLine?: Maybe<Line>;
  updateDealCommitment?: Maybe<GenericResult>;
  updateOrganization?: Maybe<Organization>;
  updateOwners?: Maybe<GenericResult>;
  uploadProofOfInsuranceForLine?: Maybe<Line>;
  validatePasswordResetToken?: Maybe<ValidResult>;
  verifyMultiFactor: Session;
};


export type MutationAcceptLineTermsArgs = {
  lineId: Scalars['String'];
};


export type MutationAddCardToUserArgs = {
  input: UserAddCardInput;
};


export type MutationAddCryptoAccountArgs = {
  input: ZaboAccountInput;
};


export type MutationAddEmailToLineAuctionWaitlistArgs = {
  input: AddEmailToLineAuctionWaitlistInput;
};


export type MutationAddEmailToWaitlistArgs = {
  input: UserWaitlistEmailInput;
};


export type MutationAddOwnersToCheckingAccountArgs = {
  input: AddOwnersToCheckingAccountInput;
};


export type MutationAddPersonalInformationToUserArgs = {
  input: UserPersonalInformationInput;
};


export type MutationAddUserToAccountsArgs = {
  input: AccountUserIdInput;
};


export type MutationAddUserToConnectedAccountsArgs = {
  input: AccountUserIdInput;
};


export type MutationAddVerificationToUserArgs = {
  input: UserVerificationInput;
};


export type MutationAllocateLineDownPaymentAccountIdArgs = {
  accountId: Scalars['String'];
  lineId: Scalars['String'];
};


export type MutationAllocateRepaymentAccountIdArgs = {
  accountId: Scalars['String'];
};


export type MutationCalculateLineTermsArgs = {
  input: CalculateLineTermsInput;
};


export type MutationCancelLineArgs = {
  lineId: Scalars['String'];
  orgId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationChangeCardLimitArgs = {
  input: ChangeCardLimitInput;
};


export type MutationChangePasswordArgs = {
  input: UserChangePasswordInput;
};


export type MutationCloseCardArgs = {
  input: CloseCardInput;
};


export type MutationCloseCheckingAccountArgs = {
  input: CloseCheckingAccountInput;
};


export type MutationCommitToDealArgs = {
  input: CommitToDealInput;
};


export type MutationCompleteCardSessionArgs = {
  input: CardSessionInput;
};


export type MutationConnectConnectedAccountProviderArgs = {
  input: ConnectedAccountConnectInput;
};


export type MutationCreateCardArgs = {
  input: CreateCardInput;
};


export type MutationCreateDepositArgs = {
  input: CreateDepositInput;
};


export type MutationCreateLineArgs = {
  input: CreateLineInput;
};


export type MutationCreateLinePaymentArgs = {
  input: CreateLinePaymentInput;
};


export type MutationCreateOnfidoApplicationArgs = {
  input: OnfidoApplicationInput;
};


export type MutationCreateOrUpdateOrganizationArgs = {
  input: CreateOrUpdateOrgInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateRecipientArgs = {
  input: CreateRecipientInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationCreateWirePaymentArgs = {
  input: CreateWirePaymentInput;
};


export type MutationDeleteAssetArgs = {
  assetId: Scalars['String'];
};


export type MutationDeleteDealCommitmentArgs = {
  input: DeleteDealCommitmentInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteRecipientArgs = {
  recipientId: Scalars['String'];
};


export type MutationDepositCheckArgs = {
  input: DepositCheckInput;
};


export type MutationDisconnectConnectedAccountArgs = {
  input: DisconnectConnectedAccountInput;
};


export type MutationDismissConnectedAccountAlertArgs = {
  input: DismissConnectedAccountAlertInput;
};


export type MutationEditBasicUserInformationArgs = {
  input: UserEditInput;
};


export type MutationEditCardUserAccessArgs = {
  input: CardUserAccess;
};


export type MutationEditCheckingAccountArgs = {
  input: EditCheckingAccountInput;
};


export type MutationEditConnectedAccountArgs = {
  input: EditConnectedAccountInput;
};


export type MutationEditOrgUserAccessArgs = {
  input: OrgUserAccess;
};


export type MutationEditUserDeviceTokenArgs = {
  input: UserEditDeviceTokenInput;
};


export type MutationEditUserNotificationSettingsArgs = {
  input: UserEditNotificationSettingsInput;
};


export type MutationFreezeCardArgs = {
  input: FreezeCardInput;
};


export type MutationFreezeOrgUserArgs = {
  userId: Scalars['String'];
};


export type MutationGetConnectedTokenArgs = {
  input: ProviderTokenInput;
};


export type MutationInitiateLineDownPaymentArgs = {
  lineId: Scalars['String'];
};


export type MutationInviteUserToOrgArgs = {
  input: InviteOrgUserInput;
};


export type MutationLoginArgs = {
  input: AuthenticationInput;
};


export type MutationOpenCheckingAccountArgs = {
  input: OpenCheckingAccountInput;
};


export type MutationReIssueTokenArgs = {
  input: ReIssueTokenInput;
};


export type MutationRecaptchaSiteVerifyArgs = {
  input: RecaptchaInput;
};


export type MutationRefreshAccountBalanceArgs = {
  input: RefreshBalanceInput;
};


export type MutationRefreshConnectedAccountArgs = {
  accountId: Scalars['String'];
};


export type MutationRemoveCardFromUserArgs = {
  input: UserRemoveCardInput;
};


export type MutationRemoveOrgUserArgs = {
  userId: Scalars['String'];
};


export type MutationRemoveOwnersFromCheckingAccountArgs = {
  input: RemoveOwnersToCheckingAccountInput;
};


export type MutationRemoveUserFromAccountsArgs = {
  input: AccountUserIdInput;
};


export type MutationRemoveUserFromConnectedAccountsArgs = {
  input: AccountUserIdInput;
};


export type MutationReplaceCardArgs = {
  input: ReplaceCardInput;
};


export type MutationReportCardLostArgs = {
  input: ReportCardLostInput;
};


export type MutationReportCardStolenArgs = {
  input: ReportCardStolenInput;
};


export type MutationRequestPasswordResetArgs = {
  input: UserRequestPasswordResetInput;
};


export type MutationResetPasswordArgs = {
  input: UserResetPasswordInput;
};


export type MutationRespondToImpersonationRequestArgs = {
  input: ImpersonationResponse;
};


export type MutationRevokeInviteToOrgArgs = {
  input: RevokeOrgUserInput;
};


export type MutationThawOrgUserArgs = {
  userId: Scalars['String'];
};


export type MutationTransferBetweenAccountsArgs = {
  input: TransferBetweenAccountsInput;
};


export type MutationTriggerVerificationArgs = {
  input: UserTriggerVerification;
};


export type MutationUnfreezeCardArgs = {
  input: UnfreezeCardInput;
};


export type MutationUpdateAndResetLineArgs = {
  input: CreateLineInput;
  lineId: Scalars['String'];
};


export type MutationUpdateDealCommitmentArgs = {
  input: CommitToDealInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOwnersArgs = {
  input: CreateOrUpdateOwnersInput;
};


export type MutationUploadProofOfInsuranceForLineArgs = {
  input: ProofOfInsuranceForLineInput;
};


export type MutationValidatePasswordResetTokenArgs = {
  input: ValidateTokenInput;
};


export type MutationVerifyMultiFactorArgs = {
  input: VerifyMultiFactorInput;
};

export type NetWorth = {
  __typename?: 'NetWorth';
  assetValue: Money;
  assets: Array<NetWorthAsset>;
  balances?: Maybe<Array<Maybe<AccountBalancesGrouped>>>;
  debtValue: Money;
  orgAssets: Array<Asset>;
  totalValue: Money;
};


export type NetWorthBalancesArgs = {
  filterByAsset?: InputMaybe<Scalars['Boolean']>;
  timeframe?: InputMaybe<BalancesTimeframe>;
};

export type NetWorthAsset = {
  __typename?: 'NetWorthAsset';
  category: AssetCategory;
  isAsset: Scalars['Boolean'];
  percentage?: Maybe<Percentage>;
  value: Money;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  receivePush: Scalars['Boolean'];
  receiveSms: Scalars['Boolean'];
};

export type NumberRange = {
  __typename?: 'NumberRange';
  lower: Scalars['Int'];
  upper: Scalars['Int'];
};

export type OneLine = {
  __typename?: 'OneLine';
  availableToUnderwrite: Scalars['Boolean'];
  eligibilityQualificationAmount: Money;
  eligibleForQualification: Scalars['Boolean'];
  lines: Array<Line>;
  repaymentAccount?: Maybe<RepaymentAccount>;
  repaymentAccountId?: Maybe<Scalars['String']>;
  repaymentAccountType?: Maybe<TargetAccountType>;
  repaymentFeePercent?: Maybe<Money>;
  totals: LineTotals;
  underwritingReviewStatus?: Maybe<CheckStatus>;
};

export type OnfidoApplication = {
  __typename?: 'OnfidoApplication';
  applicantId?: Maybe<Scalars['String']>;
  sdkToken?: Maybe<Scalars['String']>;
};

export type OnfidoApplicationInput = {
  referrer?: InputMaybe<Scalars['String']>;
};

export type OpenCheckingAccountInput = {
  nickname: Scalars['String'];
};

export enum OrgType {
  Business = 'Business',
  Individual = 'Individual',
  Trust = 'Trust'
}

export type OrgUserAccess = {
  role: Role;
  userId: Scalars['String'];
};

export type Organization = {
  __typename?: 'Organization';
  accountHolder?: Maybe<AccountHolder>;
  accredited?: Maybe<Scalars['Boolean']>;
  accreditedOn?: Maybe<Scalars['String']>;
  accreditedVia?: Maybe<AccreditationMethod>;
  availableBalance: Money;
  balance: Money;
  balances: Array<AccountBalancesGrouped>;
  beneficialOwners?: Maybe<Array<BeneficialOwner>>;
  beneficialOwnersList?: Maybe<Array<BeneficialOwner>>;
  businessPhoneNumber?: Maybe<Scalars['String']>;
  cardIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cards: Array<Card>;
  category?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  connectedAvailableBalance: Money;
  connectedTotalBalance: Money;
  contactEmail?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  creditCheck?: Maybe<CheckStatus>;
  creditScoreLastChecked?: Maybe<Scalars['String']>;
  currentContext: Scalars['Boolean'];
  dba?: Maybe<Scalars['String']>;
  deals: Array<DealInvestor>;
  deposits: Money;
  externalBalance: Money;
  fromPartnership?: Maybe<Scalars['Boolean']>;
  hasDepositedInitial?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  legalStructure?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netWorth: NetWorth;
  oneLine: OneLine;
  oneLineAvailableToBorrow?: Maybe<Money>;
  oneLineAvailableToBorrowLastUpdatedAt?: Maybe<Scalars['String']>;
  orgType: OrgType;
  ownerUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnershipType?: Maybe<PartnershipType>;
  permissionLevel?: Maybe<PermissionLevel>;
  repaymentAccountId?: Maybe<Scalars['String']>;
  repaymentAccountType?: Maybe<TargetAccountType>;
  role: Role;
  session?: Maybe<Scalars['String']>;
  spent: Money;
  state?: Maybe<Scalars['String']>;
  stateOfIncorporation?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxStatus?: Maybe<Scalars['String']>;
  totalBalance: Money;
  underwritingReviewStatus?: Maybe<CheckStatus>;
  userRelationship?: Maybe<UserOrganization>;
  users: Array<User>;
  website?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};


export type OrganizationBalancesArgs = {
  groupBy?: InputMaybe<BalancesGrouping>;
  timeframe?: InputMaybe<BalancesTimeframe>;
};


export type OrganizationNetWorthArgs = {
  timeframe?: InputMaybe<BalancesTimeframe>;
};


export type OrganizationUsersArgs = {
  selectedId?: InputMaybe<Scalars['String']>;
};

export enum OrganizationType {
  Business = 'Business',
  Individual = 'Individual'
}

export type Paging = {
  __typename?: 'Paging';
  total?: Maybe<Scalars['Int']>;
};

export enum PartnershipType {
  Letter = 'Letter',
  TetonRidge = 'TetonRidge'
}

export type Payment = {
  __typename?: 'Payment';
  amount: Money;
  description?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lineId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sourceAccountId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  targetAccountId?: Maybe<Scalars['String']>;
  targetAccountType?: Maybe<Scalars['String']>;
};

export enum PaymentDirection {
  Credit = 'Credit',
  Debit = 'Debit'
}

export enum PaymentInterval {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type Percentage = {
  __typename?: 'Percentage';
  amount: Scalars['Float'];
  display: Scalars['String'];
};

export type PercentageRange = {
  __typename?: 'PercentageRange';
  lower: Percentage;
  upper: Percentage;
};

export enum PermissionLevel {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER'
}

export type ProofOfInsuranceForLineInput = {
  insuranceProof: Scalars['Upload'];
  lineId: Scalars['String'];
};

export type ProviderConnectResult = {
  __typename?: 'ProviderConnectResult';
  enrollmentId: Scalars['String'];
  expectedNewAccountsData?: Maybe<Array<Maybe<ConnectedAccount>>>;
  expectedNewAccountsNumber: Scalars['Int'];
  token?: Maybe<Scalars['String']>;
};

export type ProviderScope = {
  __typename?: 'ProviderScope';
  description: Scalars['String'];
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type ProviderScopeInput = {
  description: Scalars['String'];
  displayName: Scalars['String'];
  name: Scalars['String'];
};

export type ProviderTokenInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  provider: ConnectedAccountProvider;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  alerts: Alerts;
  assets: Assets;
  bankAccounts: BankAccounts;
  calculateAmortization?: Maybe<AmortizationCalculation>;
  card: Card;
  connectedAccount: ConnectedAccount;
  connectedAccountsList: ConnectedAccountsList;
  connectedUpdateToken?: Maybe<TokenResult>;
  deals: Deals;
  documentSigningCompleted?: Maybe<GenericResult>;
  doesInviteExistForEmail: GenericResult;
  generateLineDocumentUrl?: Maybe<DocumentUrl>;
  getLineDocuments?: Maybe<LineDocumentPdfList>;
  institutionInfo: BankInstitution;
  line: Line;
  lineAuctionDates: Array<UpcomingAuction>;
  lineType: LineType;
  lineTypes: Array<LineType>;
  me: User;
  organization: Organization;
  recipient: Recipient;
  recipients: Recipients;
  statement?: Maybe<StatementPdf>;
  transactionsByAccountId: TransactionListWithPaging;
  transactionsForOrg: TransactionListWithPaging;
  user?: Maybe<User>;
  userBalance?: Maybe<UserCardsBalance>;
  validSession: GenericResult;
  weeklyActivityByAccountId: WeeklyActivity;
};


export type QueryAccountArgs = {
  accountId: Scalars['String'];
};


export type QueryAlertsArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryBankAccountsArgs = {
  input: BankAccountsInput;
};


export type QueryCalculateAmortizationArgs = {
  input: AmortizationCalculationInput;
};


export type QueryCardArgs = {
  cardId: Scalars['String'];
};


export type QueryConnectedAccountArgs = {
  accountId: Scalars['String'];
};


export type QueryConnectedAccountsListArgs = {
  connectedParams?: InputMaybe<ConnectedAccountListParams>;
};


export type QueryConnectedUpdateTokenArgs = {
  enrollmentId: Scalars['String'];
};


export type QueryDocumentSigningCompletedArgs = {
  documentId: Scalars['String'];
  lineId: Scalars['String'];
};


export type QueryDoesInviteExistForEmailArgs = {
  email: Scalars['String'];
};


export type QueryGenerateLineDocumentUrlArgs = {
  documentType: LineDocumentType;
  lineId: Scalars['String'];
};


export type QueryGetLineDocumentsArgs = {
  lineId: Scalars['String'];
};


export type QueryInstitutionInfoArgs = {
  routingNumber: Scalars['String'];
};


export type QueryLineArgs = {
  lineId: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
};


export type QueryLineAuctionDatesArgs = {
  includePast?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLineTypeArgs = {
  lineTypeId: Scalars['String'];
};


export type QueryOrganizationArgs = {
  orgId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryRecipientArgs = {
  recipientId: Scalars['String'];
};


export type QueryStatementArgs = {
  accountId: Scalars['String'];
  statementId: Scalars['String'];
};


export type QueryTransactionsByAccountIdArgs = {
  accountId: Scalars['String'];
  cardId?: InputMaybe<Scalars['String']>;
  filterParams?: InputMaybe<TransactionFilterInput>;
};


export type QueryTransactionsForOrgArgs = {
  filterParams?: InputMaybe<TransactionFilterInput>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryWeeklyActivityByAccountIdArgs = {
  accountId?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['String']>;
};

export type QueueUser = {
  __typename?: 'QueueUser';
  maxReferrals?: Maybe<Scalars['Int']>;
  points?: Maybe<Scalars['Int']>;
  referralCode?: Maybe<Scalars['String']>;
  referredUserIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  referredUsers?: Maybe<Array<Maybe<User>>>;
  totalQueueUsers?: Maybe<Scalars['Int']>;
  userPosition?: Maybe<Scalars['Int']>;
  wantsMoreReferrals?: Maybe<Scalars['Boolean']>;
};

export type ReIssueTokenInput = {
  organizationId: Scalars['String'];
};

export type Recaptcha = {
  __typename?: 'Recaptcha';
  errorCodesList?: Maybe<Array<Maybe<Scalars['String']>>>;
  score?: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
};

export type RecaptchaInput = {
  token: Scalars['String'];
};

export type Recipient = {
  __typename?: 'Recipient';
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  nickname?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  routingNumber: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
  transferType: TransferRecipientType;
  wireDescription?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type Recipients = {
  __typename?: 'Recipients';
  recipients?: Maybe<Array<Maybe<Recipient>>>;
};

export type RefreshBalanceInput = {
  accountId?: InputMaybe<Scalars['String']>;
  accountIdList?: InputMaybe<Array<Scalars['String']>>;
};

export type RemoveOwnersToCheckingAccountInput = {
  accountId: Scalars['String'];
  userId: Scalars['String'];
};

export type RepaymentAccount = Account | ConnectedAccount;

export type ReplaceCardInput = {
  cardId: Scalars['String'];
  shippingAddress?: InputMaybe<CounterpartyAddressInput>;
};

export type ReportCardLostInput = {
  cardId: Scalars['String'];
};

export type ReportCardStolenInput = {
  cardId: Scalars['String'];
};

export type RevokeOrgUserInput = {
  userId: Scalars['String'];
};

export enum Role {
  Admin = 'Admin',
  Anon = 'Anon',
  Auditor = 'Auditor',
  Frozen = 'Frozen',
  Invited = 'Invited',
  Member = 'Member',
  Onboarding = 'Onboarding',
  Owner = 'Owner',
  Readonly = 'Readonly',
  Superadmin = 'Superadmin'
}

export type Session = {
  __typename?: 'Session';
  mfaEnabled?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['String']>;
  session?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export enum SpendTimeframe {
  ThisMonth = 'ThisMonth',
  Today = 'Today'
}

export enum SpendType {
  Credit = 'Credit',
  Debit = 'Debit'
}

export type Statement = {
  __typename?: 'Statement';
  month?: Maybe<Scalars['String']>;
  statementId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type StatementPdf = {
  __typename?: 'StatementPDF';
  url?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  completedPayments?: Maybe<Array<Maybe<SubscriptionPaymentInput>>>;
  failedPaymentDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inDefaultCriticalDate?: Maybe<Scalars['String']>;
  inDefaultReason?: Maybe<SubscriptionInDefaultReason>;
  inDefaultStage?: Maybe<SubscriptionInDefaultStage>;
  lastPaymentOn?: Maybe<Scalars['String']>;
  latePayments?: Maybe<Array<Maybe<SubscriptionPaymentInput>>>;
  nextPaymentDate?: Maybe<Scalars['String']>;
  nextPaymentOn?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  outstandingPayments?: Maybe<Array<Maybe<SubscriptionPaymentInput>>>;
  paymentFrequency?: Maybe<Scalars['Int']>;
  paymentInterval: PaymentInterval;
  paymentsBeginOn?: Maybe<Scalars['String']>;
  status: SubscriptionStatus;
  subscriptionId: Scalars['String'];
  subscriptionType: SubscriptionType;
};

export enum SubscriptionInDefaultReason {
  LatePayment = 'LatePayment',
  NoInsurance = 'NoInsurance',
  None = 'None'
}

export enum SubscriptionInDefaultStage {
  AllGood = 'AllGood',
  Final = 'Final',
  GracePeriod = 'GracePeriod',
  Initial = 'Initial'
}

export type SubscriptionPaymentInput = {
  __typename?: 'SubscriptionPaymentInput';
  amount: Money;
  description: Scalars['String'];
  direction: PaymentDirection;
  id: Scalars['ID'];
  initiated?: Maybe<Scalars['Boolean']>;
  lastAttemptedDate?: Maybe<Scalars['String']>;
  numberOfAttempts?: Maybe<Scalars['Int']>;
  paymentId?: Maybe<Scalars['String']>;
  paymentInitiatedId?: Maybe<Scalars['String']>;
  paymentInstalmentDate?: Maybe<Scalars['String']>;
  paymentInstalmentMonthDate?: Maybe<Scalars['String']>;
  paymentInstalmentPaidDate?: Maybe<Scalars['String']>;
  repaymentType: SubscriptionRepaymentType;
  sourceAccountId: Scalars['String'];
  subscriptionId: Scalars['String'];
  targetAccountId: Scalars['String'];
  targetAccountType: TargetAccountType;
};

export enum SubscriptionRepaymentType {
  Interest = 'Interest',
  LateFee = 'LateFee',
  Loan = 'Loan',
  RepaymentFee = 'RepaymentFee',
  SubscriptionTypeFee = 'SubscriptionTypeFee'
}

export enum SubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Late = 'Late',
  Paused = 'Paused'
}

export enum SubscriptionType {
  CryptoBuy = 'CryptoBuy',
  CryptoSell = 'CryptoSell',
  OneLine = 'OneLine',
  PremiumAccount = 'PremiumAccount'
}

export enum TargetAccountType {
  Account = 'Account',
  ConnectedAccount = 'ConnectedAccount',
  Recipient = 'Recipient'
}

export type TokenResult = {
  __typename?: 'TokenResult';
  token: Scalars['String'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Money;
  authorizationId?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  externalTransactionId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  merchantDescription?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  paymentId?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<EntityType>;
  spendType?: Maybe<SpendType>;
  status?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  targetType?: Maybe<EntityType>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate: Scalars['String'];
  transactionOriginator?: Maybe<AccountType>;
  transactionType?: Maybe<Scalars['String']>;
};

export type TransactionFilterInput = {
  endDate?: InputMaybe<Scalars['String']>;
  lastSeenID?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type TransactionListWithPaging = {
  __typename?: 'TransactionListWithPaging';
  items: Array<Transaction>;
  paging?: Maybe<Paging>;
};

export type TransferBetweenAccountsInput = {
  amount: Scalars['Float'];
  sourceAccountId: Scalars['String'];
  targetAccountId: Scalars['String'];
};

export type TransferBetweenCardsInput = {
  amount: Scalars['Float'];
  sourceCardId: Scalars['String'];
  targetCardId: Scalars['String'];
};

export enum TransferRecipientType {
  Ach = 'Ach',
  Wire = 'Wire'
}

export type UnfreezeCardInput = {
  cardId: Scalars['String'];
};

export enum UnitAchDirection {
  Credit = 'Credit',
  Debit = 'Debit'
}

export type UpcomingAuction = {
  __typename?: 'UpcomingAuction';
  auctionHouse?: Maybe<Scalars['String']>;
  cutOffDate?: Maybe<Scalars['String']>;
  date: DateRange;
  description?: Maybe<Scalars['String']>;
  location: Scalars['String'];
};

export type UpcomingAuctionInput = {
  date: AuctionDate;
  location: Scalars['String'];
};

export type UpdateOrganizationInput = {
  businessPhoneNumber?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  legalStructure?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  orgType: OrganizationType;
  state?: InputMaybe<Scalars['String']>;
  stateOfIncorporation?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxStatus?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  DOB?: Maybe<Scalars['String']>;
  SSN?: Maybe<Scalars['String']>;
  accounts: Array<Account>;
  accredited?: Maybe<Scalars['Boolean']>;
  accreditedOn?: Maybe<Scalars['String']>;
  accreditedVia?: Maybe<AccreditationMethod>;
  approved?: Maybe<Scalars['Boolean']>;
  cardIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cardIdsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  cards: Array<Card>;
  checks: Array<UserCheck>;
  city?: Maybe<Scalars['String']>;
  closed: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Date']>;
  creationStatus?: Maybe<UserCreationStatus>;
  creditCheck?: Maybe<CheckStatus>;
  deviceToken?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  fromPartnership?: Maybe<Scalars['Boolean']>;
  hasDeposited?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idVerifications?: Maybe<Array<Maybe<UserIdVerification>>>;
  internallyApproved?: Maybe<Scalars['Boolean']>;
  inviteCode?: Maybe<Scalars['String']>;
  isAccountOwner?: Maybe<Scalars['Boolean']>;
  isLetterEmployee?: Maybe<Scalars['Boolean']>;
  isThisMe?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  locked?: Maybe<Scalars['Boolean']>;
  netWorth?: Maybe<Scalars['String']>;
  notifications: NotificationSettings;
  onboarded?: Maybe<Scalars['Boolean']>;
  orgRole: Role;
  organizations: Array<Organization>;
  partnershipType?: Maybe<PartnershipType>;
  password?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  plan?: Maybe<UserPlan>;
  queue?: Maybe<Scalars['Boolean']>;
  referralCode?: Maybe<Scalars['String']>;
  referringUserId?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<UserStatus>;
  streetAddress?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  verified: VerifiedStatus;
  zip?: Maybe<Scalars['String']>;
};

export type UserAddCardInput = {
  cardId: Scalars['String'];
};

export type UserAndOrgIds = {
  __typename?: 'UserAndOrgIds';
  organizationId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserCardsBalance = {
  __typename?: 'UserCardsBalance';
  balance?: Maybe<Scalars['Int']>;
};

export type UserChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type UserCheck = {
  __typename?: 'UserCheck';
  comments?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: UserCheckStatus;
  type?: Maybe<UserCheckType>;
};

export enum UserCheckStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  Problem = 'Problem',
  Processing = 'Processing'
}

export enum UserCheckType {
  Bank = 'Bank',
  Face = 'Face',
  Id = 'Id'
}

export enum UserCreationStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Proto = 'Proto'
}

export type UserEditDeviceTokenInput = {
  deviceToken?: InputMaybe<Scalars['String']>;
};

export type UserEditInput = {
  city?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  netWorth?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  zip?: InputMaybe<Scalars['String']>;
};

export type UserEditNotificationSettingsInput = {
  receivePush?: InputMaybe<Scalars['Boolean']>;
  receiveSms?: InputMaybe<Scalars['Boolean']>;
};

export type UserIdVerification = {
  __typename?: 'UserIdVerification';
  idVerificationName?: Maybe<UserIdVerificationName>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  verificationImage?: Maybe<Scalars['String']>;
};

export enum UserIdVerificationName {
  AddressVerification = 'AddressVerification',
  CertificateOfIncorporation = 'CertificateOfIncorporation',
  DrivingLicenseBack = 'DrivingLicenseBack',
  DrivingLicenseFront = 'DrivingLicenseFront',
  EinConfirmation = 'EinConfirmation',
  FacePhoto = 'FacePhoto',
  Passport = 'Passport',
  PowerOfAttorney = 'PowerOfAttorney',
  SocialSecurityCard = 'SocialSecurityCard'
}

export type UserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  inviteCode?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  netWorth?: InputMaybe<Scalars['String']>;
  partnershipType?: InputMaybe<PartnershipType>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  referralCode?: InputMaybe<Scalars['String']>;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  frozen?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isBeneficialOwner?: Maybe<Scalars['Boolean']>;
  isPrimaryOfficer?: Maybe<Scalars['Boolean']>;
  permissionLevel?: Maybe<PermissionLevel>;
  title?: Maybe<Scalars['String']>;
};

export type UserPersonalInformationInput = {
  DOB: Scalars['String'];
  SSN: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  streetAddress: Scalars['String'];
  userId: Scalars['ID'];
  zip: Scalars['String'];
};

export enum UserPlan {
  Basic = 'Basic',
  Premium = 'Premium'
}

export type UserRemoveCardInput = {
  cardId: Scalars['String'];
};

export type UserRequestPasswordResetInput = {
  email: Scalars['String'];
};

export type UserResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export type UserTriggerVerification = {
  type?: InputMaybe<UserVerificationType>;
};

export type UserVerificationInput = {
  idVerificationName?: InputMaybe<UserIdVerificationName>;
  organizationId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  verificationImage?: InputMaybe<Scalars['Upload']>;
  verificationType?: InputMaybe<UserVerificationType>;
};

export enum UserVerificationType {
  Email = 'Email',
  Face = 'Face',
  Id = 'Id',
  Mfa = 'Mfa',
  Phone = 'Phone',
  Survey = 'Survey',
  Wealth = 'Wealth'
}

export type UserWaitlistEmailInput = {
  email: Scalars['String'];
};

export type ValidResult = {
  __typename?: 'ValidResult';
  valid: Scalars['Boolean'];
};

export type ValidateTokenInput = {
  token: Scalars['String'];
};

export type VerifiedStatus = {
  __typename?: 'VerifiedStatus';
  _userId?: Maybe<Scalars['String']>;
  email: Scalars['Boolean'];
  face?: Maybe<Scalars['Boolean']>;
  id: Scalars['Boolean'];
  mfa?: Maybe<Scalars['Boolean']>;
  phone: Scalars['Boolean'];
  survey: Scalars['Boolean'];
  wealth: Scalars['Boolean'];
};

export type VerifyMultiFactorInput = {
  token: Scalars['String'];
};

export type WeeklyActivity = {
  __typename?: 'WeeklyActivity';
  activity?: Maybe<Array<Maybe<WeeklyActivityDay>>>;
  currentDay: Scalars['Int'];
};

export type WeeklyActivityDay = {
  __typename?: 'WeeklyActivityDay';
  day: Scalars['Int'];
  spendAmount: Money;
};

export type ZaboAccountInput = {
  balances?: InputMaybe<Array<InputMaybe<ZaboBalanceInput>>>;
  blockchain?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['Int'];
  id: Scalars['ID'];
  provider?: InputMaybe<ZaboProviderInput>;
  resourceType: Scalars['String'];
  updatedAt: Scalars['Int'];
};

export type ZaboBalance = {
  __typename?: 'ZaboBalance';
  amount: Scalars['String'];
  assetIsVerified: Scalars['Boolean'];
  assetType: Scalars['String'];
  decimals: Scalars['Float'];
  fiatAssetIsVerified: Scalars['Boolean'];
  fiatTicker: Scalars['String'];
  fiatValue: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  providerTicker: Scalars['String'];
  resourceType: Scalars['String'];
  ticker: Scalars['String'];
  updatedAt: Scalars['Int'];
};

export type ZaboBalanceInput = {
  amount: Scalars['String'];
  assetIsVerified: Scalars['Boolean'];
  assetType: Scalars['String'];
  decimals: Scalars['Float'];
  fiatAssetIsVerified: Scalars['Boolean'];
  fiatTicker: Scalars['String'];
  fiatValue: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  providerTicker: Scalars['String'];
  resourceType: Scalars['String'];
  ticker: Scalars['String'];
  updatedAt: Scalars['Int'];
};

export type ZaboCryptoInput = {
  account: ZaboAccountInput;
  user?: InputMaybe<ZaboUserInput>;
};

export type ZaboPartialAccount = {
  __typename?: 'ZaboPartialAccount';
  blockchain: Scalars['String'];
  id: Scalars['ID'];
  lastConnected: Scalars['Int'];
  provider?: Maybe<ZaboProvider>;
};

export type ZaboPartialAccountInput = {
  blockchain: Scalars['String'];
  id: Scalars['ID'];
  lastConnected: Scalars['Int'];
  provider?: InputMaybe<ZaboProviderInput>;
};

export type ZaboProvider = {
  __typename?: 'ZaboProvider';
  currencies?: Maybe<Array<Maybe<CurrencyList>>>;
  displayName: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  resourceType: Scalars['String'];
  scopes?: Maybe<Array<ProviderScope>>;
};

export type ZaboProviderInput = {
  currencies?: InputMaybe<Array<InputMaybe<CurrencyListInput>>>;
  displayName: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  resourceType: Scalars['String'];
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ZaboUser = {
  __typename?: 'ZaboUser';
  accounts?: Maybe<Array<Maybe<ZaboPartialAccount>>>;
  createdAt: Scalars['Int'];
  id: Scalars['ID'];
  resourceType: Scalars['String'];
  updatedAt: Scalars['Int'];
};

export type ZaboUserInput = {
  accounts?: InputMaybe<Array<InputMaybe<ZaboPartialAccountInput>>>;
  createdAt: Scalars['Int'];
  id: Scalars['ID'];
  resourceType: Scalars['String'];
  updatedAt: Scalars['Int'];
};

export type OpenCheckingAccountMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type OpenCheckingAccountMutation = { __typename?: 'Mutation', openCheckingAccount?: { __typename?: 'Account', id: string, externalAccountNumber: string, nickname?: string, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', display: string, amount: number } } };

export type CloseCheckingAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type CloseCheckingAccountMutation = { __typename?: 'Mutation', closeCheckingAccount?: { __typename?: 'GenericResult', success: boolean } };

export type EditCheckingAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  name: Scalars['String'];
}>;


export type EditCheckingAccountMutation = { __typename?: 'Mutation', editCheckingAccount?: { __typename?: 'Account', id: string, nickname?: string } };

export type BankAccountsQueryVariables = Exact<{
  accountRef: Array<AccountRef> | AccountRef;
  selectedId?: InputMaybe<Scalars['String']>;
  timeframe?: InputMaybe<BalancesTimeframe>;
  groupBy?: InputMaybe<BalancesGrouping>;
}>;


export type BankAccountsQuery = { __typename?: 'Query', bankAccounts: { __typename?: 'BankAccounts', accounts?: Array<{ __typename?: 'Account', id: string, createdAt: any, externalAccountNumber: string, externalRoutingNumber: string, last4?: string, nickname?: string, organizationDefault: boolean, organizationId: string, selected?: boolean, accountType?: AccountType, balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }>, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', amount: number, display: string }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deposits: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, statements: Array<{ __typename?: 'Statement', statementId?: string, month?: string, year?: string }>, owners: Array<{ __typename?: 'User', id: string, isAccountOwner?: boolean, firstName: string, lastName: string, status?: UserStatus, email: string }> }> } };

export type BankAccountByIdQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type BankAccountByIdQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, createdAt: any, externalAccountNumber: string, externalRoutingNumber: string, last4?: string, nickname?: string, organizationDefault: boolean, organizationId: string, selected?: boolean, accountType?: AccountType, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', amount: number, display: string }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deposits: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, statements: Array<{ __typename?: 'Statement', statementId?: string, month?: string, year?: string }>, owners: Array<{ __typename?: 'User', id: string, isAccountOwner?: boolean, firstName: string, lastName: string, status?: UserStatus, email: string }> } };

export type BankAccountBalancesByIdQueryVariables = Exact<{
  accountId: Scalars['String'];
  timeframe: BalancesTimeframe;
}>;


export type BankAccountBalancesByIdQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }> } };

export type BankAccountTransactionsByIdQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type BankAccountTransactionsByIdQuery = { __typename?: 'Query', transactionsByAccountId: { __typename?: 'TransactionListWithPaging', items: Array<{ __typename?: 'Transaction', id: string, transactionType?: string, sourceId?: string, targetId?: string, entityId?: string, transactionDate: string, merchantDescription?: string, spendType?: SpendType, entityType?: EntityType, sourceType?: EntityType, targetType?: EntityType, organizationId?: string, createdAt: any, status?: string, amount: { __typename?: 'Money', amount: number, display: string } }> } };

export type BankAccountStatementQueryVariables = Exact<{
  statementId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type BankAccountStatementQuery = { __typename?: 'Query', statement?: { __typename?: 'StatementPDF', url?: string } };

export type BankAccountOwnersQueryVariables = Exact<{
  accountId: Scalars['String'];
  selectedId: Scalars['String'];
}>;


export type BankAccountOwnersQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: string, owners: Array<{ __typename?: 'User', id: string, isAccountOwner?: boolean, firstName: string, lastName: string, selected?: boolean, isThisMe?: boolean }> } };

export type AddOwnersToCheckingAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type AddOwnersToCheckingAccountMutation = { __typename?: 'Mutation', addOwnersToCheckingAccount?: { __typename?: 'Account', id: string, createdAt: any, externalAccountNumber: string, externalRoutingNumber: string, last4?: string, nickname?: string, organizationDefault: boolean, organizationId: string, selected?: boolean, accountType?: AccountType, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', amount: number, display: string }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deposits: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, statements: Array<{ __typename?: 'Statement', statementId?: string, month?: string, year?: string }>, owners: Array<{ __typename?: 'User', id: string, isAccountOwner?: boolean, firstName: string, lastName: string, status?: UserStatus, email: string }> } };

export type RemoveOwnersFromCheckingAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type RemoveOwnersFromCheckingAccountMutation = { __typename?: 'Mutation', removeOwnersFromCheckingAccount?: { __typename?: 'GenericResult', success: boolean } };

export type AlertsQueryVariables = Exact<{ [key: string]: never; }>;


export type AlertsQuery = { __typename?: 'Query', alerts: { __typename?: 'Alerts', alerts?: Array<{ __typename?: 'Alert', id: string, meta?: string, alertType?: AlertType, createdAt?: string }> } };

export type AddEmailToWaitlistMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AddEmailToWaitlistMutation = { __typename?: 'Mutation', addEmailToWaitlist?: { __typename?: 'GenericResult', success: boolean } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  inviteCode?: InputMaybe<Scalars['String']>;
  recaptchaScore?: InputMaybe<Scalars['Float']>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Session', session?: string, mfaEnabled?: boolean, organizationId?: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'GenericResult', success: boolean } };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'GenericResult', success: boolean } };

export type GenerateMultiFactorMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateMultiFactorMutation = { __typename?: 'Mutation', generateMultiFactor?: { __typename?: 'MultiFactor', secret: string, uri: string, qr: string } };

export type VerifyMultiFactorMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyMultiFactorMutation = { __typename?: 'Mutation', verifyMultiFactor: { __typename?: 'Session', session?: string, mfaEnabled?: boolean, organizationId?: string } };

export type ValidSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type ValidSessionQuery = { __typename?: 'Query', validSession: { __typename?: 'GenericResult', success: boolean } };

export type RespondToImpersonationRequestMutationVariables = Exact<{
  id: Scalars['String'];
  allow: Scalars['Boolean'];
}>;


export type RespondToImpersonationRequestMutation = { __typename?: 'Mutation', respondToImpersonationRequest?: { __typename?: 'GenericResult', success: boolean } };

export type RecaptchaSiteVerifyMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type RecaptchaSiteVerifyMutation = { __typename?: 'Mutation', recaptchaSiteVerify?: { __typename?: 'Recaptcha', success: boolean, score?: number, errorCodesList?: Array<string> } };

export type CreateOnfidoApplicationMutationVariables = Exact<{
  input: OnfidoApplicationInput;
}>;


export type CreateOnfidoApplicationMutation = { __typename?: 'Mutation', createOnfidoApplication?: { __typename?: 'OnfidoApplication', sdkToken?: string, applicantId?: string } };

export type CreateOnfidoCheckMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateOnfidoCheckMutation = { __typename?: 'Mutation', createOnfidoCheck?: { __typename?: 'GenericResult', success: boolean } };

export type CreateCardMutationVariables = Exact<{
  accountId: Scalars['String'];
  limit: Scalars['Float'];
  role: Role;
  cardHolderFirstName: Scalars['String'];
  cardHolderLastName: Scalars['String'];
  cardHolderUserId: Scalars['String'];
  cardHolderEmail: Scalars['String'];
  design: Scalars['String'];
  limitBehaviour?: InputMaybe<CardLimitBehaviourType>;
  type?: InputMaybe<CardType>;
}>;


export type CreateCardMutation = { __typename?: 'Mutation', createCard?: { __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } } };

export type GetCardQueryVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type GetCardQuery = { __typename?: 'Query', card: { __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } } };

export type UpdateCardLimitMutationVariables = Exact<{
  cardId: Scalars['String'];
  limit: Scalars['Float'];
  limitBehaviour: CardLimitBehaviourType;
  limitEnabled: Scalars['Boolean'];
}>;


export type UpdateCardLimitMutation = { __typename?: 'Mutation', changeCardLimit?: { __typename?: 'Card', id: string, status: CardStatusType, last4?: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, expiryDate?: string, externalCardId: string, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } } };

export type WeeklyCardActivityQueryVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type WeeklyCardActivityQuery = { __typename?: 'Query', weeklyActivityByAccountId: { __typename?: 'WeeklyActivity', currentDay: number, activity?: Array<{ __typename?: 'WeeklyActivityDay', day: number, spendAmount: { __typename?: 'Money', amount: number, display: string } }> } };

export type CardTransactionsQueryVariables = Exact<{
  accountId: Scalars['String'];
  cardId: Scalars['String'];
}>;


export type CardTransactionsQuery = { __typename?: 'Query', transactionsByAccountId: { __typename?: 'TransactionListWithPaging', items: Array<{ __typename?: 'Transaction', id: string, transactionType?: string, sourceId?: string, targetId?: string, entityId?: string, transactionDate: string, merchantDescription?: string, spendType?: SpendType, entityType?: EntityType, sourceType?: EntityType, targetType?: EntityType, organizationId?: string, createdAt: any, status?: string, amount: { __typename?: 'Money', amount: number, display: string } }> } };

export type CreateCardSesssionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCardSesssionMutation = { __typename?: 'Mutation', createCardSession?: { __typename?: 'CardSession', challenge?: boolean } };

export type CompleteCardSesssionMutationVariables = Exact<{
  code: Scalars['String'];
  cardId: Scalars['String'];
}>;


export type CompleteCardSesssionMutation = { __typename?: 'Mutation', completeCardSession?: { __typename?: 'CardSession', token?: string, externalCardId?: string } };

export type FreezeCardMutationVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type FreezeCardMutation = { __typename?: 'Mutation', freezeCard?: { __typename?: 'Card', id: string, status: CardStatusType } };

export type UnfreezeCardMutationVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type UnfreezeCardMutation = { __typename?: 'Mutation', unfreezeCard?: { __typename?: 'Card', id: string, status: CardStatusType } };

export type CloseCardMutationVariables = Exact<{
  cardId: Scalars['String'];
}>;


export type CloseCardMutation = { __typename?: 'Mutation', closeCard?: { __typename?: 'Card', id: string, status: CardStatusType, last4?: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, expiryDate?: string, externalCardId: string, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } } };

export type ConnectConnectedAccountProviderMutationVariables = Exact<{
  input: ConnectedAccountConnectInput;
}>;


export type ConnectConnectedAccountProviderMutation = { __typename?: 'Mutation', connectConnectedAccountProvider?: { __typename?: 'ProviderConnectResult', expectedNewAccountsNumber: number, expectedNewAccountsData?: Array<{ __typename?: 'ConnectedAccount', id: string, type: string, subType?: string, organizationId: string, userId: string, accountNumber?: string, routingNumber?: string, last4?: string, providerAccountId: string, providerEnrollmentId?: string, connectedInstitutionName?: string, connectedInstitutionLogo?: string, connectedInstitutionId?: string, provider: ConnectedAccountProvider, nickname?: string, name?: string, status?: ConnectedAccountStatus, updatedAt?: string, createdAt?: string, selected?: boolean, availableBalance: { __typename?: 'Money', display: string, amount: number }, totalBalance: { __typename?: 'Money', display: string, amount: number } }> } };

export type GetConnectedTokenMutationVariables = Exact<{
  input: ProviderTokenInput;
}>;


export type GetConnectedTokenMutation = { __typename?: 'Mutation', getConnectedToken?: { __typename?: 'TokenResult', token: string } };

export type RefreshConnectedAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type RefreshConnectedAccountMutation = { __typename?: 'Mutation', refreshConnectedAccount?: { __typename?: 'ConnectedAccount', nickname?: string, type: string, last4?: string, id: string, accountNumber?: string, routingNumber?: string, status?: ConnectedAccountStatus, providerEnrollmentId?: string, updatedAt?: string, balance: { __typename?: 'Money', display: string, amount: number } } };

export type RefreshConnectedAccountsMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshConnectedAccountsMutation = { __typename?: 'Mutation', refreshConnectedAccounts?: { __typename?: 'GenericResult', success: boolean } };

export type ConnectedUpdateTokenQueryVariables = Exact<{
  enrollmentId: Scalars['String'];
}>;


export type ConnectedUpdateTokenQuery = { __typename?: 'Query', connectedUpdateToken?: { __typename?: 'TokenResult', token: string } };

export type EditConnectedAccountMutationVariables = Exact<{
  accountId: Scalars['String'];
  nickname: Scalars['String'];
}>;


export type EditConnectedAccountMutation = { __typename?: 'Mutation', editConnectedAccount?: { __typename?: 'ConnectedAccount', nickname?: string } };

export type DisconnectConnectedAccountMutationVariables = Exact<{
  input: DisconnectConnectedAccountInput;
}>;


export type DisconnectConnectedAccountMutation = { __typename?: 'Mutation', disconnectConnectedAccount?: { __typename?: 'GenericResult', success: boolean } };

export type ConnectedAccountsListQueryVariables = Exact<{
  timeframe?: InputMaybe<BalancesTimeframe>;
  groupBy?: InputMaybe<BalancesGrouping>;
  moveMoneyCapable?: InputMaybe<Scalars['Boolean']>;
  selectedId?: InputMaybe<Scalars['String']>;
}>;


export type ConnectedAccountsListQuery = { __typename?: 'Query', connectedAccountsList: { __typename?: 'ConnectedAccountsList', connectedAccounts?: Array<{ __typename?: 'ConnectedAccount', id: string, type: string, subType?: string, organizationId: string, userId: string, accountNumber?: string, routingNumber?: string, last4?: string, providerAccountId: string, providerEnrollmentId?: string, connectedInstitutionName?: string, connectedInstitutionLogo?: string, connectedInstitutionId?: string, provider: ConnectedAccountProvider, nickname?: string, name?: string, status?: ConnectedAccountStatus, updatedAt?: string, createdAt?: string, selected?: boolean, availableBalance: { __typename?: 'Money', display: string, amount: number }, totalBalance: { __typename?: 'Money', display: string, amount: number }, balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }> }>, flaggedEnrollmentsList?: Array<{ __typename?: 'FlaggedEnrollment', error?: string, consentExpirationTime?: string, updateType?: string, transactions?: string }> } };

export type ConnectedAccountBalancesQueryVariables = Exact<{
  accountId: Scalars['String'];
  timeframe?: InputMaybe<BalancesTimeframe>;
  groupBy?: InputMaybe<BalancesGrouping>;
}>;


export type ConnectedAccountBalancesQuery = { __typename?: 'Query', connectedAccount: { __typename?: 'ConnectedAccount', balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }> } };

export type ConnectedAccountQueryVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type ConnectedAccountQuery = { __typename?: 'Query', connectedAccount: { __typename?: 'ConnectedAccount', id: string, type: string, subType?: string, organizationId: string, userId: string, accountNumber?: string, routingNumber?: string, last4?: string, providerAccountId: string, providerEnrollmentId?: string, connectedInstitutionName?: string, connectedInstitutionLogo?: string, connectedInstitutionId?: string, provider: ConnectedAccountProvider, nickname?: string, name?: string, status?: ConnectedAccountStatus, updatedAt?: string, createdAt?: string, selected?: boolean, availableBalance: { __typename?: 'Money', display: string, amount: number }, totalBalance: { __typename?: 'Money', display: string, amount: number } } };

export type DealsQueryVariables = Exact<{ [key: string]: never; }>;


export type DealsQuery = { __typename?: 'Query', deals: { __typename?: 'Deals', deals?: Array<{ __typename?: 'Deal', id: string, name: string, createdAt: any, termLength: string, caption?: string, description?: string, details?: string, closeDate: string, infoLink: string, listingType?: DealListingType, distributions?: string, logoImage?: string, headerImage?: string, discount?: { __typename?: 'Percentage', amount: number, display: string }, committedAmountSold?: { __typename?: 'Money', amount: number, display: string }, committedAmountBought?: { __typename?: 'Money', amount: number, display: string }, transactionAmountSold?: { __typename?: 'Money', amount: number, display: string }, transactionAmountBought?: { __typename?: 'Money', amount: number, display: string }, targetAmount: { __typename?: 'Money', amount: number, display: string }, minInvestment: { __typename?: 'Money', amount: number, display: string }, targetedTotalReturn: { __typename?: 'Money', amount: number, display: string }, letterFee?: { __typename?: 'Money', amount: number, display: string } }> } };

export type CommitToDealMutationVariables = Exact<{
  dealId: Scalars['String'];
  fundingAccountId: Scalars['String'];
  committedAmount: Scalars['Float'];
  executionDirection?: InputMaybe<DealExecutionDirection>;
  numberOfShares?: InputMaybe<Scalars['Float']>;
}>;


export type CommitToDealMutation = { __typename?: 'Mutation', commitToDeal?: { __typename?: 'GenericResult', success: boolean } };

export type UpdateDealCommitmentMutationVariables = Exact<{
  dealId: Scalars['String'];
  fundingAccountId: Scalars['String'];
  committedAmount: Scalars['Float'];
  dealCommitmentId?: InputMaybe<Scalars['String']>;
  dealInvestorId?: InputMaybe<Scalars['String']>;
  numberOfShares?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateDealCommitmentMutation = { __typename?: 'Mutation', updateDealCommitment?: { __typename?: 'GenericResult', success: boolean } };

export type DeleteDealCommitmentMutationVariables = Exact<{
  dealId: Scalars['String'];
  dealCommitmentId?: InputMaybe<Scalars['String']>;
  dealInvestorId?: InputMaybe<Scalars['String']>;
}>;


export type DeleteDealCommitmentMutation = { __typename?: 'Mutation', deleteDealCommitment?: { __typename?: 'GenericResult', success: boolean } };

export type CreateDepositMutationVariables = Exact<{
  input: CreateDepositInput;
}>;


export type CreateDepositMutation = { __typename?: 'Mutation', createDeposit?: { __typename?: 'DepositResult', id: string, description: string, amount: { __typename?: 'Money', amount: number, display: string } } };

export type CardDataFragment = { __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } };

export type LineTypeDataFragment = { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } };

export type LinePaymentScheduleDataFragment = { __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } };

export type LineMinDataFragment = { __typename?: 'Line', id: string, createdAt: string, finalized?: boolean, originationStatus: LineOriginationStatus, status: LineStatus, loanAmount: { __typename?: 'Money', display: string, amount: number }, lineType: { __typename?: 'LineType', id: string, title: string } };

export type LineDataFragment = { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } };

export type OneLineDataFragment = { __typename?: 'OneLine', availableToUnderwrite: boolean, eligibleForQualification: boolean, repaymentAccountId?: string, repaymentAccountType?: TargetAccountType, underwritingReviewStatus?: CheckStatus, lines: Array<{ __typename?: 'Line', id: string, createdAt: string, finalized?: boolean, originationStatus: LineOriginationStatus, status: LineStatus, loanAmount: { __typename?: 'Money', display: string, amount: number }, lineType: { __typename?: 'LineType', id: string, title: string } }>, totals: { __typename?: 'LineTotals', approxPayOffDate: string, monthsRemaining: number, monthsTotal: number, openLines: number, availableToBorrow: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, totalAmountBorrowed: { __typename?: 'Money', display: string, amount: number }, totalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, totalMonthlyPayment: { __typename?: 'Money', display: string, amount: number } }, eligibilityQualificationAmount: { __typename?: 'Money', display: string, amount: number }, repaymentAccount?: { __typename?: 'Account', nickname?: string, last4?: string } | { __typename?: 'ConnectedAccount', nickname?: string, last4?: string }, repaymentFeePercent?: { __typename?: 'Money', display: string, amount: number } };

export type OrgMinDataFragment = { __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType };

export type OrgDataFragment = { __typename?: 'Organization', ownerUserIds?: Array<string>, legalStructure?: string, taxId?: string, taxStatus?: string, category?: string, stateOfIncorporation?: string, businessPhoneNumber?: string, streetAddress?: string, city?: string, state?: string, zip?: string, session?: string, role: Role, accredited?: boolean, creditCheck?: CheckStatus, id: string, currentContext: boolean, name?: string, orgType: OrgType, accountHolder?: { __typename?: 'AccountHolder', name: string, address: { __typename?: 'CounterpartyAddress', street?: string, city?: string, state?: string, postalCode?: string, country?: string } }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deals: Array<{ __typename?: 'DealInvestor', id: string, fundingAccountId?: string, committedAmount?: { __typename?: 'Money', display: string, amount: number }, commitments?: Array<{ __typename?: 'DealCommitment', dealInvestorId: string, dealId: string, id: string, numberOfShares?: number }> }>, oneLine: { __typename?: 'OneLine', availableToUnderwrite: boolean, eligibleForQualification: boolean, repaymentAccountId?: string, repaymentAccountType?: TargetAccountType, underwritingReviewStatus?: CheckStatus, lines: Array<{ __typename?: 'Line', id: string, createdAt: string, finalized?: boolean, originationStatus: LineOriginationStatus, status: LineStatus, loanAmount: { __typename?: 'Money', display: string, amount: number }, lineType: { __typename?: 'LineType', id: string, title: string } }>, totals: { __typename?: 'LineTotals', approxPayOffDate: string, monthsRemaining: number, monthsTotal: number, openLines: number, availableToBorrow: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, totalAmountBorrowed: { __typename?: 'Money', display: string, amount: number }, totalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, totalMonthlyPayment: { __typename?: 'Money', display: string, amount: number } }, eligibilityQualificationAmount: { __typename?: 'Money', display: string, amount: number }, repaymentAccount?: { __typename?: 'Account', nickname?: string, last4?: string } | { __typename?: 'ConnectedAccount', nickname?: string, last4?: string }, repaymentFeePercent?: { __typename?: 'Money', display: string, amount: number } }, oneLineAvailableToBorrow?: { __typename?: 'Money', display: string, amount: number } };

export type BusinessDataFragment = { __typename?: 'Organization', id: string, ownerUserIds?: Array<string>, orgType: OrgType, name?: string, legalStructure?: string, taxId?: string, taxStatus?: string, category?: string, stateOfIncorporation?: string, businessPhoneNumber?: string, streetAddress?: string, city?: string, state?: string, zip?: string, session?: string, currentContext: boolean };

export type OwnerDataFragment = { __typename?: 'Organization', beneficialOwners?: Array<{ __typename?: 'BeneficialOwner', id: string, firstName: string, lastName: string, phone: string, dob?: string, ownershipPercentage: string, ssn?: string, email: string, streetAddress?: string, city?: string, state?: string, zip?: string, title: string, createdAt?: any, primaryContact?: boolean, primaryOfficer?: boolean }> };

export type UserDataFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } };

export type CreatedUserDataFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, netWorth?: string, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean } };

export type TranxDataFragment = { __typename?: 'Transaction', id: string, sourceId?: string, targetId?: string, sourceType?: EntityType, targetType?: EntityType, organizationId?: string, merchantDescription?: string, createdAt: any, amount: { __typename?: 'Money', display: string, amount: number } };

export type FullAccountDataFragment = { __typename?: 'Account', id: string, createdAt: any, externalAccountNumber: string, externalRoutingNumber: string, last4?: string, nickname?: string, organizationDefault: boolean, organizationId: string, selected?: boolean, accountType?: AccountType, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', amount: number, display: string }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deposits: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, statements: Array<{ __typename?: 'Statement', statementId?: string, month?: string, year?: string }>, owners: Array<{ __typename?: 'User', id: string, isAccountOwner?: boolean, firstName: string, lastName: string, status?: UserStatus, email: string }> };

export type FullBankAccountDataFragment = { __typename?: 'BankAccounts', accounts?: Array<{ __typename?: 'Account', id: string, createdAt: any, externalAccountNumber: string, externalRoutingNumber: string, last4?: string, nickname?: string, organizationDefault: boolean, organizationId: string, selected?: boolean, accountType?: AccountType, balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }>, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', amount: number, display: string }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deposits: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, statements: Array<{ __typename?: 'Statement', statementId?: string, month?: string, year?: string }>, owners: Array<{ __typename?: 'User', id: string, isAccountOwner?: boolean, firstName: string, lastName: string, status?: UserStatus, email: string }> }> };

export type AccountActivityFragmentFragment = { __typename?: 'WeeklyActivity', currentDay: number, activity?: Array<{ __typename?: 'WeeklyActivityDay', day: number, spendAmount: { __typename?: 'Money', amount: number, display: string } }> };

export type FullTransactionAccountDataFragment = { __typename?: 'TransactionListWithPaging', items: Array<{ __typename?: 'Transaction', id: string, transactionType?: string, sourceId?: string, targetId?: string, entityId?: string, transactionDate: string, merchantDescription?: string, spendType?: SpendType, entityType?: EntityType, sourceType?: EntityType, targetType?: EntityType, organizationId?: string, createdAt: any, status?: string, amount: { __typename?: 'Money', amount: number, display: string } }> };

export type FullTransactionDataFragment = { __typename?: 'TransactionListWithPaging', items: Array<{ __typename?: 'Transaction', id: string, transactionType?: string, sourceId?: string, targetId?: string, entityId?: string, transactionDate: string, merchantDescription?: string, spendType?: SpendType, entityType?: EntityType, sourceType?: EntityType, targetType?: EntityType, organizationId?: string, createdAt: any, status?: string, amount: { __typename?: 'Money', amount: number, display: string } }> };

export type FullConnectedAccountDataFragment = { __typename?: 'ConnectedAccount', id: string, type: string, subType?: string, organizationId: string, userId: string, accountNumber?: string, routingNumber?: string, last4?: string, providerAccountId: string, providerEnrollmentId?: string, connectedInstitutionName?: string, connectedInstitutionLogo?: string, connectedInstitutionId?: string, provider: ConnectedAccountProvider, nickname?: string, name?: string, status?: ConnectedAccountStatus, updatedAt?: string, createdAt?: string, selected?: boolean, availableBalance: { __typename?: 'Money', display: string, amount: number }, totalBalance: { __typename?: 'Money', display: string, amount: number }, balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }> };

export type LineAuctionDatesQueryVariables = Exact<{
  includePast?: InputMaybe<Scalars['Boolean']>;
}>;


export type LineAuctionDatesQuery = { __typename?: 'Query', lineAuctionDates: Array<{ __typename?: 'UpcomingAuction', auctionHouse?: string, cutOffDate?: string, description?: string, location: string, date: { __typename?: 'DateRange', start: string, end: string } }> };

export type LineTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineTypesQuery = { __typename?: 'Query', lineTypes: Array<{ __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }> };

export type LineTypeQueryVariables = Exact<{
  lineTypeId: Scalars['String'];
}>;


export type LineTypeQuery = { __typename?: 'Query', lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } } };

export type GetLineDocumentsQueryVariables = Exact<{
  lineId: Scalars['String'];
}>;


export type GetLineDocumentsQuery = { __typename?: 'Query', getLineDocuments?: { __typename?: 'LineDocumentPDFList', documents: Array<{ __typename?: 'LineDocumentPDF', url: string, name: string }> } };

export type GetLineQueryVariables = Exact<{
  lineId: Scalars['String'];
}>;


export type GetLineQuery = { __typename?: 'Query', line: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type AddEmailToLineAuctionWaitlistMutationVariables = Exact<{
  input: AddEmailToLineAuctionWaitlistInput;
}>;


export type AddEmailToLineAuctionWaitlistMutation = { __typename?: 'Mutation', addEmailToLineAuctionWaitlist?: { __typename?: 'GenericResult', success: boolean } };

export type RunCreditCheckMutationVariables = Exact<{ [key: string]: never; }>;


export type RunCreditCheckMutation = { __typename?: 'Mutation', runCreditCheck?: { __typename?: 'Organization', ownerUserIds?: Array<string>, legalStructure?: string, taxId?: string, taxStatus?: string, category?: string, stateOfIncorporation?: string, businessPhoneNumber?: string, streetAddress?: string, city?: string, state?: string, zip?: string, session?: string, role: Role, accredited?: boolean, creditCheck?: CheckStatus, id: string, currentContext: boolean, name?: string, orgType: OrgType, accountHolder?: { __typename?: 'AccountHolder', name: string, address: { __typename?: 'CounterpartyAddress', street?: string, city?: string, state?: string, postalCode?: string, country?: string } }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deals: Array<{ __typename?: 'DealInvestor', id: string, fundingAccountId?: string, committedAmount?: { __typename?: 'Money', display: string, amount: number }, commitments?: Array<{ __typename?: 'DealCommitment', dealInvestorId: string, dealId: string, id: string, numberOfShares?: number }> }>, oneLine: { __typename?: 'OneLine', availableToUnderwrite: boolean, eligibleForQualification: boolean, repaymentAccountId?: string, repaymentAccountType?: TargetAccountType, underwritingReviewStatus?: CheckStatus, lines: Array<{ __typename?: 'Line', id: string, createdAt: string, finalized?: boolean, originationStatus: LineOriginationStatus, status: LineStatus, loanAmount: { __typename?: 'Money', display: string, amount: number }, lineType: { __typename?: 'LineType', id: string, title: string } }>, totals: { __typename?: 'LineTotals', approxPayOffDate: string, monthsRemaining: number, monthsTotal: number, openLines: number, availableToBorrow: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, totalAmountBorrowed: { __typename?: 'Money', display: string, amount: number }, totalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, totalMonthlyPayment: { __typename?: 'Money', display: string, amount: number } }, eligibilityQualificationAmount: { __typename?: 'Money', display: string, amount: number }, repaymentAccount?: { __typename?: 'Account', nickname?: string, last4?: string } | { __typename?: 'ConnectedAccount', nickname?: string, last4?: string }, repaymentFeePercent?: { __typename?: 'Money', display: string, amount: number } }, oneLineAvailableToBorrow?: { __typename?: 'Money', display: string, amount: number } } };

export type CalculateLineTermsMutationVariables = Exact<{
  input: CalculateLineTermsInput;
}>;


export type CalculateLineTermsMutation = { __typename?: 'Mutation', calculateLineTerms?: { __typename?: 'LineTermsCalculation', downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number } } };

export type CreateLineMutationVariables = Exact<{
  input: CreateLineInput;
}>;


export type CreateLineMutation = { __typename?: 'Mutation', createLine?: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type UpdateAndResetLineMutationVariables = Exact<{
  lineId: Scalars['String'];
  input: CreateLineInput;
}>;


export type UpdateAndResetLineMutation = { __typename?: 'Mutation', updateAndResetLine?: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type CancelLineMutationVariables = Exact<{
  lineId: Scalars['String'];
}>;


export type CancelLineMutation = { __typename?: 'Mutation', cancelLine?: { __typename?: 'GenericResult', success: boolean } };

export type AcceptLineTermsMutationVariables = Exact<{
  lineId: Scalars['String'];
}>;


export type AcceptLineTermsMutation = { __typename?: 'Mutation', acceptLineTerms?: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type InitiateLineDownPaymentMutationVariables = Exact<{
  lineId: Scalars['String'];
}>;


export type InitiateLineDownPaymentMutation = { __typename?: 'Mutation', initiateLineDownPayment?: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type AllocateLineDownPaymentAccountIdMutationVariables = Exact<{
  lineId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type AllocateLineDownPaymentAccountIdMutation = { __typename?: 'Mutation', allocateLineDownPaymentAccountId?: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type GenerateLineDocumentUrlQueryVariables = Exact<{
  lineId: Scalars['String'];
  documentType: LineDocumentType;
}>;


export type GenerateLineDocumentUrlQuery = { __typename?: 'Query', generateLineDocumentUrl?: { __typename?: 'DocumentUrl', url: string, envelopeId: string } };

export type DocumentSigningCompletedQueryVariables = Exact<{
  lineId: Scalars['String'];
  documentId: Scalars['String'];
}>;


export type DocumentSigningCompletedQuery = { __typename?: 'Query', documentSigningCompleted?: { __typename?: 'GenericResult', success: boolean } };

export type UploadProofOfInsuranceForLineMutationVariables = Exact<{
  lineId: Scalars['String'];
  insuranceProof: Scalars['Upload'];
}>;


export type UploadProofOfInsuranceForLineMutation = { __typename?: 'Mutation', uploadProofOfInsuranceForLine?: { __typename?: 'Line', completedPaymentIds: Array<string>, createdAt: string, downPaymentAccountId: string, finalized?: boolean, id: string, latePaymentIds: Array<string>, loanType: LoanType, monthsRemaining: number, monthsTotal: number, originationStatus: LineOriginationStatus, organizationId: string, personalGuarantee: boolean, projectedPayoffDate: string, proofOfInsuranceUploaded: boolean, repaymentDate: number, status: LineStatus, subscriptionId: string, termLengthInMonths: number, userId: string, amountBorrowed: { __typename?: 'Money', display: string, amount: number }, amountPaidOff: { __typename?: 'Money', display: string, amount: number }, auctionDate?: { __typename?: 'DateRange', start: string, end: string }, collateral: Array<{ __typename?: 'Collateral', collateralType: CollateralType, description: string, identification?: string, currentValue: { __typename?: 'Money', display: string, amount: number }, originalValue: { __typename?: 'Money', display: string, amount: number } }>, documents: Array<{ __typename?: 'LineDocument', documentId?: string, signed: boolean, title: string, documentType: LineDocumentType, documentStatus: LineDocumentStatus }>, downPaymentAmount: { __typename?: 'Money', display: string, amount: number }, interestAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, interestRate: { __typename?: 'Percentage', display: string, amount: number }, lineType: { __typename?: 'LineType', collateralType: CollateralType, description: string, id: string, termLengthMonths?: Array<number>, title: string, apyRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, ltvRange: { __typename?: 'PercentageRange', lower: { __typename?: 'Percentage', amount: number, display: string }, upper: { __typename?: 'Percentage', amount: number, display: string } }, maxOfferingAmount: { __typename?: 'Money', amount: number, display: string }, requiredDeposit?: { __typename?: 'Money', amount: number, display: string }, termMonthRange: { __typename?: 'NumberRange', lower: number, upper: number } }, loanAmount: { __typename?: 'Money', display: string, amount: number }, loanInterestAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentAmount: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, paymentSchedule?: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, principalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, subscription?: { __typename?: 'Subscription', nextPaymentDate?: string, inDefaultReason?: SubscriptionInDefaultReason, inDefaultStage?: SubscriptionInDefaultStage, status: SubscriptionStatus, latePayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }>, completedPayments?: Array<{ __typename?: 'SubscriptionPaymentInput', id: string }> } } };

export type CalculateAmortizationQueryVariables = Exact<{
  input: AmortizationCalculationInput;
}>;


export type CalculateAmortizationQuery = { __typename?: 'Query', calculateAmortization?: { __typename?: 'AmortizationCalculation', interestRatePercent: number, projectedPayoffDate: string, termLengthInMonths: number, monthlyPaymentAmount: { __typename?: 'Money', display: string, amount: number }, monthlyRepaymentFeePercent: { __typename?: 'Percentage', display: string, amount: number }, schedule: Array<{ __typename?: 'AmortizationPayment', paymentDate: string, interestAmountPaid: { __typename?: 'Money', display: string, amount: number }, principalAmountPaid: { __typename?: 'Money', display: string, amount: number }, remainingAmount: { __typename?: 'Money', display: string, amount: number } }>, totalAmountBorrowed: { __typename?: 'Money', display: string, amount: number }, totalInterestAmount: { __typename?: 'Money', display: string, amount: number } } };

export type AddBusinessInfoMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']>;
  orgType: OrganizationType;
  orgName?: InputMaybe<Scalars['String']>;
  legalStructure?: InputMaybe<Scalars['String']>;
  taxStatus?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  stateOfIncorporation?: InputMaybe<Scalars['String']>;
  businessPhoneNumber?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}>;


export type AddBusinessInfoMutation = { __typename?: 'Mutation', createOrUpdateOrganization?: { __typename?: 'Organization', id: string, ownerUserIds?: Array<string>, orgType: OrgType, name?: string, legalStructure?: string, taxId?: string, taxStatus?: string, category?: string, stateOfIncorporation?: string, businessPhoneNumber?: string, streetAddress?: string, city?: string, state?: string, zip?: string, session?: string, currentContext: boolean } };

export type UpdateOwnersMutationVariables = Exact<{
  organizationId: Scalars['String'];
  beneficialOwners: Array<BeneficialOwnerInput> | BeneficialOwnerInput;
}>;


export type UpdateOwnersMutation = { __typename?: 'Mutation', updateOwners?: { __typename?: 'GenericResult', success: boolean } };

export type ReissueTokenMutationVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type ReissueTokenMutation = { __typename?: 'Mutation', reIssueToken: { __typename?: 'Session', session?: string } };

export type OrganizationOwnersQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OrganizationOwnersQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', beneficialOwners?: Array<{ __typename?: 'BeneficialOwner', id: string, firstName: string, lastName: string, phone: string, dob?: string, ownershipPercentage: string, ssn?: string, email: string, streetAddress?: string, city?: string, state?: string, zip?: string, title: string, createdAt?: any, primaryContact?: boolean, primaryOfficer?: boolean }> } };

export type TransactionsForOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type TransactionsForOrgQuery = { __typename?: 'Query', transactionsForOrg: { __typename?: 'TransactionListWithPaging', items: Array<{ __typename?: 'Transaction', id: string, transactionType?: string, sourceId?: string, targetId?: string, entityId?: string, transactionDate: string, merchantDescription?: string, spendType?: SpendType, entityType?: EntityType, sourceType?: EntityType, targetType?: EntityType, organizationId?: string, createdAt: any, status?: string, amount: { __typename?: 'Money', amount: number, display: string } }> } };

export type OrganizationByIdBalancesQueryVariables = Exact<{
  orgId: Scalars['String'];
  timeframe?: InputMaybe<BalancesTimeframe>;
}>;


export type OrganizationByIdBalancesQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, balances: Array<{ __typename?: 'AccountBalancesGrouped', period: string, balance: { __typename?: 'Money', amount: number, display: string } }> } };

export type OrganizationByIdQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type OrganizationByIdQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', ownerUserIds?: Array<string>, legalStructure?: string, taxId?: string, taxStatus?: string, category?: string, stateOfIncorporation?: string, businessPhoneNumber?: string, streetAddress?: string, city?: string, state?: string, zip?: string, session?: string, role: Role, accredited?: boolean, creditCheck?: CheckStatus, id: string, currentContext: boolean, name?: string, orgType: OrgType, externalBalance: { __typename?: 'Money', display: string, amount: number }, totalBalance: { __typename?: 'Money', display: string, amount: number }, availableBalance: { __typename?: 'Money', display: string, amount: number }, deposits: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, accountHolder?: { __typename?: 'AccountHolder', name: string, address: { __typename?: 'CounterpartyAddress', street?: string, city?: string, state?: string, postalCode?: string, country?: string } }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deals: Array<{ __typename?: 'DealInvestor', id: string, fundingAccountId?: string, committedAmount?: { __typename?: 'Money', display: string, amount: number }, commitments?: Array<{ __typename?: 'DealCommitment', dealInvestorId: string, dealId: string, id: string, numberOfShares?: number }> }>, oneLine: { __typename?: 'OneLine', availableToUnderwrite: boolean, eligibleForQualification: boolean, repaymentAccountId?: string, repaymentAccountType?: TargetAccountType, underwritingReviewStatus?: CheckStatus, lines: Array<{ __typename?: 'Line', id: string, createdAt: string, finalized?: boolean, originationStatus: LineOriginationStatus, status: LineStatus, loanAmount: { __typename?: 'Money', display: string, amount: number }, lineType: { __typename?: 'LineType', id: string, title: string } }>, totals: { __typename?: 'LineTotals', approxPayOffDate: string, monthsRemaining: number, monthsTotal: number, openLines: number, availableToBorrow: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, totalAmountBorrowed: { __typename?: 'Money', display: string, amount: number }, totalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, totalMonthlyPayment: { __typename?: 'Money', display: string, amount: number } }, eligibilityQualificationAmount: { __typename?: 'Money', display: string, amount: number }, repaymentAccount?: { __typename?: 'Account', nickname?: string, last4?: string } | { __typename?: 'ConnectedAccount', nickname?: string, last4?: string }, repaymentFeePercent?: { __typename?: 'Money', display: string, amount: number } }, oneLineAvailableToBorrow?: { __typename?: 'Money', display: string, amount: number }, beneficialOwners?: Array<{ __typename?: 'BeneficialOwner', id: string, firstName: string, lastName: string, phone: string, dob?: string, ownershipPercentage: string, ssn?: string, email: string, streetAddress?: string, city?: string, state?: string, zip?: string, title: string, createdAt?: any, primaryContact?: boolean, primaryOfficer?: boolean }> } };

export type OrganizationUsersQueryVariables = Exact<{
  orgId: Scalars['String'];
  selectedUserId?: InputMaybe<Scalars['String']>;
}>;


export type OrganizationUsersQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, role: Role, users: Array<{ __typename?: 'User', id: string, email: string, firstName: string, lastName: string, orgRole: Role, status?: UserStatus, selected?: boolean, isThisMe?: boolean, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }> }> } };

export type RevokeOrgInviteMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RevokeOrgInviteMutation = { __typename?: 'Mutation', revokeInviteToOrg?: { __typename?: 'GenericResult', success: boolean } };

export type RemoveOrgUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type RemoveOrgUserMutation = { __typename?: 'Mutation', removeOrgUser?: { __typename?: 'GenericResult', success: boolean } };

export type FreezeOrgUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FreezeOrgUserMutation = { __typename?: 'Mutation', freezeOrgUser?: { __typename?: 'GenericResult', success: boolean } };

export type ThawOrgUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ThawOrgUserMutation = { __typename?: 'Mutation', thawOrgUser?: { __typename?: 'GenericResult', success: boolean } };

export type EditOrgUserMutationVariables = Exact<{
  userId: Scalars['String'];
  role: Role;
}>;


export type EditOrgUserMutation = { __typename?: 'Mutation', editOrgUserAccess?: { __typename?: 'GenericResult', success: boolean } };

export type DeleteOrgMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteOrgMutation = { __typename?: 'Mutation', deleteOrganization?: { __typename?: 'GenericResult', success: boolean } };

export type InviteUserToOrgMutationVariables = Exact<{
  permissionLevel: PermissionLevel;
  email: Scalars['String'];
  sendEmail: Scalars['Boolean'];
}>;


export type InviteUserToOrgMutation = { __typename?: 'Mutation', inviteUserToOrg?: { __typename?: 'InviteUserToOrgResponse', token: string, userId: string } };

export type RequetAccreditationMutationVariables = Exact<{ [key: string]: never; }>;


export type RequetAccreditationMutation = { __typename?: 'Mutation', requestAccreditation?: { __typename?: 'GenericResult', success: boolean } };

export type AllocateRepaymentAccountIdMutationVariables = Exact<{
  accountId: Scalars['String'];
}>;


export type AllocateRepaymentAccountIdMutation = { __typename?: 'Mutation', allocateRepaymentAccountId?: { __typename?: 'Organization', ownerUserIds?: Array<string>, legalStructure?: string, taxId?: string, taxStatus?: string, category?: string, stateOfIncorporation?: string, businessPhoneNumber?: string, streetAddress?: string, city?: string, state?: string, zip?: string, session?: string, role: Role, accredited?: boolean, creditCheck?: CheckStatus, id: string, currentContext: boolean, name?: string, orgType: OrgType, accountHolder?: { __typename?: 'AccountHolder', name: string, address: { __typename?: 'CounterpartyAddress', street?: string, city?: string, state?: string, postalCode?: string, country?: string } }, cards: Array<{ __typename?: 'Card', id: string, accountId: string, organizationId: string, cardHolderFirstName?: string, cardHolderLastName?: string, cardHolderEmail?: string, type?: CardType, limitBehaviour?: CardLimitBehaviourType, design?: string, last4?: string, expiryDate?: string, externalCardId: string, status: CardStatusType, limit: { __typename?: 'Money', display: string, amount: number }, spent: { __typename?: 'Money', display: string, amount: number }, spentToday: { __typename?: 'Money', display: string, amount: number }, spentThisMonth: { __typename?: 'Money', display: string, amount: number }, address: { __typename?: 'Address', street: string, city: string, state: string, postalCode: string, country: string } }>, deals: Array<{ __typename?: 'DealInvestor', id: string, fundingAccountId?: string, committedAmount?: { __typename?: 'Money', display: string, amount: number }, commitments?: Array<{ __typename?: 'DealCommitment', dealInvestorId: string, dealId: string, id: string, numberOfShares?: number }> }>, oneLine: { __typename?: 'OneLine', availableToUnderwrite: boolean, eligibleForQualification: boolean, repaymentAccountId?: string, repaymentAccountType?: TargetAccountType, underwritingReviewStatus?: CheckStatus, lines: Array<{ __typename?: 'Line', id: string, createdAt: string, finalized?: boolean, originationStatus: LineOriginationStatus, status: LineStatus, loanAmount: { __typename?: 'Money', display: string, amount: number }, lineType: { __typename?: 'LineType', id: string, title: string } }>, totals: { __typename?: 'LineTotals', approxPayOffDate: string, monthsRemaining: number, monthsTotal: number, openLines: number, availableToBorrow: { __typename?: 'Money', display: string, amount: number }, outstandingBalance: { __typename?: 'Money', display: string, amount: number }, totalAmountBorrowed: { __typename?: 'Money', display: string, amount: number }, totalAmountPaidOff: { __typename?: 'Money', display: string, amount: number }, totalMonthlyPayment: { __typename?: 'Money', display: string, amount: number } }, eligibilityQualificationAmount: { __typename?: 'Money', display: string, amount: number }, repaymentAccount?: { __typename?: 'Account', nickname?: string, last4?: string } | { __typename?: 'ConnectedAccount', nickname?: string, last4?: string }, repaymentFeePercent?: { __typename?: 'Money', display: string, amount: number } }, oneLineAvailableToBorrow?: { __typename?: 'Money', display: string, amount: number } } };

export type CreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'Payment', id: string, description?: string, amount: { __typename?: 'Money', amount: number, display: string } } };

export type GetInstitutionInfoQueryVariables = Exact<{
  routingNumber: Scalars['String'];
}>;


export type GetInstitutionInfoQuery = { __typename?: 'Query', institutionInfo: { __typename?: 'BankInstitution', routingNumber?: string, name?: string, address?: string, isAchSupported?: boolean, isWireSupported?: boolean } };

export type RecipientsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecipientsQuery = { __typename?: 'Query', recipients: { __typename?: 'Recipients', recipients?: Array<{ __typename?: 'Recipient', id: string, nickname?: string, accountHolderName: string, accountNumber: string, routingNumber: string, organizationId: string, transferType: TransferRecipientType, street: string, city: string, state: string, zipCode: string, country: string, wireDescription?: string }> } };

export type RecipientQueryVariables = Exact<{
  recipientId: Scalars['String'];
}>;


export type RecipientQuery = { __typename?: 'Query', recipient: { __typename?: 'Recipient', id: string, nickname?: string, accountHolderName: string, accountNumber: string, routingNumber: string, organizationId: string, transferType: TransferRecipientType, street: string, city: string, state: string, zipCode: string, country: string, wireDescription?: string } };

export type CreateRecipientMutationVariables = Exact<{
  input: CreateRecipientInput;
}>;


export type CreateRecipientMutation = { __typename?: 'Mutation', createRecipient?: { __typename?: 'Recipient', id: string } };

export type DeleteRecipientMutationVariables = Exact<{
  recipientId: Scalars['String'];
}>;


export type DeleteRecipientMutation = { __typename?: 'Mutation', deleteRecipient?: { __typename?: 'GenericResult', success: boolean } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, checks: Array<{ __typename?: 'UserCheck', type?: UserCheckType, status: UserCheckStatus, comments?: string }>, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type CreateUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  password: Scalars['String'];
  referralCode?: InputMaybe<Scalars['String']>;
  netWorth: Scalars['String'];
  inviteCode?: InputMaybe<Scalars['String']>;
  partnershipType?: InputMaybe<PartnershipType>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', token?: string, id: string, firstName: string, lastName: string, email: string, phone: string, netWorth?: string, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean } } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  netWorth: Scalars['String'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', editBasicUserInformation?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type AddPersonalInfoMutationVariables = Exact<{
  userId: Scalars['ID'];
  DOB: Scalars['String'];
  SSN: Scalars['String'];
  streetAddress: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
}>;


export type AddPersonalInfoMutation = { __typename?: 'Mutation', addPersonalInformationToUser?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type TriggerVerificationMutationVariables = Exact<{
  type: UserVerificationType;
}>;


export type TriggerVerificationMutation = { __typename?: 'Mutation', triggerVerification?: { __typename?: 'GenericResult', success: boolean } };

export type AddVerificationToUserMutationVariables = Exact<{
  userId: Scalars['ID'];
  verificationType?: InputMaybe<UserVerificationType>;
  verificationImage?: InputMaybe<Scalars['Upload']>;
  idVerificationName?: InputMaybe<UserIdVerificationName>;
  token?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
}>;


export type AddVerificationToUserMutation = { __typename?: 'Mutation', addVerificationToUser?: { __typename?: 'User', verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type CancelAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelAccountMutation = { __typename?: 'Mutation', cancelAccount?: { __typename?: 'GenericResult', success: boolean } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'GenericResult', success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'User', email: string } };

export type OpenAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type OpenAccountMutation = { __typename?: 'Mutation', openAccount?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type UnlockAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type UnlockAccountMutation = { __typename?: 'Mutation', unlockAccount?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type EditUserDeviceTokenMutationVariables = Exact<{
  deviceToken: Scalars['String'];
}>;


export type EditUserDeviceTokenMutation = { __typename?: 'Mutation', editUserDeviceToken?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type EditUserNotificationSettingsMutationVariables = Exact<{
  receivePush: Scalars['Boolean'];
  receiveSms: Scalars['Boolean'];
}>;


export type EditUserNotificationSettingsMutation = { __typename?: 'Mutation', editUserNotificationSettings?: { __typename?: 'User', id: string, firstName: string, lastName: string, email: string, phone: string, DOB?: string, SSN?: string, inviteCode?: string, onboarded?: boolean, approved?: boolean, isThisMe?: boolean, hasDeposited?: boolean, streetAddress?: string, city?: string, state?: string, zip?: string, netWorth?: string, partnershipType?: PartnershipType, idVerifications?: Array<{ __typename?: 'UserIdVerification', idVerificationName?: UserIdVerificationName, updatedAt?: string }>, notifications: { __typename?: 'NotificationSettings', receivePush: boolean, receiveSms: boolean }, organizations: Array<{ __typename?: 'Organization', id: string, currentContext: boolean, name?: string, orgType: OrgType }>, verified: { __typename?: 'VerifiedStatus', wealth: boolean, id: boolean, mfa?: boolean, survey: boolean, phone: boolean, email: boolean, face?: boolean, _userId?: string } } };

export type ValidatePasswordResetTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ValidatePasswordResetTokenMutation = { __typename?: 'Mutation', validatePasswordResetToken?: { __typename?: 'ValidResult', valid: boolean } };

export type RequestMoreReferralsMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestMoreReferralsMutation = { __typename?: 'Mutation', requestMoreReferrals?: { __typename?: 'GenericResult', success: boolean } };

export const LineTypeDataFragmentDoc = gql`
    fragment LineTypeData on LineType {
  apyRange {
    lower {
      amount
      display
    }
    upper {
      amount
      display
    }
  }
  collateralType
  description
  id
  ltvRange {
    lower {
      amount
      display
    }
    upper {
      amount
      display
    }
  }
  maxOfferingAmount {
    amount
    display
  }
  requiredDeposit {
    amount
    display
  }
  termLengthMonths
  termMonthRange {
    lower
    upper
  }
  title
}
    `;
export const LinePaymentScheduleDataFragmentDoc = gql`
    fragment LinePaymentScheduleData on AmortizationPayment {
  interestAmountPaid {
    display
    amount
  }
  paymentDate
  principalAmountPaid {
    display
    amount
  }
  remainingAmount {
    display
    amount
  }
}
    `;
export const LineDataFragmentDoc = gql`
    fragment LineData on Line {
  amountBorrowed {
    display
    amount
  }
  amountPaidOff {
    display
    amount
  }
  auctionDate {
    start
    end
  }
  collateral {
    collateralType
    currentValue {
      display
      amount
    }
    description
    identification
    originalValue {
      display
      amount
    }
  }
  completedPaymentIds
  createdAt
  documents {
    documentId
    signed
    title
    documentType
    documentStatus
  }
  downPaymentAccountId
  downPaymentAmount {
    display
    amount
  }
  finalized
  id
  interestAmountPaidOff {
    display
    amount
  }
  interestRate {
    display
    amount
  }
  latePaymentIds
  lineType {
    ...LineTypeData
  }
  loanAmount {
    display
    amount
  }
  loanInterestAmount {
    display
    amount
  }
  loanType
  monthlyRepaymentAmount {
    display
    amount
  }
  monthsRemaining
  monthsTotal
  originationStatus
  organizationId
  outstandingBalance {
    display
    amount
  }
  paymentSchedule {
    ...LinePaymentScheduleData
  }
  personalGuarantee
  principalAmountPaidOff {
    display
    amount
  }
  projectedPayoffDate
  proofOfInsuranceUploaded
  repaymentDate
  status
  subscriptionId
  subscription {
    nextPaymentDate
    inDefaultReason
    inDefaultStage
    status
    latePayments {
      id
    }
    completedPayments {
      id
    }
  }
  termLengthInMonths
  userId
}
    ${LineTypeDataFragmentDoc}
${LinePaymentScheduleDataFragmentDoc}`;
export const OrgMinDataFragmentDoc = gql`
    fragment OrgMinData on Organization {
  id
  currentContext
  name
  orgType
}
    `;
export const CardDataFragmentDoc = gql`
    fragment CardData on Card {
  id
  accountId
  limit {
    display
    amount
  }
  organizationId
  cardHolderFirstName
  cardHolderLastName
  cardHolderEmail
  type
  limitBehaviour
  design
  last4
  expiryDate
  externalCardId
  status
  spent {
    display
    amount
  }
  spentToday {
    display
    amount
  }
  spentThisMonth {
    display
    amount
  }
  address {
    street
    city
    state
    postalCode
    country
  }
}
    `;
export const LineMinDataFragmentDoc = gql`
    fragment LineMinData on Line {
  id
  loanAmount {
    display
    amount
  }
  createdAt
  finalized
  lineType {
    id
    title
  }
  originationStatus
  status
}
    `;
export const OneLineDataFragmentDoc = gql`
    fragment OneLineData on OneLine {
  lines {
    ...LineMinData
  }
  totals {
    approxPayOffDate
    availableToBorrow {
      display
      amount
    }
    monthsRemaining
    monthsTotal
    openLines
    outstandingBalance {
      display
      amount
    }
    totalAmountBorrowed {
      display
      amount
    }
    totalAmountPaidOff {
      display
      amount
    }
    totalMonthlyPayment {
      display
      amount
    }
  }
  availableToUnderwrite
  eligibleForQualification
  eligibilityQualificationAmount {
    display
    amount
  }
  repaymentAccount {
    ... on Account {
      nickname
      last4
    }
    ... on ConnectedAccount {
      nickname
      last4
    }
  }
  repaymentAccountId
  repaymentAccountType
  repaymentFeePercent {
    display
    amount
  }
  underwritingReviewStatus
}
    ${LineMinDataFragmentDoc}`;
export const OrgDataFragmentDoc = gql`
    fragment OrgData on Organization {
  ...OrgMinData
  ownerUserIds
  accountHolder {
    name
    address {
      street
      city
      state
      postalCode
      country
    }
  }
  legalStructure
  taxId
  taxStatus
  category
  stateOfIncorporation
  businessPhoneNumber
  streetAddress
  city
  state
  zip
  session
  role
  accredited
  creditCheck
  cards {
    ...CardData
  }
  deals {
    id
    fundingAccountId
    committedAmount {
      display
      amount
    }
    commitments {
      dealInvestorId
      dealId
      id
      numberOfShares
    }
  }
  oneLine {
    ...OneLineData
  }
  oneLineAvailableToBorrow {
    display
    amount
  }
}
    ${OrgMinDataFragmentDoc}
${CardDataFragmentDoc}
${OneLineDataFragmentDoc}`;
export const BusinessDataFragmentDoc = gql`
    fragment BusinessData on Organization {
  id
  ownerUserIds
  orgType
  name
  legalStructure
  taxId
  taxStatus
  category
  stateOfIncorporation
  businessPhoneNumber
  streetAddress
  city
  state
  zip
  session
  currentContext
}
    `;
export const OwnerDataFragmentDoc = gql`
    fragment OwnerData on Organization {
  beneficialOwners {
    id
    firstName
    lastName
    phone
    dob
    ownershipPercentage
    ssn
    email
    streetAddress
    city
    state
    zip
    title
    createdAt
    primaryContact
    primaryOfficer
  }
}
    `;
export const UserDataFragmentDoc = gql`
    fragment UserData on User {
  id
  firstName
  lastName
  email
  phone
  DOB
  SSN
  inviteCode
  onboarded
  approved
  idVerifications {
    idVerificationName
    updatedAt
  }
  isThisMe
  hasDeposited
  streetAddress
  city
  state
  zip
  netWorth
  notifications {
    receivePush
    receiveSms
  }
  organizations {
    ...OrgMinData
  }
  partnershipType
  verified {
    wealth
    id
    mfa
    survey
    phone
    email
    face
    _userId
  }
}
    ${OrgMinDataFragmentDoc}`;
export const CreatedUserDataFragmentDoc = gql`
    fragment CreatedUserData on User {
  id
  firstName
  lastName
  email
  phone
  netWorth
  notifications {
    receivePush
    receiveSms
  }
}
    `;
export const TranxDataFragmentDoc = gql`
    fragment TranxData on Transaction {
  id
  amount {
    display
    amount
  }
  sourceId
  targetId
  sourceType
  targetType
  organizationId
  merchantDescription
  createdAt
}
    `;
export const FullAccountDataFragmentDoc = gql`
    fragment FullAccountData on Account {
  id
  totalBalance {
    display
    amount
  }
  availableBalance {
    amount
    display
  }
  cards {
    ...CardData
  }
  createdAt
  deposits {
    display
    amount
  }
  externalAccountNumber
  externalRoutingNumber
  last4
  nickname
  organizationDefault
  organizationId
  spent {
    display
    amount
  }
  statements {
    statementId
    month
    year
  }
  selected
  accountType
  owners {
    id
    isAccountOwner
    firstName
    lastName
    status
    email
  }
}
    ${CardDataFragmentDoc}`;
export const FullBankAccountDataFragmentDoc = gql`
    fragment FullBankAccountData on BankAccounts {
  accounts {
    balances(timeframe: $timeframe, groupBy: $groupBy) {
      period
      balance {
        amount
        display
      }
    }
    ...FullAccountData
  }
}
    ${FullAccountDataFragmentDoc}`;
export const AccountActivityFragmentFragmentDoc = gql`
    fragment AccountActivityFragment on WeeklyActivity {
  activity {
    day
    spendAmount {
      amount
      display
    }
  }
  currentDay
}
    `;
export const FullTransactionAccountDataFragmentDoc = gql`
    fragment FullTransactionAccountData on TransactionListWithPaging {
  items {
    id
    amount {
      amount
      display
    }
    transactionType
    sourceId
    targetId
    entityId
    transactionDate
    merchantDescription
    spendType
    entityType
    sourceType
    targetType
    organizationId
    createdAt
    status
  }
}
    `;
export const FullTransactionDataFragmentDoc = gql`
    fragment FullTransactionData on TransactionListWithPaging {
  items {
    id
    amount {
      amount
      display
    }
    transactionType
    sourceId
    targetId
    entityId
    transactionDate
    merchantDescription
    spendType
    entityType
    sourceType
    targetType
    organizationId
    createdAt
    status
  }
}
    `;
export const FullConnectedAccountDataFragmentDoc = gql`
    fragment FullConnectedAccountData on ConnectedAccount {
  id
  type
  subType
  organizationId
  userId
  availableBalance {
    display
    amount
  }
  totalBalance {
    display
    amount
  }
  balances(timeframe: $timeframe, groupBy: $groupBy) {
    period
    balance {
      amount
      display
    }
  }
  accountNumber
  routingNumber
  last4
  providerAccountId
  providerEnrollmentId
  connectedInstitutionName
  connectedInstitutionLogo
  connectedInstitutionId
  provider
  nickname
  name
  status
  updatedAt
  createdAt
  selected
}
    `;
export const OpenCheckingAccountDocument = gql`
    mutation OpenCheckingAccount($name: String!) {
  openCheckingAccount(input: {nickname: $name}) {
    id
    totalBalance {
      display
      amount
    }
    availableBalance {
      display
      amount
    }
    externalAccountNumber
    nickname
  }
}
    `;
export type OpenCheckingAccountMutationFn = Apollo.MutationFunction<OpenCheckingAccountMutation, OpenCheckingAccountMutationVariables>;

/**
 * __useOpenCheckingAccountMutation__
 *
 * To run a mutation, you first call `useOpenCheckingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenCheckingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openCheckingAccountMutation, { data, loading, error }] = useOpenCheckingAccountMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOpenCheckingAccountMutation(baseOptions?: Apollo.MutationHookOptions<OpenCheckingAccountMutation, OpenCheckingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenCheckingAccountMutation, OpenCheckingAccountMutationVariables>(OpenCheckingAccountDocument, options);
      }
export type OpenCheckingAccountMutationHookResult = ReturnType<typeof useOpenCheckingAccountMutation>;
export type OpenCheckingAccountMutationResult = Apollo.MutationResult<OpenCheckingAccountMutation>;
export type OpenCheckingAccountMutationOptions = Apollo.BaseMutationOptions<OpenCheckingAccountMutation, OpenCheckingAccountMutationVariables>;
export const CloseCheckingAccountDocument = gql`
    mutation CloseCheckingAccount($accountId: String!) {
  closeCheckingAccount(input: {accountId: $accountId}) {
    success
  }
}
    `;
export type CloseCheckingAccountMutationFn = Apollo.MutationFunction<CloseCheckingAccountMutation, CloseCheckingAccountMutationVariables>;

/**
 * __useCloseCheckingAccountMutation__
 *
 * To run a mutation, you first call `useCloseCheckingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCheckingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCheckingAccountMutation, { data, loading, error }] = useCloseCheckingAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useCloseCheckingAccountMutation(baseOptions?: Apollo.MutationHookOptions<CloseCheckingAccountMutation, CloseCheckingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseCheckingAccountMutation, CloseCheckingAccountMutationVariables>(CloseCheckingAccountDocument, options);
      }
export type CloseCheckingAccountMutationHookResult = ReturnType<typeof useCloseCheckingAccountMutation>;
export type CloseCheckingAccountMutationResult = Apollo.MutationResult<CloseCheckingAccountMutation>;
export type CloseCheckingAccountMutationOptions = Apollo.BaseMutationOptions<CloseCheckingAccountMutation, CloseCheckingAccountMutationVariables>;
export const EditCheckingAccountDocument = gql`
    mutation EditCheckingAccount($accountId: String!, $name: String!) {
  editCheckingAccount(input: {accountId: $accountId, nickname: $name}) {
    id
    nickname
  }
}
    `;
export type EditCheckingAccountMutationFn = Apollo.MutationFunction<EditCheckingAccountMutation, EditCheckingAccountMutationVariables>;

/**
 * __useEditCheckingAccountMutation__
 *
 * To run a mutation, you first call `useEditCheckingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCheckingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCheckingAccountMutation, { data, loading, error }] = useEditCheckingAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditCheckingAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditCheckingAccountMutation, EditCheckingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCheckingAccountMutation, EditCheckingAccountMutationVariables>(EditCheckingAccountDocument, options);
      }
export type EditCheckingAccountMutationHookResult = ReturnType<typeof useEditCheckingAccountMutation>;
export type EditCheckingAccountMutationResult = Apollo.MutationResult<EditCheckingAccountMutation>;
export type EditCheckingAccountMutationOptions = Apollo.BaseMutationOptions<EditCheckingAccountMutation, EditCheckingAccountMutationVariables>;
export const BankAccountsDocument = gql`
    query BankAccounts($accountRef: [AccountRef!]!, $selectedId: String, $timeframe: BalancesTimeframe, $groupBy: BalancesGrouping) {
  bankAccounts(input: {accountRef: $accountRef, selectedId: $selectedId}) {
    ...FullBankAccountData
  }
}
    ${FullBankAccountDataFragmentDoc}`;

/**
 * __useBankAccountsQuery__
 *
 * To run a query within a React component, call `useBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountsQuery({
 *   variables: {
 *      accountRef: // value for 'accountRef'
 *      selectedId: // value for 'selectedId'
 *      timeframe: // value for 'timeframe'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
      }
export function useBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountsQuery, BankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountsQuery, BankAccountsQueryVariables>(BankAccountsDocument, options);
        }
export type BankAccountsQueryHookResult = ReturnType<typeof useBankAccountsQuery>;
export type BankAccountsLazyQueryHookResult = ReturnType<typeof useBankAccountsLazyQuery>;
export type BankAccountsQueryResult = Apollo.QueryResult<BankAccountsQuery, BankAccountsQueryVariables>;
export function refetchBankAccountsQuery(variables: BankAccountsQueryVariables) {
      return { query: BankAccountsDocument, variables: variables }
    }
export const BankAccountByIdDocument = gql`
    query BankAccountById($accountId: String!) {
  account(accountId: $accountId) {
    ...FullAccountData
  }
}
    ${FullAccountDataFragmentDoc}`;

/**
 * __useBankAccountByIdQuery__
 *
 * To run a query within a React component, call `useBankAccountByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountByIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useBankAccountByIdQuery(baseOptions: Apollo.QueryHookOptions<BankAccountByIdQuery, BankAccountByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountByIdQuery, BankAccountByIdQueryVariables>(BankAccountByIdDocument, options);
      }
export function useBankAccountByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountByIdQuery, BankAccountByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountByIdQuery, BankAccountByIdQueryVariables>(BankAccountByIdDocument, options);
        }
export type BankAccountByIdQueryHookResult = ReturnType<typeof useBankAccountByIdQuery>;
export type BankAccountByIdLazyQueryHookResult = ReturnType<typeof useBankAccountByIdLazyQuery>;
export type BankAccountByIdQueryResult = Apollo.QueryResult<BankAccountByIdQuery, BankAccountByIdQueryVariables>;
export function refetchBankAccountByIdQuery(variables: BankAccountByIdQueryVariables) {
      return { query: BankAccountByIdDocument, variables: variables }
    }
export const BankAccountBalancesByIdDocument = gql`
    query BankAccountBalancesById($accountId: String!, $timeframe: BalancesTimeframe!) {
  account(accountId: $accountId) {
    id
    balances(timeframe: $timeframe) {
      period
      balance {
        amount
        display
      }
    }
  }
}
    `;

/**
 * __useBankAccountBalancesByIdQuery__
 *
 * To run a query within a React component, call `useBankAccountBalancesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountBalancesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountBalancesByIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useBankAccountBalancesByIdQuery(baseOptions: Apollo.QueryHookOptions<BankAccountBalancesByIdQuery, BankAccountBalancesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountBalancesByIdQuery, BankAccountBalancesByIdQueryVariables>(BankAccountBalancesByIdDocument, options);
      }
export function useBankAccountBalancesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountBalancesByIdQuery, BankAccountBalancesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountBalancesByIdQuery, BankAccountBalancesByIdQueryVariables>(BankAccountBalancesByIdDocument, options);
        }
export type BankAccountBalancesByIdQueryHookResult = ReturnType<typeof useBankAccountBalancesByIdQuery>;
export type BankAccountBalancesByIdLazyQueryHookResult = ReturnType<typeof useBankAccountBalancesByIdLazyQuery>;
export type BankAccountBalancesByIdQueryResult = Apollo.QueryResult<BankAccountBalancesByIdQuery, BankAccountBalancesByIdQueryVariables>;
export function refetchBankAccountBalancesByIdQuery(variables: BankAccountBalancesByIdQueryVariables) {
      return { query: BankAccountBalancesByIdDocument, variables: variables }
    }
export const BankAccountTransactionsByIdDocument = gql`
    query BankAccountTransactionsById($accountId: String!) {
  transactionsByAccountId(accountId: $accountId) {
    ...FullTransactionAccountData
  }
}
    ${FullTransactionAccountDataFragmentDoc}`;

/**
 * __useBankAccountTransactionsByIdQuery__
 *
 * To run a query within a React component, call `useBankAccountTransactionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountTransactionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountTransactionsByIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useBankAccountTransactionsByIdQuery(baseOptions: Apollo.QueryHookOptions<BankAccountTransactionsByIdQuery, BankAccountTransactionsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountTransactionsByIdQuery, BankAccountTransactionsByIdQueryVariables>(BankAccountTransactionsByIdDocument, options);
      }
export function useBankAccountTransactionsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountTransactionsByIdQuery, BankAccountTransactionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountTransactionsByIdQuery, BankAccountTransactionsByIdQueryVariables>(BankAccountTransactionsByIdDocument, options);
        }
export type BankAccountTransactionsByIdQueryHookResult = ReturnType<typeof useBankAccountTransactionsByIdQuery>;
export type BankAccountTransactionsByIdLazyQueryHookResult = ReturnType<typeof useBankAccountTransactionsByIdLazyQuery>;
export type BankAccountTransactionsByIdQueryResult = Apollo.QueryResult<BankAccountTransactionsByIdQuery, BankAccountTransactionsByIdQueryVariables>;
export function refetchBankAccountTransactionsByIdQuery(variables: BankAccountTransactionsByIdQueryVariables) {
      return { query: BankAccountTransactionsByIdDocument, variables: variables }
    }
export const BankAccountStatementDocument = gql`
    query BankAccountStatement($statementId: String!, $accountId: String!) {
  statement(statementId: $statementId, accountId: $accountId) {
    url
  }
}
    `;

/**
 * __useBankAccountStatementQuery__
 *
 * To run a query within a React component, call `useBankAccountStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountStatementQuery({
 *   variables: {
 *      statementId: // value for 'statementId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useBankAccountStatementQuery(baseOptions: Apollo.QueryHookOptions<BankAccountStatementQuery, BankAccountStatementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountStatementQuery, BankAccountStatementQueryVariables>(BankAccountStatementDocument, options);
      }
export function useBankAccountStatementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountStatementQuery, BankAccountStatementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountStatementQuery, BankAccountStatementQueryVariables>(BankAccountStatementDocument, options);
        }
export type BankAccountStatementQueryHookResult = ReturnType<typeof useBankAccountStatementQuery>;
export type BankAccountStatementLazyQueryHookResult = ReturnType<typeof useBankAccountStatementLazyQuery>;
export type BankAccountStatementQueryResult = Apollo.QueryResult<BankAccountStatementQuery, BankAccountStatementQueryVariables>;
export function refetchBankAccountStatementQuery(variables: BankAccountStatementQueryVariables) {
      return { query: BankAccountStatementDocument, variables: variables }
    }
export const BankAccountOwnersDocument = gql`
    query BankAccountOwners($accountId: String!, $selectedId: String!) {
  account(accountId: $accountId) {
    id
    owners(selectedId: $selectedId) {
      id
      isAccountOwner
      firstName
      lastName
      selected
      isThisMe
    }
  }
}
    `;

/**
 * __useBankAccountOwnersQuery__
 *
 * To run a query within a React component, call `useBankAccountOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountOwnersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      selectedId: // value for 'selectedId'
 *   },
 * });
 */
export function useBankAccountOwnersQuery(baseOptions: Apollo.QueryHookOptions<BankAccountOwnersQuery, BankAccountOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountOwnersQuery, BankAccountOwnersQueryVariables>(BankAccountOwnersDocument, options);
      }
export function useBankAccountOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountOwnersQuery, BankAccountOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountOwnersQuery, BankAccountOwnersQueryVariables>(BankAccountOwnersDocument, options);
        }
export type BankAccountOwnersQueryHookResult = ReturnType<typeof useBankAccountOwnersQuery>;
export type BankAccountOwnersLazyQueryHookResult = ReturnType<typeof useBankAccountOwnersLazyQuery>;
export type BankAccountOwnersQueryResult = Apollo.QueryResult<BankAccountOwnersQuery, BankAccountOwnersQueryVariables>;
export function refetchBankAccountOwnersQuery(variables: BankAccountOwnersQueryVariables) {
      return { query: BankAccountOwnersDocument, variables: variables }
    }
export const AddOwnersToCheckingAccountDocument = gql`
    mutation AddOwnersToCheckingAccount($accountId: String!, $userId: String!) {
  addOwnersToCheckingAccount(input: {accountId: $accountId, userId: $userId}) {
    ...FullAccountData
  }
}
    ${FullAccountDataFragmentDoc}`;
export type AddOwnersToCheckingAccountMutationFn = Apollo.MutationFunction<AddOwnersToCheckingAccountMutation, AddOwnersToCheckingAccountMutationVariables>;

/**
 * __useAddOwnersToCheckingAccountMutation__
 *
 * To run a mutation, you first call `useAddOwnersToCheckingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOwnersToCheckingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOwnersToCheckingAccountMutation, { data, loading, error }] = useAddOwnersToCheckingAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddOwnersToCheckingAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddOwnersToCheckingAccountMutation, AddOwnersToCheckingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOwnersToCheckingAccountMutation, AddOwnersToCheckingAccountMutationVariables>(AddOwnersToCheckingAccountDocument, options);
      }
export type AddOwnersToCheckingAccountMutationHookResult = ReturnType<typeof useAddOwnersToCheckingAccountMutation>;
export type AddOwnersToCheckingAccountMutationResult = Apollo.MutationResult<AddOwnersToCheckingAccountMutation>;
export type AddOwnersToCheckingAccountMutationOptions = Apollo.BaseMutationOptions<AddOwnersToCheckingAccountMutation, AddOwnersToCheckingAccountMutationVariables>;
export const RemoveOwnersFromCheckingAccountDocument = gql`
    mutation RemoveOwnersFromCheckingAccount($accountId: String!, $userId: String!) {
  removeOwnersFromCheckingAccount(input: {accountId: $accountId, userId: $userId}) {
    success
  }
}
    `;
export type RemoveOwnersFromCheckingAccountMutationFn = Apollo.MutationFunction<RemoveOwnersFromCheckingAccountMutation, RemoveOwnersFromCheckingAccountMutationVariables>;

/**
 * __useRemoveOwnersFromCheckingAccountMutation__
 *
 * To run a mutation, you first call `useRemoveOwnersFromCheckingAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOwnersFromCheckingAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOwnersFromCheckingAccountMutation, { data, loading, error }] = useRemoveOwnersFromCheckingAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveOwnersFromCheckingAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOwnersFromCheckingAccountMutation, RemoveOwnersFromCheckingAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOwnersFromCheckingAccountMutation, RemoveOwnersFromCheckingAccountMutationVariables>(RemoveOwnersFromCheckingAccountDocument, options);
      }
export type RemoveOwnersFromCheckingAccountMutationHookResult = ReturnType<typeof useRemoveOwnersFromCheckingAccountMutation>;
export type RemoveOwnersFromCheckingAccountMutationResult = Apollo.MutationResult<RemoveOwnersFromCheckingAccountMutation>;
export type RemoveOwnersFromCheckingAccountMutationOptions = Apollo.BaseMutationOptions<RemoveOwnersFromCheckingAccountMutation, RemoveOwnersFromCheckingAccountMutationVariables>;
export const AlertsDocument = gql`
    query alerts {
  alerts {
    alerts {
      id
      meta
      alertType
      createdAt
    }
  }
}
    `;

/**
 * __useAlertsQuery__
 *
 * To run a query within a React component, call `useAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlertsQuery(baseOptions?: Apollo.QueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
      }
export function useAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
export type AlertsQueryHookResult = ReturnType<typeof useAlertsQuery>;
export type AlertsLazyQueryHookResult = ReturnType<typeof useAlertsLazyQuery>;
export type AlertsQueryResult = Apollo.QueryResult<AlertsQuery, AlertsQueryVariables>;
export function refetchAlertsQuery(variables?: AlertsQueryVariables) {
      return { query: AlertsDocument, variables: variables }
    }
export const AddEmailToWaitlistDocument = gql`
    mutation AddEmailToWaitlist($email: String!) {
  addEmailToWaitlist(input: {email: $email}) {
    success
  }
}
    `;
export type AddEmailToWaitlistMutationFn = Apollo.MutationFunction<AddEmailToWaitlistMutation, AddEmailToWaitlistMutationVariables>;

/**
 * __useAddEmailToWaitlistMutation__
 *
 * To run a mutation, you first call `useAddEmailToWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailToWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailToWaitlistMutation, { data, loading, error }] = useAddEmailToWaitlistMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddEmailToWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailToWaitlistMutation, AddEmailToWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailToWaitlistMutation, AddEmailToWaitlistMutationVariables>(AddEmailToWaitlistDocument, options);
      }
export type AddEmailToWaitlistMutationHookResult = ReturnType<typeof useAddEmailToWaitlistMutation>;
export type AddEmailToWaitlistMutationResult = Apollo.MutationResult<AddEmailToWaitlistMutation>;
export type AddEmailToWaitlistMutationOptions = Apollo.BaseMutationOptions<AddEmailToWaitlistMutation, AddEmailToWaitlistMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!, $inviteCode: String, $recaptchaScore: Float) {
  login(
    input: {email: $email, password: $password, inviteCode: $inviteCode, recaptchaScore: $recaptchaScore}
  ) {
    session
    mfaEnabled
    organizationId
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      inviteCode: // value for 'inviteCode'
 *      recaptchaScore: // value for 'recaptchaScore'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(input: {oldPassword: $oldPassword, newPassword: $newPassword}) {
    success
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GenerateMultiFactorDocument = gql`
    mutation GenerateMultiFactor {
  generateMultiFactor {
    secret
    uri
    qr
  }
}
    `;
export type GenerateMultiFactorMutationFn = Apollo.MutationFunction<GenerateMultiFactorMutation, GenerateMultiFactorMutationVariables>;

/**
 * __useGenerateMultiFactorMutation__
 *
 * To run a mutation, you first call `useGenerateMultiFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMultiFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMultiFactorMutation, { data, loading, error }] = useGenerateMultiFactorMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateMultiFactorMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMultiFactorMutation, GenerateMultiFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMultiFactorMutation, GenerateMultiFactorMutationVariables>(GenerateMultiFactorDocument, options);
      }
export type GenerateMultiFactorMutationHookResult = ReturnType<typeof useGenerateMultiFactorMutation>;
export type GenerateMultiFactorMutationResult = Apollo.MutationResult<GenerateMultiFactorMutation>;
export type GenerateMultiFactorMutationOptions = Apollo.BaseMutationOptions<GenerateMultiFactorMutation, GenerateMultiFactorMutationVariables>;
export const VerifyMultiFactorDocument = gql`
    mutation VerifyMultiFactor($token: String!) {
  verifyMultiFactor(input: {token: $token}) {
    session
    mfaEnabled
    organizationId
  }
}
    `;
export type VerifyMultiFactorMutationFn = Apollo.MutationFunction<VerifyMultiFactorMutation, VerifyMultiFactorMutationVariables>;

/**
 * __useVerifyMultiFactorMutation__
 *
 * To run a mutation, you first call `useVerifyMultiFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMultiFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMultiFactorMutation, { data, loading, error }] = useVerifyMultiFactorMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyMultiFactorMutation(baseOptions?: Apollo.MutationHookOptions<VerifyMultiFactorMutation, VerifyMultiFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyMultiFactorMutation, VerifyMultiFactorMutationVariables>(VerifyMultiFactorDocument, options);
      }
export type VerifyMultiFactorMutationHookResult = ReturnType<typeof useVerifyMultiFactorMutation>;
export type VerifyMultiFactorMutationResult = Apollo.MutationResult<VerifyMultiFactorMutation>;
export type VerifyMultiFactorMutationOptions = Apollo.BaseMutationOptions<VerifyMultiFactorMutation, VerifyMultiFactorMutationVariables>;
export const ValidSessionDocument = gql`
    query ValidSession {
  validSession {
    success
  }
}
    `;

/**
 * __useValidSessionQuery__
 *
 * To run a query within a React component, call `useValidSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidSessionQuery(baseOptions?: Apollo.QueryHookOptions<ValidSessionQuery, ValidSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidSessionQuery, ValidSessionQueryVariables>(ValidSessionDocument, options);
      }
export function useValidSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidSessionQuery, ValidSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidSessionQuery, ValidSessionQueryVariables>(ValidSessionDocument, options);
        }
export type ValidSessionQueryHookResult = ReturnType<typeof useValidSessionQuery>;
export type ValidSessionLazyQueryHookResult = ReturnType<typeof useValidSessionLazyQuery>;
export type ValidSessionQueryResult = Apollo.QueryResult<ValidSessionQuery, ValidSessionQueryVariables>;
export function refetchValidSessionQuery(variables?: ValidSessionQueryVariables) {
      return { query: ValidSessionDocument, variables: variables }
    }
export const RespondToImpersonationRequestDocument = gql`
    mutation RespondToImpersonationRequest($id: String!, $allow: Boolean!) {
  respondToImpersonationRequest(input: {id: $id, allow: $allow}) {
    success
  }
}
    `;
export type RespondToImpersonationRequestMutationFn = Apollo.MutationFunction<RespondToImpersonationRequestMutation, RespondToImpersonationRequestMutationVariables>;

/**
 * __useRespondToImpersonationRequestMutation__
 *
 * To run a mutation, you first call `useRespondToImpersonationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToImpersonationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToImpersonationRequestMutation, { data, loading, error }] = useRespondToImpersonationRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      allow: // value for 'allow'
 *   },
 * });
 */
export function useRespondToImpersonationRequestMutation(baseOptions?: Apollo.MutationHookOptions<RespondToImpersonationRequestMutation, RespondToImpersonationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToImpersonationRequestMutation, RespondToImpersonationRequestMutationVariables>(RespondToImpersonationRequestDocument, options);
      }
export type RespondToImpersonationRequestMutationHookResult = ReturnType<typeof useRespondToImpersonationRequestMutation>;
export type RespondToImpersonationRequestMutationResult = Apollo.MutationResult<RespondToImpersonationRequestMutation>;
export type RespondToImpersonationRequestMutationOptions = Apollo.BaseMutationOptions<RespondToImpersonationRequestMutation, RespondToImpersonationRequestMutationVariables>;
export const RecaptchaSiteVerifyDocument = gql`
    mutation RecaptchaSiteVerify($token: String!) {
  recaptchaSiteVerify(input: {token: $token}) {
    success
    score
    errorCodesList
  }
}
    `;
export type RecaptchaSiteVerifyMutationFn = Apollo.MutationFunction<RecaptchaSiteVerifyMutation, RecaptchaSiteVerifyMutationVariables>;

/**
 * __useRecaptchaSiteVerifyMutation__
 *
 * To run a mutation, you first call `useRecaptchaSiteVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecaptchaSiteVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recaptchaSiteVerifyMutation, { data, loading, error }] = useRecaptchaSiteVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRecaptchaSiteVerifyMutation(baseOptions?: Apollo.MutationHookOptions<RecaptchaSiteVerifyMutation, RecaptchaSiteVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecaptchaSiteVerifyMutation, RecaptchaSiteVerifyMutationVariables>(RecaptchaSiteVerifyDocument, options);
      }
export type RecaptchaSiteVerifyMutationHookResult = ReturnType<typeof useRecaptchaSiteVerifyMutation>;
export type RecaptchaSiteVerifyMutationResult = Apollo.MutationResult<RecaptchaSiteVerifyMutation>;
export type RecaptchaSiteVerifyMutationOptions = Apollo.BaseMutationOptions<RecaptchaSiteVerifyMutation, RecaptchaSiteVerifyMutationVariables>;
export const CreateOnfidoApplicationDocument = gql`
    mutation CreateOnfidoApplication($input: OnfidoApplicationInput!) {
  createOnfidoApplication(input: $input) {
    sdkToken
    applicantId
  }
}
    `;
export type CreateOnfidoApplicationMutationFn = Apollo.MutationFunction<CreateOnfidoApplicationMutation, CreateOnfidoApplicationMutationVariables>;

/**
 * __useCreateOnfidoApplicationMutation__
 *
 * To run a mutation, you first call `useCreateOnfidoApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnfidoApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnfidoApplicationMutation, { data, loading, error }] = useCreateOnfidoApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOnfidoApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnfidoApplicationMutation, CreateOnfidoApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnfidoApplicationMutation, CreateOnfidoApplicationMutationVariables>(CreateOnfidoApplicationDocument, options);
      }
export type CreateOnfidoApplicationMutationHookResult = ReturnType<typeof useCreateOnfidoApplicationMutation>;
export type CreateOnfidoApplicationMutationResult = Apollo.MutationResult<CreateOnfidoApplicationMutation>;
export type CreateOnfidoApplicationMutationOptions = Apollo.BaseMutationOptions<CreateOnfidoApplicationMutation, CreateOnfidoApplicationMutationVariables>;
export const CreateOnfidoCheckDocument = gql`
    mutation CreateOnfidoCheck {
  createOnfidoCheck {
    success
  }
}
    `;
export type CreateOnfidoCheckMutationFn = Apollo.MutationFunction<CreateOnfidoCheckMutation, CreateOnfidoCheckMutationVariables>;

/**
 * __useCreateOnfidoCheckMutation__
 *
 * To run a mutation, you first call `useCreateOnfidoCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnfidoCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnfidoCheckMutation, { data, loading, error }] = useCreateOnfidoCheckMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateOnfidoCheckMutation(baseOptions?: Apollo.MutationHookOptions<CreateOnfidoCheckMutation, CreateOnfidoCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOnfidoCheckMutation, CreateOnfidoCheckMutationVariables>(CreateOnfidoCheckDocument, options);
      }
export type CreateOnfidoCheckMutationHookResult = ReturnType<typeof useCreateOnfidoCheckMutation>;
export type CreateOnfidoCheckMutationResult = Apollo.MutationResult<CreateOnfidoCheckMutation>;
export type CreateOnfidoCheckMutationOptions = Apollo.BaseMutationOptions<CreateOnfidoCheckMutation, CreateOnfidoCheckMutationVariables>;
export const CreateCardDocument = gql`
    mutation CreateCard($accountId: String!, $limit: Float!, $role: Role!, $cardHolderFirstName: String!, $cardHolderLastName: String!, $cardHolderUserId: String!, $cardHolderEmail: String!, $design: String!, $limitBehaviour: CardLimitBehaviourType, $type: CardType) {
  createCard(
    input: {accountId: $accountId, limit: $limit, role: $role, cardHolderFirstName: $cardHolderFirstName, cardHolderLastName: $cardHolderLastName, cardHolderUserId: $cardHolderUserId, cardHolderEmail: $cardHolderEmail, design: $design, limitBehaviour: $limitBehaviour, type: $type}
  ) {
    ...CardData
  }
}
    ${CardDataFragmentDoc}`;
export type CreateCardMutationFn = Apollo.MutationFunction<CreateCardMutation, CreateCardMutationVariables>;

/**
 * __useCreateCardMutation__
 *
 * To run a mutation, you first call `useCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardMutation, { data, loading, error }] = useCreateCardMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      role: // value for 'role'
 *      cardHolderFirstName: // value for 'cardHolderFirstName'
 *      cardHolderLastName: // value for 'cardHolderLastName'
 *      cardHolderUserId: // value for 'cardHolderUserId'
 *      cardHolderEmail: // value for 'cardHolderEmail'
 *      design: // value for 'design'
 *      limitBehaviour: // value for 'limitBehaviour'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardMutation, CreateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardMutation, CreateCardMutationVariables>(CreateCardDocument, options);
      }
export type CreateCardMutationHookResult = ReturnType<typeof useCreateCardMutation>;
export type CreateCardMutationResult = Apollo.MutationResult<CreateCardMutation>;
export type CreateCardMutationOptions = Apollo.BaseMutationOptions<CreateCardMutation, CreateCardMutationVariables>;
export const GetCardDocument = gql`
    query GetCard($cardId: String!) {
  card(cardId: $cardId) {
    id
    ...CardData
  }
}
    ${CardDataFragmentDoc}`;

/**
 * __useGetCardQuery__
 *
 * To run a query within a React component, call `useGetCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetCardQuery(baseOptions: Apollo.QueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
      }
export function useGetCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
        }
export type GetCardQueryHookResult = ReturnType<typeof useGetCardQuery>;
export type GetCardLazyQueryHookResult = ReturnType<typeof useGetCardLazyQuery>;
export type GetCardQueryResult = Apollo.QueryResult<GetCardQuery, GetCardQueryVariables>;
export function refetchGetCardQuery(variables: GetCardQueryVariables) {
      return { query: GetCardDocument, variables: variables }
    }
export const UpdateCardLimitDocument = gql`
    mutation UpdateCardLimit($cardId: String!, $limit: Float!, $limitBehaviour: CardLimitBehaviourType!, $limitEnabled: Boolean!) {
  changeCardLimit(
    input: {cardId: $cardId, limit: $limit, limitBehaviour: $limitBehaviour, limitEnabled: $limitEnabled}
  ) {
    id
    status
    last4
    ...CardData
  }
}
    ${CardDataFragmentDoc}`;
export type UpdateCardLimitMutationFn = Apollo.MutationFunction<UpdateCardLimitMutation, UpdateCardLimitMutationVariables>;

/**
 * __useUpdateCardLimitMutation__
 *
 * To run a mutation, you first call `useUpdateCardLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardLimitMutation, { data, loading, error }] = useUpdateCardLimitMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      limit: // value for 'limit'
 *      limitBehaviour: // value for 'limitBehaviour'
 *      limitEnabled: // value for 'limitEnabled'
 *   },
 * });
 */
export function useUpdateCardLimitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardLimitMutation, UpdateCardLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardLimitMutation, UpdateCardLimitMutationVariables>(UpdateCardLimitDocument, options);
      }
export type UpdateCardLimitMutationHookResult = ReturnType<typeof useUpdateCardLimitMutation>;
export type UpdateCardLimitMutationResult = Apollo.MutationResult<UpdateCardLimitMutation>;
export type UpdateCardLimitMutationOptions = Apollo.BaseMutationOptions<UpdateCardLimitMutation, UpdateCardLimitMutationVariables>;
export const WeeklyCardActivityDocument = gql`
    query WeeklyCardActivity($cardId: String!) {
  weeklyActivityByAccountId(cardId: $cardId) {
    activity {
      day
      spendAmount {
        amount
        display
      }
    }
    currentDay
  }
}
    `;

/**
 * __useWeeklyCardActivityQuery__
 *
 * To run a query within a React component, call `useWeeklyCardActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyCardActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyCardActivityQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useWeeklyCardActivityQuery(baseOptions: Apollo.QueryHookOptions<WeeklyCardActivityQuery, WeeklyCardActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeeklyCardActivityQuery, WeeklyCardActivityQueryVariables>(WeeklyCardActivityDocument, options);
      }
export function useWeeklyCardActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeeklyCardActivityQuery, WeeklyCardActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeeklyCardActivityQuery, WeeklyCardActivityQueryVariables>(WeeklyCardActivityDocument, options);
        }
export type WeeklyCardActivityQueryHookResult = ReturnType<typeof useWeeklyCardActivityQuery>;
export type WeeklyCardActivityLazyQueryHookResult = ReturnType<typeof useWeeklyCardActivityLazyQuery>;
export type WeeklyCardActivityQueryResult = Apollo.QueryResult<WeeklyCardActivityQuery, WeeklyCardActivityQueryVariables>;
export function refetchWeeklyCardActivityQuery(variables: WeeklyCardActivityQueryVariables) {
      return { query: WeeklyCardActivityDocument, variables: variables }
    }
export const CardTransactionsDocument = gql`
    query CardTransactions($accountId: String!, $cardId: String!) {
  transactionsByAccountId(accountId: $accountId, cardId: $cardId) {
    ...FullTransactionAccountData
  }
}
    ${FullTransactionAccountDataFragmentDoc}`;

/**
 * __useCardTransactionsQuery__
 *
 * To run a query within a React component, call `useCardTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardTransactionsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useCardTransactionsQuery(baseOptions: Apollo.QueryHookOptions<CardTransactionsQuery, CardTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardTransactionsQuery, CardTransactionsQueryVariables>(CardTransactionsDocument, options);
      }
export function useCardTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardTransactionsQuery, CardTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardTransactionsQuery, CardTransactionsQueryVariables>(CardTransactionsDocument, options);
        }
export type CardTransactionsQueryHookResult = ReturnType<typeof useCardTransactionsQuery>;
export type CardTransactionsLazyQueryHookResult = ReturnType<typeof useCardTransactionsLazyQuery>;
export type CardTransactionsQueryResult = Apollo.QueryResult<CardTransactionsQuery, CardTransactionsQueryVariables>;
export function refetchCardTransactionsQuery(variables: CardTransactionsQueryVariables) {
      return { query: CardTransactionsDocument, variables: variables }
    }
export const CreateCardSesssionDocument = gql`
    mutation CreateCardSesssion {
  createCardSession {
    challenge
  }
}
    `;
export type CreateCardSesssionMutationFn = Apollo.MutationFunction<CreateCardSesssionMutation, CreateCardSesssionMutationVariables>;

/**
 * __useCreateCardSesssionMutation__
 *
 * To run a mutation, you first call `useCreateCardSesssionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardSesssionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardSesssionMutation, { data, loading, error }] = useCreateCardSesssionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCardSesssionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCardSesssionMutation, CreateCardSesssionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCardSesssionMutation, CreateCardSesssionMutationVariables>(CreateCardSesssionDocument, options);
      }
export type CreateCardSesssionMutationHookResult = ReturnType<typeof useCreateCardSesssionMutation>;
export type CreateCardSesssionMutationResult = Apollo.MutationResult<CreateCardSesssionMutation>;
export type CreateCardSesssionMutationOptions = Apollo.BaseMutationOptions<CreateCardSesssionMutation, CreateCardSesssionMutationVariables>;
export const CompleteCardSesssionDocument = gql`
    mutation CompleteCardSesssion($code: String!, $cardId: String!) {
  completeCardSession(input: {code: $code, cardId: $cardId}) {
    token
    externalCardId
  }
}
    `;
export type CompleteCardSesssionMutationFn = Apollo.MutationFunction<CompleteCardSesssionMutation, CompleteCardSesssionMutationVariables>;

/**
 * __useCompleteCardSesssionMutation__
 *
 * To run a mutation, you first call `useCompleteCardSesssionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCardSesssionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCardSesssionMutation, { data, loading, error }] = useCompleteCardSesssionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useCompleteCardSesssionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteCardSesssionMutation, CompleteCardSesssionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteCardSesssionMutation, CompleteCardSesssionMutationVariables>(CompleteCardSesssionDocument, options);
      }
export type CompleteCardSesssionMutationHookResult = ReturnType<typeof useCompleteCardSesssionMutation>;
export type CompleteCardSesssionMutationResult = Apollo.MutationResult<CompleteCardSesssionMutation>;
export type CompleteCardSesssionMutationOptions = Apollo.BaseMutationOptions<CompleteCardSesssionMutation, CompleteCardSesssionMutationVariables>;
export const FreezeCardDocument = gql`
    mutation FreezeCard($cardId: String!) {
  freezeCard(input: {cardId: $cardId}) {
    id
    status
  }
}
    `;
export type FreezeCardMutationFn = Apollo.MutationFunction<FreezeCardMutation, FreezeCardMutationVariables>;

/**
 * __useFreezeCardMutation__
 *
 * To run a mutation, you first call `useFreezeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreezeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freezeCardMutation, { data, loading, error }] = useFreezeCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useFreezeCardMutation(baseOptions?: Apollo.MutationHookOptions<FreezeCardMutation, FreezeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreezeCardMutation, FreezeCardMutationVariables>(FreezeCardDocument, options);
      }
export type FreezeCardMutationHookResult = ReturnType<typeof useFreezeCardMutation>;
export type FreezeCardMutationResult = Apollo.MutationResult<FreezeCardMutation>;
export type FreezeCardMutationOptions = Apollo.BaseMutationOptions<FreezeCardMutation, FreezeCardMutationVariables>;
export const UnfreezeCardDocument = gql`
    mutation UnfreezeCard($cardId: String!) {
  unfreezeCard(input: {cardId: $cardId}) {
    id
    status
  }
}
    `;
export type UnfreezeCardMutationFn = Apollo.MutationFunction<UnfreezeCardMutation, UnfreezeCardMutationVariables>;

/**
 * __useUnfreezeCardMutation__
 *
 * To run a mutation, you first call `useUnfreezeCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfreezeCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfreezeCardMutation, { data, loading, error }] = useUnfreezeCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useUnfreezeCardMutation(baseOptions?: Apollo.MutationHookOptions<UnfreezeCardMutation, UnfreezeCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfreezeCardMutation, UnfreezeCardMutationVariables>(UnfreezeCardDocument, options);
      }
export type UnfreezeCardMutationHookResult = ReturnType<typeof useUnfreezeCardMutation>;
export type UnfreezeCardMutationResult = Apollo.MutationResult<UnfreezeCardMutation>;
export type UnfreezeCardMutationOptions = Apollo.BaseMutationOptions<UnfreezeCardMutation, UnfreezeCardMutationVariables>;
export const CloseCardDocument = gql`
    mutation CloseCard($cardId: String!) {
  closeCard(input: {cardId: $cardId}) {
    id
    status
    last4
    ...CardData
  }
}
    ${CardDataFragmentDoc}`;
export type CloseCardMutationFn = Apollo.MutationFunction<CloseCardMutation, CloseCardMutationVariables>;

/**
 * __useCloseCardMutation__
 *
 * To run a mutation, you first call `useCloseCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCardMutation, { data, loading, error }] = useCloseCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useCloseCardMutation(baseOptions?: Apollo.MutationHookOptions<CloseCardMutation, CloseCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseCardMutation, CloseCardMutationVariables>(CloseCardDocument, options);
      }
export type CloseCardMutationHookResult = ReturnType<typeof useCloseCardMutation>;
export type CloseCardMutationResult = Apollo.MutationResult<CloseCardMutation>;
export type CloseCardMutationOptions = Apollo.BaseMutationOptions<CloseCardMutation, CloseCardMutationVariables>;
export const ConnectConnectedAccountProviderDocument = gql`
    mutation ConnectConnectedAccountProvider($input: ConnectedAccountConnectInput!) {
  connectConnectedAccountProvider(input: $input) {
    expectedNewAccountsNumber
    expectedNewAccountsData {
      id
      type
      subType
      organizationId
      userId
      availableBalance {
        display
        amount
      }
      totalBalance {
        display
        amount
      }
      accountNumber
      routingNumber
      last4
      providerAccountId
      providerEnrollmentId
      connectedInstitutionName
      connectedInstitutionLogo
      connectedInstitutionId
      provider
      nickname
      name
      status
      updatedAt
      createdAt
      selected
    }
  }
}
    `;
export type ConnectConnectedAccountProviderMutationFn = Apollo.MutationFunction<ConnectConnectedAccountProviderMutation, ConnectConnectedAccountProviderMutationVariables>;

/**
 * __useConnectConnectedAccountProviderMutation__
 *
 * To run a mutation, you first call `useConnectConnectedAccountProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectConnectedAccountProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectConnectedAccountProviderMutation, { data, loading, error }] = useConnectConnectedAccountProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectConnectedAccountProviderMutation(baseOptions?: Apollo.MutationHookOptions<ConnectConnectedAccountProviderMutation, ConnectConnectedAccountProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectConnectedAccountProviderMutation, ConnectConnectedAccountProviderMutationVariables>(ConnectConnectedAccountProviderDocument, options);
      }
export type ConnectConnectedAccountProviderMutationHookResult = ReturnType<typeof useConnectConnectedAccountProviderMutation>;
export type ConnectConnectedAccountProviderMutationResult = Apollo.MutationResult<ConnectConnectedAccountProviderMutation>;
export type ConnectConnectedAccountProviderMutationOptions = Apollo.BaseMutationOptions<ConnectConnectedAccountProviderMutation, ConnectConnectedAccountProviderMutationVariables>;
export const GetConnectedTokenDocument = gql`
    mutation GetConnectedToken($input: ProviderTokenInput!) {
  getConnectedToken(input: $input) {
    token
  }
}
    `;
export type GetConnectedTokenMutationFn = Apollo.MutationFunction<GetConnectedTokenMutation, GetConnectedTokenMutationVariables>;

/**
 * __useGetConnectedTokenMutation__
 *
 * To run a mutation, you first call `useGetConnectedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getConnectedTokenMutation, { data, loading, error }] = useGetConnectedTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConnectedTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetConnectedTokenMutation, GetConnectedTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetConnectedTokenMutation, GetConnectedTokenMutationVariables>(GetConnectedTokenDocument, options);
      }
export type GetConnectedTokenMutationHookResult = ReturnType<typeof useGetConnectedTokenMutation>;
export type GetConnectedTokenMutationResult = Apollo.MutationResult<GetConnectedTokenMutation>;
export type GetConnectedTokenMutationOptions = Apollo.BaseMutationOptions<GetConnectedTokenMutation, GetConnectedTokenMutationVariables>;
export const RefreshConnectedAccountDocument = gql`
    mutation refreshConnectedAccount($accountId: String!) {
  refreshConnectedAccount(accountId: $accountId) {
    nickname
    type
    last4
    id
    accountNumber
    routingNumber
    status
    providerEnrollmentId
    updatedAt
    balance {
      display
      amount
    }
  }
}
    `;
export type RefreshConnectedAccountMutationFn = Apollo.MutationFunction<RefreshConnectedAccountMutation, RefreshConnectedAccountMutationVariables>;

/**
 * __useRefreshConnectedAccountMutation__
 *
 * To run a mutation, you first call `useRefreshConnectedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshConnectedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshConnectedAccountMutation, { data, loading, error }] = useRefreshConnectedAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRefreshConnectedAccountMutation(baseOptions?: Apollo.MutationHookOptions<RefreshConnectedAccountMutation, RefreshConnectedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshConnectedAccountMutation, RefreshConnectedAccountMutationVariables>(RefreshConnectedAccountDocument, options);
      }
export type RefreshConnectedAccountMutationHookResult = ReturnType<typeof useRefreshConnectedAccountMutation>;
export type RefreshConnectedAccountMutationResult = Apollo.MutationResult<RefreshConnectedAccountMutation>;
export type RefreshConnectedAccountMutationOptions = Apollo.BaseMutationOptions<RefreshConnectedAccountMutation, RefreshConnectedAccountMutationVariables>;
export const RefreshConnectedAccountsDocument = gql`
    mutation refreshConnectedAccounts {
  refreshConnectedAccounts {
    success
  }
}
    `;
export type RefreshConnectedAccountsMutationFn = Apollo.MutationFunction<RefreshConnectedAccountsMutation, RefreshConnectedAccountsMutationVariables>;

/**
 * __useRefreshConnectedAccountsMutation__
 *
 * To run a mutation, you first call `useRefreshConnectedAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshConnectedAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshConnectedAccountsMutation, { data, loading, error }] = useRefreshConnectedAccountsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshConnectedAccountsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshConnectedAccountsMutation, RefreshConnectedAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshConnectedAccountsMutation, RefreshConnectedAccountsMutationVariables>(RefreshConnectedAccountsDocument, options);
      }
export type RefreshConnectedAccountsMutationHookResult = ReturnType<typeof useRefreshConnectedAccountsMutation>;
export type RefreshConnectedAccountsMutationResult = Apollo.MutationResult<RefreshConnectedAccountsMutation>;
export type RefreshConnectedAccountsMutationOptions = Apollo.BaseMutationOptions<RefreshConnectedAccountsMutation, RefreshConnectedAccountsMutationVariables>;
export const ConnectedUpdateTokenDocument = gql`
    query connectedUpdateToken($enrollmentId: String!) {
  connectedUpdateToken(enrollmentId: $enrollmentId) {
    token
  }
}
    `;

/**
 * __useConnectedUpdateTokenQuery__
 *
 * To run a query within a React component, call `useConnectedUpdateTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedUpdateTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedUpdateTokenQuery({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useConnectedUpdateTokenQuery(baseOptions: Apollo.QueryHookOptions<ConnectedUpdateTokenQuery, ConnectedUpdateTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedUpdateTokenQuery, ConnectedUpdateTokenQueryVariables>(ConnectedUpdateTokenDocument, options);
      }
export function useConnectedUpdateTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedUpdateTokenQuery, ConnectedUpdateTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedUpdateTokenQuery, ConnectedUpdateTokenQueryVariables>(ConnectedUpdateTokenDocument, options);
        }
export type ConnectedUpdateTokenQueryHookResult = ReturnType<typeof useConnectedUpdateTokenQuery>;
export type ConnectedUpdateTokenLazyQueryHookResult = ReturnType<typeof useConnectedUpdateTokenLazyQuery>;
export type ConnectedUpdateTokenQueryResult = Apollo.QueryResult<ConnectedUpdateTokenQuery, ConnectedUpdateTokenQueryVariables>;
export function refetchConnectedUpdateTokenQuery(variables: ConnectedUpdateTokenQueryVariables) {
      return { query: ConnectedUpdateTokenDocument, variables: variables }
    }
export const EditConnectedAccountDocument = gql`
    mutation EditConnectedAccount($accountId: String!, $nickname: String!) {
  editConnectedAccount(input: {accountId: $accountId, nickname: $nickname}) {
    nickname
  }
}
    `;
export type EditConnectedAccountMutationFn = Apollo.MutationFunction<EditConnectedAccountMutation, EditConnectedAccountMutationVariables>;

/**
 * __useEditConnectedAccountMutation__
 *
 * To run a mutation, you first call `useEditConnectedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditConnectedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editConnectedAccountMutation, { data, loading, error }] = useEditConnectedAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      nickname: // value for 'nickname'
 *   },
 * });
 */
export function useEditConnectedAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditConnectedAccountMutation, EditConnectedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditConnectedAccountMutation, EditConnectedAccountMutationVariables>(EditConnectedAccountDocument, options);
      }
export type EditConnectedAccountMutationHookResult = ReturnType<typeof useEditConnectedAccountMutation>;
export type EditConnectedAccountMutationResult = Apollo.MutationResult<EditConnectedAccountMutation>;
export type EditConnectedAccountMutationOptions = Apollo.BaseMutationOptions<EditConnectedAccountMutation, EditConnectedAccountMutationVariables>;
export const DisconnectConnectedAccountDocument = gql`
    mutation DisconnectConnectedAccount($input: DisconnectConnectedAccountInput!) {
  disconnectConnectedAccount(input: $input) {
    success
  }
}
    `;
export type DisconnectConnectedAccountMutationFn = Apollo.MutationFunction<DisconnectConnectedAccountMutation, DisconnectConnectedAccountMutationVariables>;

/**
 * __useDisconnectConnectedAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectConnectedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectConnectedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectConnectedAccountMutation, { data, loading, error }] = useDisconnectConnectedAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectConnectedAccountMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectConnectedAccountMutation, DisconnectConnectedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectConnectedAccountMutation, DisconnectConnectedAccountMutationVariables>(DisconnectConnectedAccountDocument, options);
      }
export type DisconnectConnectedAccountMutationHookResult = ReturnType<typeof useDisconnectConnectedAccountMutation>;
export type DisconnectConnectedAccountMutationResult = Apollo.MutationResult<DisconnectConnectedAccountMutation>;
export type DisconnectConnectedAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectConnectedAccountMutation, DisconnectConnectedAccountMutationVariables>;
export const ConnectedAccountsListDocument = gql`
    query ConnectedAccountsList($timeframe: BalancesTimeframe, $groupBy: BalancesGrouping, $moveMoneyCapable: Boolean, $selectedId: String) {
  connectedAccountsList(
    connectedParams: {moveMoneyCapable: $moveMoneyCapable, selectedId: $selectedId}
  ) {
    connectedAccounts {
      ...FullConnectedAccountData
    }
    flaggedEnrollmentsList {
      error
      consentExpirationTime
      updateType
      transactions
    }
  }
}
    ${FullConnectedAccountDataFragmentDoc}`;

/**
 * __useConnectedAccountsListQuery__
 *
 * To run a query within a React component, call `useConnectedAccountsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedAccountsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedAccountsListQuery({
 *   variables: {
 *      timeframe: // value for 'timeframe'
 *      groupBy: // value for 'groupBy'
 *      moveMoneyCapable: // value for 'moveMoneyCapable'
 *      selectedId: // value for 'selectedId'
 *   },
 * });
 */
export function useConnectedAccountsListQuery(baseOptions?: Apollo.QueryHookOptions<ConnectedAccountsListQuery, ConnectedAccountsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedAccountsListQuery, ConnectedAccountsListQueryVariables>(ConnectedAccountsListDocument, options);
      }
export function useConnectedAccountsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedAccountsListQuery, ConnectedAccountsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedAccountsListQuery, ConnectedAccountsListQueryVariables>(ConnectedAccountsListDocument, options);
        }
export type ConnectedAccountsListQueryHookResult = ReturnType<typeof useConnectedAccountsListQuery>;
export type ConnectedAccountsListLazyQueryHookResult = ReturnType<typeof useConnectedAccountsListLazyQuery>;
export type ConnectedAccountsListQueryResult = Apollo.QueryResult<ConnectedAccountsListQuery, ConnectedAccountsListQueryVariables>;
export function refetchConnectedAccountsListQuery(variables?: ConnectedAccountsListQueryVariables) {
      return { query: ConnectedAccountsListDocument, variables: variables }
    }
export const ConnectedAccountBalancesDocument = gql`
    query ConnectedAccountBalances($accountId: String!, $timeframe: BalancesTimeframe, $groupBy: BalancesGrouping) {
  connectedAccount(accountId: $accountId) {
    balances(timeframe: $timeframe, groupBy: $groupBy) {
      period
      balance {
        amount
        display
      }
    }
  }
}
    `;

/**
 * __useConnectedAccountBalancesQuery__
 *
 * To run a query within a React component, call `useConnectedAccountBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedAccountBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedAccountBalancesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      timeframe: // value for 'timeframe'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useConnectedAccountBalancesQuery(baseOptions: Apollo.QueryHookOptions<ConnectedAccountBalancesQuery, ConnectedAccountBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedAccountBalancesQuery, ConnectedAccountBalancesQueryVariables>(ConnectedAccountBalancesDocument, options);
      }
export function useConnectedAccountBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedAccountBalancesQuery, ConnectedAccountBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedAccountBalancesQuery, ConnectedAccountBalancesQueryVariables>(ConnectedAccountBalancesDocument, options);
        }
export type ConnectedAccountBalancesQueryHookResult = ReturnType<typeof useConnectedAccountBalancesQuery>;
export type ConnectedAccountBalancesLazyQueryHookResult = ReturnType<typeof useConnectedAccountBalancesLazyQuery>;
export type ConnectedAccountBalancesQueryResult = Apollo.QueryResult<ConnectedAccountBalancesQuery, ConnectedAccountBalancesQueryVariables>;
export function refetchConnectedAccountBalancesQuery(variables: ConnectedAccountBalancesQueryVariables) {
      return { query: ConnectedAccountBalancesDocument, variables: variables }
    }
export const ConnectedAccountDocument = gql`
    query ConnectedAccount($accountId: String!) {
  connectedAccount(accountId: $accountId) {
    id
    type
    subType
    organizationId
    userId
    availableBalance {
      display
      amount
    }
    totalBalance {
      display
      amount
    }
    accountNumber
    routingNumber
    last4
    providerAccountId
    providerEnrollmentId
    connectedInstitutionName
    connectedInstitutionLogo
    connectedInstitutionId
    provider
    nickname
    name
    status
    updatedAt
    createdAt
    selected
  }
}
    `;

/**
 * __useConnectedAccountQuery__
 *
 * To run a query within a React component, call `useConnectedAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useConnectedAccountQuery(baseOptions: Apollo.QueryHookOptions<ConnectedAccountQuery, ConnectedAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedAccountQuery, ConnectedAccountQueryVariables>(ConnectedAccountDocument, options);
      }
export function useConnectedAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedAccountQuery, ConnectedAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedAccountQuery, ConnectedAccountQueryVariables>(ConnectedAccountDocument, options);
        }
export type ConnectedAccountQueryHookResult = ReturnType<typeof useConnectedAccountQuery>;
export type ConnectedAccountLazyQueryHookResult = ReturnType<typeof useConnectedAccountLazyQuery>;
export type ConnectedAccountQueryResult = Apollo.QueryResult<ConnectedAccountQuery, ConnectedAccountQueryVariables>;
export function refetchConnectedAccountQuery(variables: ConnectedAccountQueryVariables) {
      return { query: ConnectedAccountDocument, variables: variables }
    }
export const DealsDocument = gql`
    query Deals {
  deals {
    deals {
      id
      name
      createdAt
      termLength
      caption
      description
      details
      closeDate
      infoLink
      listingType
      distributions
      logoImage
      headerImage
      discount {
        amount
        display
      }
      committedAmountSold {
        amount
        display
      }
      committedAmountBought {
        amount
        display
      }
      transactionAmountSold {
        amount
        display
      }
      transactionAmountBought {
        amount
        display
      }
      targetAmount {
        amount
        display
      }
      minInvestment {
        amount
        display
      }
      targetedTotalReturn {
        amount
        display
      }
      letterFee {
        amount
        display
      }
    }
  }
}
    `;

/**
 * __useDealsQuery__
 *
 * To run a query within a React component, call `useDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealsQuery(baseOptions?: Apollo.QueryHookOptions<DealsQuery, DealsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealsQuery, DealsQueryVariables>(DealsDocument, options);
      }
export function useDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealsQuery, DealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealsQuery, DealsQueryVariables>(DealsDocument, options);
        }
export type DealsQueryHookResult = ReturnType<typeof useDealsQuery>;
export type DealsLazyQueryHookResult = ReturnType<typeof useDealsLazyQuery>;
export type DealsQueryResult = Apollo.QueryResult<DealsQuery, DealsQueryVariables>;
export function refetchDealsQuery(variables?: DealsQueryVariables) {
      return { query: DealsDocument, variables: variables }
    }
export const CommitToDealDocument = gql`
    mutation CommitToDeal($dealId: String!, $fundingAccountId: String!, $committedAmount: Float!, $executionDirection: DealExecutionDirection, $numberOfShares: Float) {
  commitToDeal(
    input: {dealId: $dealId, fundingAccountId: $fundingAccountId, committedAmount: $committedAmount, executionDirection: $executionDirection, numberOfShares: $numberOfShares}
  ) {
    success
  }
}
    `;
export type CommitToDealMutationFn = Apollo.MutationFunction<CommitToDealMutation, CommitToDealMutationVariables>;

/**
 * __useCommitToDealMutation__
 *
 * To run a mutation, you first call `useCommitToDealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitToDealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitToDealMutation, { data, loading, error }] = useCommitToDealMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      fundingAccountId: // value for 'fundingAccountId'
 *      committedAmount: // value for 'committedAmount'
 *      executionDirection: // value for 'executionDirection'
 *      numberOfShares: // value for 'numberOfShares'
 *   },
 * });
 */
export function useCommitToDealMutation(baseOptions?: Apollo.MutationHookOptions<CommitToDealMutation, CommitToDealMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommitToDealMutation, CommitToDealMutationVariables>(CommitToDealDocument, options);
      }
export type CommitToDealMutationHookResult = ReturnType<typeof useCommitToDealMutation>;
export type CommitToDealMutationResult = Apollo.MutationResult<CommitToDealMutation>;
export type CommitToDealMutationOptions = Apollo.BaseMutationOptions<CommitToDealMutation, CommitToDealMutationVariables>;
export const UpdateDealCommitmentDocument = gql`
    mutation UpdateDealCommitment($dealId: String!, $fundingAccountId: String!, $committedAmount: Float!, $dealCommitmentId: String, $dealInvestorId: String, $numberOfShares: Float) {
  updateDealCommitment(
    input: {dealId: $dealId, fundingAccountId: $fundingAccountId, committedAmount: $committedAmount, dealCommitmentId: $dealCommitmentId, dealInvestorId: $dealInvestorId, numberOfShares: $numberOfShares}
  ) {
    success
  }
}
    `;
export type UpdateDealCommitmentMutationFn = Apollo.MutationFunction<UpdateDealCommitmentMutation, UpdateDealCommitmentMutationVariables>;

/**
 * __useUpdateDealCommitmentMutation__
 *
 * To run a mutation, you first call `useUpdateDealCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDealCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDealCommitmentMutation, { data, loading, error }] = useUpdateDealCommitmentMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      fundingAccountId: // value for 'fundingAccountId'
 *      committedAmount: // value for 'committedAmount'
 *      dealCommitmentId: // value for 'dealCommitmentId'
 *      dealInvestorId: // value for 'dealInvestorId'
 *      numberOfShares: // value for 'numberOfShares'
 *   },
 * });
 */
export function useUpdateDealCommitmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDealCommitmentMutation, UpdateDealCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDealCommitmentMutation, UpdateDealCommitmentMutationVariables>(UpdateDealCommitmentDocument, options);
      }
export type UpdateDealCommitmentMutationHookResult = ReturnType<typeof useUpdateDealCommitmentMutation>;
export type UpdateDealCommitmentMutationResult = Apollo.MutationResult<UpdateDealCommitmentMutation>;
export type UpdateDealCommitmentMutationOptions = Apollo.BaseMutationOptions<UpdateDealCommitmentMutation, UpdateDealCommitmentMutationVariables>;
export const DeleteDealCommitmentDocument = gql`
    mutation DeleteDealCommitment($dealId: String!, $dealCommitmentId: String, $dealInvestorId: String) {
  deleteDealCommitment(
    input: {dealId: $dealId, dealCommitmentId: $dealCommitmentId, dealInvestorId: $dealInvestorId}
  ) {
    success
  }
}
    `;
export type DeleteDealCommitmentMutationFn = Apollo.MutationFunction<DeleteDealCommitmentMutation, DeleteDealCommitmentMutationVariables>;

/**
 * __useDeleteDealCommitmentMutation__
 *
 * To run a mutation, you first call `useDeleteDealCommitmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealCommitmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealCommitmentMutation, { data, loading, error }] = useDeleteDealCommitmentMutation({
 *   variables: {
 *      dealId: // value for 'dealId'
 *      dealCommitmentId: // value for 'dealCommitmentId'
 *      dealInvestorId: // value for 'dealInvestorId'
 *   },
 * });
 */
export function useDeleteDealCommitmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDealCommitmentMutation, DeleteDealCommitmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDealCommitmentMutation, DeleteDealCommitmentMutationVariables>(DeleteDealCommitmentDocument, options);
      }
export type DeleteDealCommitmentMutationHookResult = ReturnType<typeof useDeleteDealCommitmentMutation>;
export type DeleteDealCommitmentMutationResult = Apollo.MutationResult<DeleteDealCommitmentMutation>;
export type DeleteDealCommitmentMutationOptions = Apollo.BaseMutationOptions<DeleteDealCommitmentMutation, DeleteDealCommitmentMutationVariables>;
export const CreateDepositDocument = gql`
    mutation CreateDeposit($input: CreateDepositInput!) {
  createDeposit(input: $input) {
    id
    amount {
      amount
      display
    }
    description
  }
}
    `;
export type CreateDepositMutationFn = Apollo.MutationFunction<CreateDepositMutation, CreateDepositMutationVariables>;

/**
 * __useCreateDepositMutation__
 *
 * To run a mutation, you first call `useCreateDepositMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepositMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepositMutation, { data, loading, error }] = useCreateDepositMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepositMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepositMutation, CreateDepositMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepositMutation, CreateDepositMutationVariables>(CreateDepositDocument, options);
      }
export type CreateDepositMutationHookResult = ReturnType<typeof useCreateDepositMutation>;
export type CreateDepositMutationResult = Apollo.MutationResult<CreateDepositMutation>;
export type CreateDepositMutationOptions = Apollo.BaseMutationOptions<CreateDepositMutation, CreateDepositMutationVariables>;
export const LineAuctionDatesDocument = gql`
    query LineAuctionDates($includePast: Boolean) {
  lineAuctionDates(includePast: $includePast) {
    auctionHouse
    date {
      start
      end
    }
    cutOffDate
    description
    location
  }
}
    `;

/**
 * __useLineAuctionDatesQuery__
 *
 * To run a query within a React component, call `useLineAuctionDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineAuctionDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineAuctionDatesQuery({
 *   variables: {
 *      includePast: // value for 'includePast'
 *   },
 * });
 */
export function useLineAuctionDatesQuery(baseOptions?: Apollo.QueryHookOptions<LineAuctionDatesQuery, LineAuctionDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineAuctionDatesQuery, LineAuctionDatesQueryVariables>(LineAuctionDatesDocument, options);
      }
export function useLineAuctionDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineAuctionDatesQuery, LineAuctionDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineAuctionDatesQuery, LineAuctionDatesQueryVariables>(LineAuctionDatesDocument, options);
        }
export type LineAuctionDatesQueryHookResult = ReturnType<typeof useLineAuctionDatesQuery>;
export type LineAuctionDatesLazyQueryHookResult = ReturnType<typeof useLineAuctionDatesLazyQuery>;
export type LineAuctionDatesQueryResult = Apollo.QueryResult<LineAuctionDatesQuery, LineAuctionDatesQueryVariables>;
export function refetchLineAuctionDatesQuery(variables?: LineAuctionDatesQueryVariables) {
      return { query: LineAuctionDatesDocument, variables: variables }
    }
export const LineTypesDocument = gql`
    query LineTypes {
  lineTypes {
    ...LineTypeData
  }
}
    ${LineTypeDataFragmentDoc}`;

/**
 * __useLineTypesQuery__
 *
 * To run a query within a React component, call `useLineTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLineTypesQuery(baseOptions?: Apollo.QueryHookOptions<LineTypesQuery, LineTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineTypesQuery, LineTypesQueryVariables>(LineTypesDocument, options);
      }
export function useLineTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineTypesQuery, LineTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineTypesQuery, LineTypesQueryVariables>(LineTypesDocument, options);
        }
export type LineTypesQueryHookResult = ReturnType<typeof useLineTypesQuery>;
export type LineTypesLazyQueryHookResult = ReturnType<typeof useLineTypesLazyQuery>;
export type LineTypesQueryResult = Apollo.QueryResult<LineTypesQuery, LineTypesQueryVariables>;
export function refetchLineTypesQuery(variables?: LineTypesQueryVariables) {
      return { query: LineTypesDocument, variables: variables }
    }
export const LineTypeDocument = gql`
    query LineType($lineTypeId: String!) {
  lineType(lineTypeId: $lineTypeId) {
    ...LineTypeData
  }
}
    ${LineTypeDataFragmentDoc}`;

/**
 * __useLineTypeQuery__
 *
 * To run a query within a React component, call `useLineTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLineTypeQuery({
 *   variables: {
 *      lineTypeId: // value for 'lineTypeId'
 *   },
 * });
 */
export function useLineTypeQuery(baseOptions: Apollo.QueryHookOptions<LineTypeQuery, LineTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LineTypeQuery, LineTypeQueryVariables>(LineTypeDocument, options);
      }
export function useLineTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LineTypeQuery, LineTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LineTypeQuery, LineTypeQueryVariables>(LineTypeDocument, options);
        }
export type LineTypeQueryHookResult = ReturnType<typeof useLineTypeQuery>;
export type LineTypeLazyQueryHookResult = ReturnType<typeof useLineTypeLazyQuery>;
export type LineTypeQueryResult = Apollo.QueryResult<LineTypeQuery, LineTypeQueryVariables>;
export function refetchLineTypeQuery(variables: LineTypeQueryVariables) {
      return { query: LineTypeDocument, variables: variables }
    }
export const GetLineDocumentsDocument = gql`
    query GetLineDocuments($lineId: String!) {
  getLineDocuments(lineId: $lineId) {
    documents {
      url
      name
    }
  }
}
    `;

/**
 * __useGetLineDocumentsQuery__
 *
 * To run a query within a React component, call `useGetLineDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLineDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLineDocumentsQuery({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useGetLineDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetLineDocumentsQuery, GetLineDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLineDocumentsQuery, GetLineDocumentsQueryVariables>(GetLineDocumentsDocument, options);
      }
export function useGetLineDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLineDocumentsQuery, GetLineDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLineDocumentsQuery, GetLineDocumentsQueryVariables>(GetLineDocumentsDocument, options);
        }
export type GetLineDocumentsQueryHookResult = ReturnType<typeof useGetLineDocumentsQuery>;
export type GetLineDocumentsLazyQueryHookResult = ReturnType<typeof useGetLineDocumentsLazyQuery>;
export type GetLineDocumentsQueryResult = Apollo.QueryResult<GetLineDocumentsQuery, GetLineDocumentsQueryVariables>;
export function refetchGetLineDocumentsQuery(variables: GetLineDocumentsQueryVariables) {
      return { query: GetLineDocumentsDocument, variables: variables }
    }
export const GetLineDocument = gql`
    query GetLine($lineId: String!) {
  line(lineId: $lineId) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;

/**
 * __useGetLineQuery__
 *
 * To run a query within a React component, call `useGetLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLineQuery({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useGetLineQuery(baseOptions: Apollo.QueryHookOptions<GetLineQuery, GetLineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLineQuery, GetLineQueryVariables>(GetLineDocument, options);
      }
export function useGetLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLineQuery, GetLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLineQuery, GetLineQueryVariables>(GetLineDocument, options);
        }
export type GetLineQueryHookResult = ReturnType<typeof useGetLineQuery>;
export type GetLineLazyQueryHookResult = ReturnType<typeof useGetLineLazyQuery>;
export type GetLineQueryResult = Apollo.QueryResult<GetLineQuery, GetLineQueryVariables>;
export function refetchGetLineQuery(variables: GetLineQueryVariables) {
      return { query: GetLineDocument, variables: variables }
    }
export const AddEmailToLineAuctionWaitlistDocument = gql`
    mutation AddEmailToLineAuctionWaitlist($input: AddEmailToLineAuctionWaitlistInput!) {
  addEmailToLineAuctionWaitlist(input: $input) {
    success
  }
}
    `;
export type AddEmailToLineAuctionWaitlistMutationFn = Apollo.MutationFunction<AddEmailToLineAuctionWaitlistMutation, AddEmailToLineAuctionWaitlistMutationVariables>;

/**
 * __useAddEmailToLineAuctionWaitlistMutation__
 *
 * To run a mutation, you first call `useAddEmailToLineAuctionWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailToLineAuctionWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailToLineAuctionWaitlistMutation, { data, loading, error }] = useAddEmailToLineAuctionWaitlistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEmailToLineAuctionWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailToLineAuctionWaitlistMutation, AddEmailToLineAuctionWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailToLineAuctionWaitlistMutation, AddEmailToLineAuctionWaitlistMutationVariables>(AddEmailToLineAuctionWaitlistDocument, options);
      }
export type AddEmailToLineAuctionWaitlistMutationHookResult = ReturnType<typeof useAddEmailToLineAuctionWaitlistMutation>;
export type AddEmailToLineAuctionWaitlistMutationResult = Apollo.MutationResult<AddEmailToLineAuctionWaitlistMutation>;
export type AddEmailToLineAuctionWaitlistMutationOptions = Apollo.BaseMutationOptions<AddEmailToLineAuctionWaitlistMutation, AddEmailToLineAuctionWaitlistMutationVariables>;
export const RunCreditCheckDocument = gql`
    mutation RunCreditCheck {
  runCreditCheck {
    ...OrgData
  }
}
    ${OrgDataFragmentDoc}`;
export type RunCreditCheckMutationFn = Apollo.MutationFunction<RunCreditCheckMutation, RunCreditCheckMutationVariables>;

/**
 * __useRunCreditCheckMutation__
 *
 * To run a mutation, you first call `useRunCreditCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunCreditCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runCreditCheckMutation, { data, loading, error }] = useRunCreditCheckMutation({
 *   variables: {
 *   },
 * });
 */
export function useRunCreditCheckMutation(baseOptions?: Apollo.MutationHookOptions<RunCreditCheckMutation, RunCreditCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunCreditCheckMutation, RunCreditCheckMutationVariables>(RunCreditCheckDocument, options);
      }
export type RunCreditCheckMutationHookResult = ReturnType<typeof useRunCreditCheckMutation>;
export type RunCreditCheckMutationResult = Apollo.MutationResult<RunCreditCheckMutation>;
export type RunCreditCheckMutationOptions = Apollo.BaseMutationOptions<RunCreditCheckMutation, RunCreditCheckMutationVariables>;
export const CalculateLineTermsDocument = gql`
    mutation CalculateLineTerms($input: CalculateLineTermsInput!) {
  calculateLineTerms(input: $input) {
    downPaymentAmount {
      display
      amount
    }
    interestRate {
      display
      amount
    }
  }
}
    `;
export type CalculateLineTermsMutationFn = Apollo.MutationFunction<CalculateLineTermsMutation, CalculateLineTermsMutationVariables>;

/**
 * __useCalculateLineTermsMutation__
 *
 * To run a mutation, you first call `useCalculateLineTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateLineTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateLineTermsMutation, { data, loading, error }] = useCalculateLineTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateLineTermsMutation(baseOptions?: Apollo.MutationHookOptions<CalculateLineTermsMutation, CalculateLineTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateLineTermsMutation, CalculateLineTermsMutationVariables>(CalculateLineTermsDocument, options);
      }
export type CalculateLineTermsMutationHookResult = ReturnType<typeof useCalculateLineTermsMutation>;
export type CalculateLineTermsMutationResult = Apollo.MutationResult<CalculateLineTermsMutation>;
export type CalculateLineTermsMutationOptions = Apollo.BaseMutationOptions<CalculateLineTermsMutation, CalculateLineTermsMutationVariables>;
export const CreateLineDocument = gql`
    mutation CreateLine($input: CreateLineInput!) {
  createLine(input: $input) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;
export type CreateLineMutationFn = Apollo.MutationFunction<CreateLineMutation, CreateLineMutationVariables>;

/**
 * __useCreateLineMutation__
 *
 * To run a mutation, you first call `useCreateLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLineMutation, { data, loading, error }] = useCreateLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateLineMutation, CreateLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLineMutation, CreateLineMutationVariables>(CreateLineDocument, options);
      }
export type CreateLineMutationHookResult = ReturnType<typeof useCreateLineMutation>;
export type CreateLineMutationResult = Apollo.MutationResult<CreateLineMutation>;
export type CreateLineMutationOptions = Apollo.BaseMutationOptions<CreateLineMutation, CreateLineMutationVariables>;
export const UpdateAndResetLineDocument = gql`
    mutation UpdateAndResetLine($lineId: String!, $input: CreateLineInput!) {
  updateAndResetLine(lineId: $lineId, input: $input) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;
export type UpdateAndResetLineMutationFn = Apollo.MutationFunction<UpdateAndResetLineMutation, UpdateAndResetLineMutationVariables>;

/**
 * __useUpdateAndResetLineMutation__
 *
 * To run a mutation, you first call `useUpdateAndResetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAndResetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAndResetLineMutation, { data, loading, error }] = useUpdateAndResetLineMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAndResetLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAndResetLineMutation, UpdateAndResetLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAndResetLineMutation, UpdateAndResetLineMutationVariables>(UpdateAndResetLineDocument, options);
      }
export type UpdateAndResetLineMutationHookResult = ReturnType<typeof useUpdateAndResetLineMutation>;
export type UpdateAndResetLineMutationResult = Apollo.MutationResult<UpdateAndResetLineMutation>;
export type UpdateAndResetLineMutationOptions = Apollo.BaseMutationOptions<UpdateAndResetLineMutation, UpdateAndResetLineMutationVariables>;
export const CancelLineDocument = gql`
    mutation CancelLine($lineId: String!) {
  cancelLine(lineId: $lineId) {
    success
  }
}
    `;
export type CancelLineMutationFn = Apollo.MutationFunction<CancelLineMutation, CancelLineMutationVariables>;

/**
 * __useCancelLineMutation__
 *
 * To run a mutation, you first call `useCancelLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLineMutation, { data, loading, error }] = useCancelLineMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useCancelLineMutation(baseOptions?: Apollo.MutationHookOptions<CancelLineMutation, CancelLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLineMutation, CancelLineMutationVariables>(CancelLineDocument, options);
      }
export type CancelLineMutationHookResult = ReturnType<typeof useCancelLineMutation>;
export type CancelLineMutationResult = Apollo.MutationResult<CancelLineMutation>;
export type CancelLineMutationOptions = Apollo.BaseMutationOptions<CancelLineMutation, CancelLineMutationVariables>;
export const AcceptLineTermsDocument = gql`
    mutation AcceptLineTerms($lineId: String!) {
  acceptLineTerms(lineId: $lineId) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;
export type AcceptLineTermsMutationFn = Apollo.MutationFunction<AcceptLineTermsMutation, AcceptLineTermsMutationVariables>;

/**
 * __useAcceptLineTermsMutation__
 *
 * To run a mutation, you first call `useAcceptLineTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptLineTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptLineTermsMutation, { data, loading, error }] = useAcceptLineTermsMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useAcceptLineTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptLineTermsMutation, AcceptLineTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptLineTermsMutation, AcceptLineTermsMutationVariables>(AcceptLineTermsDocument, options);
      }
export type AcceptLineTermsMutationHookResult = ReturnType<typeof useAcceptLineTermsMutation>;
export type AcceptLineTermsMutationResult = Apollo.MutationResult<AcceptLineTermsMutation>;
export type AcceptLineTermsMutationOptions = Apollo.BaseMutationOptions<AcceptLineTermsMutation, AcceptLineTermsMutationVariables>;
export const InitiateLineDownPaymentDocument = gql`
    mutation InitiateLineDownPayment($lineId: String!) {
  initiateLineDownPayment(lineId: $lineId) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;
export type InitiateLineDownPaymentMutationFn = Apollo.MutationFunction<InitiateLineDownPaymentMutation, InitiateLineDownPaymentMutationVariables>;

/**
 * __useInitiateLineDownPaymentMutation__
 *
 * To run a mutation, you first call `useInitiateLineDownPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateLineDownPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateLineDownPaymentMutation, { data, loading, error }] = useInitiateLineDownPaymentMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useInitiateLineDownPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateLineDownPaymentMutation, InitiateLineDownPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateLineDownPaymentMutation, InitiateLineDownPaymentMutationVariables>(InitiateLineDownPaymentDocument, options);
      }
export type InitiateLineDownPaymentMutationHookResult = ReturnType<typeof useInitiateLineDownPaymentMutation>;
export type InitiateLineDownPaymentMutationResult = Apollo.MutationResult<InitiateLineDownPaymentMutation>;
export type InitiateLineDownPaymentMutationOptions = Apollo.BaseMutationOptions<InitiateLineDownPaymentMutation, InitiateLineDownPaymentMutationVariables>;
export const AllocateLineDownPaymentAccountIdDocument = gql`
    mutation AllocateLineDownPaymentAccountId($lineId: String!, $accountId: String!) {
  allocateLineDownPaymentAccountId(lineId: $lineId, accountId: $accountId) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;
export type AllocateLineDownPaymentAccountIdMutationFn = Apollo.MutationFunction<AllocateLineDownPaymentAccountIdMutation, AllocateLineDownPaymentAccountIdMutationVariables>;

/**
 * __useAllocateLineDownPaymentAccountIdMutation__
 *
 * To run a mutation, you first call `useAllocateLineDownPaymentAccountIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocateLineDownPaymentAccountIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocateLineDownPaymentAccountIdMutation, { data, loading, error }] = useAllocateLineDownPaymentAccountIdMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAllocateLineDownPaymentAccountIdMutation(baseOptions?: Apollo.MutationHookOptions<AllocateLineDownPaymentAccountIdMutation, AllocateLineDownPaymentAccountIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocateLineDownPaymentAccountIdMutation, AllocateLineDownPaymentAccountIdMutationVariables>(AllocateLineDownPaymentAccountIdDocument, options);
      }
export type AllocateLineDownPaymentAccountIdMutationHookResult = ReturnType<typeof useAllocateLineDownPaymentAccountIdMutation>;
export type AllocateLineDownPaymentAccountIdMutationResult = Apollo.MutationResult<AllocateLineDownPaymentAccountIdMutation>;
export type AllocateLineDownPaymentAccountIdMutationOptions = Apollo.BaseMutationOptions<AllocateLineDownPaymentAccountIdMutation, AllocateLineDownPaymentAccountIdMutationVariables>;
export const GenerateLineDocumentUrlDocument = gql`
    query generateLineDocumentUrl($lineId: String!, $documentType: LineDocumentType!) {
  generateLineDocumentUrl(lineId: $lineId, documentType: $documentType) {
    url
    envelopeId
  }
}
    `;

/**
 * __useGenerateLineDocumentUrlQuery__
 *
 * To run a query within a React component, call `useGenerateLineDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateLineDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateLineDocumentUrlQuery({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      documentType: // value for 'documentType'
 *   },
 * });
 */
export function useGenerateLineDocumentUrlQuery(baseOptions: Apollo.QueryHookOptions<GenerateLineDocumentUrlQuery, GenerateLineDocumentUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateLineDocumentUrlQuery, GenerateLineDocumentUrlQueryVariables>(GenerateLineDocumentUrlDocument, options);
      }
export function useGenerateLineDocumentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateLineDocumentUrlQuery, GenerateLineDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateLineDocumentUrlQuery, GenerateLineDocumentUrlQueryVariables>(GenerateLineDocumentUrlDocument, options);
        }
export type GenerateLineDocumentUrlQueryHookResult = ReturnType<typeof useGenerateLineDocumentUrlQuery>;
export type GenerateLineDocumentUrlLazyQueryHookResult = ReturnType<typeof useGenerateLineDocumentUrlLazyQuery>;
export type GenerateLineDocumentUrlQueryResult = Apollo.QueryResult<GenerateLineDocumentUrlQuery, GenerateLineDocumentUrlQueryVariables>;
export function refetchGenerateLineDocumentUrlQuery(variables: GenerateLineDocumentUrlQueryVariables) {
      return { query: GenerateLineDocumentUrlDocument, variables: variables }
    }
export const DocumentSigningCompletedDocument = gql`
    query documentSigningCompleted($lineId: String!, $documentId: String!) {
  documentSigningCompleted(lineId: $lineId, documentId: $documentId) {
    success
  }
}
    `;

/**
 * __useDocumentSigningCompletedQuery__
 *
 * To run a query within a React component, call `useDocumentSigningCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSigningCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSigningCompletedQuery({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentSigningCompletedQuery(baseOptions: Apollo.QueryHookOptions<DocumentSigningCompletedQuery, DocumentSigningCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSigningCompletedQuery, DocumentSigningCompletedQueryVariables>(DocumentSigningCompletedDocument, options);
      }
export function useDocumentSigningCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSigningCompletedQuery, DocumentSigningCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSigningCompletedQuery, DocumentSigningCompletedQueryVariables>(DocumentSigningCompletedDocument, options);
        }
export type DocumentSigningCompletedQueryHookResult = ReturnType<typeof useDocumentSigningCompletedQuery>;
export type DocumentSigningCompletedLazyQueryHookResult = ReturnType<typeof useDocumentSigningCompletedLazyQuery>;
export type DocumentSigningCompletedQueryResult = Apollo.QueryResult<DocumentSigningCompletedQuery, DocumentSigningCompletedQueryVariables>;
export function refetchDocumentSigningCompletedQuery(variables: DocumentSigningCompletedQueryVariables) {
      return { query: DocumentSigningCompletedDocument, variables: variables }
    }
export const UploadProofOfInsuranceForLineDocument = gql`
    mutation UploadProofOfInsuranceForLine($lineId: String!, $insuranceProof: Upload!) {
  uploadProofOfInsuranceForLine(
    input: {lineId: $lineId, insuranceProof: $insuranceProof}
  ) {
    ...LineData
  }
}
    ${LineDataFragmentDoc}`;
export type UploadProofOfInsuranceForLineMutationFn = Apollo.MutationFunction<UploadProofOfInsuranceForLineMutation, UploadProofOfInsuranceForLineMutationVariables>;

/**
 * __useUploadProofOfInsuranceForLineMutation__
 *
 * To run a mutation, you first call `useUploadProofOfInsuranceForLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProofOfInsuranceForLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProofOfInsuranceForLineMutation, { data, loading, error }] = useUploadProofOfInsuranceForLineMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      insuranceProof: // value for 'insuranceProof'
 *   },
 * });
 */
export function useUploadProofOfInsuranceForLineMutation(baseOptions?: Apollo.MutationHookOptions<UploadProofOfInsuranceForLineMutation, UploadProofOfInsuranceForLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProofOfInsuranceForLineMutation, UploadProofOfInsuranceForLineMutationVariables>(UploadProofOfInsuranceForLineDocument, options);
      }
export type UploadProofOfInsuranceForLineMutationHookResult = ReturnType<typeof useUploadProofOfInsuranceForLineMutation>;
export type UploadProofOfInsuranceForLineMutationResult = Apollo.MutationResult<UploadProofOfInsuranceForLineMutation>;
export type UploadProofOfInsuranceForLineMutationOptions = Apollo.BaseMutationOptions<UploadProofOfInsuranceForLineMutation, UploadProofOfInsuranceForLineMutationVariables>;
export const CalculateAmortizationDocument = gql`
    query calculateAmortization($input: AmortizationCalculationInput!) {
  calculateAmortization(input: $input) {
    interestRatePercent
    monthlyPaymentAmount {
      display
      amount
    }
    monthlyRepaymentFeePercent {
      display
      amount
    }
    projectedPayoffDate
    schedule {
      ...LinePaymentScheduleData
    }
    termLengthInMonths
    totalAmountBorrowed {
      display
      amount
    }
    totalInterestAmount {
      display
      amount
    }
  }
}
    ${LinePaymentScheduleDataFragmentDoc}`;

/**
 * __useCalculateAmortizationQuery__
 *
 * To run a query within a React component, call `useCalculateAmortizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateAmortizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateAmortizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateAmortizationQuery(baseOptions: Apollo.QueryHookOptions<CalculateAmortizationQuery, CalculateAmortizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateAmortizationQuery, CalculateAmortizationQueryVariables>(CalculateAmortizationDocument, options);
      }
export function useCalculateAmortizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateAmortizationQuery, CalculateAmortizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateAmortizationQuery, CalculateAmortizationQueryVariables>(CalculateAmortizationDocument, options);
        }
export type CalculateAmortizationQueryHookResult = ReturnType<typeof useCalculateAmortizationQuery>;
export type CalculateAmortizationLazyQueryHookResult = ReturnType<typeof useCalculateAmortizationLazyQuery>;
export type CalculateAmortizationQueryResult = Apollo.QueryResult<CalculateAmortizationQuery, CalculateAmortizationQueryVariables>;
export function refetchCalculateAmortizationQuery(variables: CalculateAmortizationQueryVariables) {
      return { query: CalculateAmortizationDocument, variables: variables }
    }
export const AddBusinessInfoDocument = gql`
    mutation AddBusinessInfo($organizationId: String, $orgType: OrganizationType!, $orgName: String, $legalStructure: String, $taxStatus: String, $taxId: String, $stateOfIncorporation: String, $businessPhoneNumber: String, $category: String, $streetAddress: String, $city: String, $state: String, $zip: String) {
  createOrUpdateOrganization(
    input: {organizationId: $organizationId, orgType: $orgType, orgName: $orgName, legalStructure: $legalStructure, taxStatus: $taxStatus, taxId: $taxId, stateOfIncorporation: $stateOfIncorporation, category: $category, businessPhoneNumber: $businessPhoneNumber, streetAddress: $streetAddress, city: $city, state: $state, zip: $zip}
  ) {
    ...BusinessData
  }
}
    ${BusinessDataFragmentDoc}`;
export type AddBusinessInfoMutationFn = Apollo.MutationFunction<AddBusinessInfoMutation, AddBusinessInfoMutationVariables>;

/**
 * __useAddBusinessInfoMutation__
 *
 * To run a mutation, you first call `useAddBusinessInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBusinessInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBusinessInfoMutation, { data, loading, error }] = useAddBusinessInfoMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      orgType: // value for 'orgType'
 *      orgName: // value for 'orgName'
 *      legalStructure: // value for 'legalStructure'
 *      taxStatus: // value for 'taxStatus'
 *      taxId: // value for 'taxId'
 *      stateOfIncorporation: // value for 'stateOfIncorporation'
 *      businessPhoneNumber: // value for 'businessPhoneNumber'
 *      category: // value for 'category'
 *      streetAddress: // value for 'streetAddress'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useAddBusinessInfoMutation(baseOptions?: Apollo.MutationHookOptions<AddBusinessInfoMutation, AddBusinessInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBusinessInfoMutation, AddBusinessInfoMutationVariables>(AddBusinessInfoDocument, options);
      }
export type AddBusinessInfoMutationHookResult = ReturnType<typeof useAddBusinessInfoMutation>;
export type AddBusinessInfoMutationResult = Apollo.MutationResult<AddBusinessInfoMutation>;
export type AddBusinessInfoMutationOptions = Apollo.BaseMutationOptions<AddBusinessInfoMutation, AddBusinessInfoMutationVariables>;
export const UpdateOwnersDocument = gql`
    mutation UpdateOwners($organizationId: String!, $beneficialOwners: [BeneficialOwnerInput!]!) {
  updateOwners(
    input: {organizationId: $organizationId, beneficialOwners: $beneficialOwners}
  ) {
    success
  }
}
    `;
export type UpdateOwnersMutationFn = Apollo.MutationFunction<UpdateOwnersMutation, UpdateOwnersMutationVariables>;

/**
 * __useUpdateOwnersMutation__
 *
 * To run a mutation, you first call `useUpdateOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOwnersMutation, { data, loading, error }] = useUpdateOwnersMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      beneficialOwners: // value for 'beneficialOwners'
 *   },
 * });
 */
export function useUpdateOwnersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOwnersMutation, UpdateOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOwnersMutation, UpdateOwnersMutationVariables>(UpdateOwnersDocument, options);
      }
export type UpdateOwnersMutationHookResult = ReturnType<typeof useUpdateOwnersMutation>;
export type UpdateOwnersMutationResult = Apollo.MutationResult<UpdateOwnersMutation>;
export type UpdateOwnersMutationOptions = Apollo.BaseMutationOptions<UpdateOwnersMutation, UpdateOwnersMutationVariables>;
export const ReissueTokenDocument = gql`
    mutation ReissueToken($organizationId: String!) {
  reIssueToken(input: {organizationId: $organizationId}) {
    session
  }
}
    `;
export type ReissueTokenMutationFn = Apollo.MutationFunction<ReissueTokenMutation, ReissueTokenMutationVariables>;

/**
 * __useReissueTokenMutation__
 *
 * To run a mutation, you first call `useReissueTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissueTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissueTokenMutation, { data, loading, error }] = useReissueTokenMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReissueTokenMutation(baseOptions?: Apollo.MutationHookOptions<ReissueTokenMutation, ReissueTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReissueTokenMutation, ReissueTokenMutationVariables>(ReissueTokenDocument, options);
      }
export type ReissueTokenMutationHookResult = ReturnType<typeof useReissueTokenMutation>;
export type ReissueTokenMutationResult = Apollo.MutationResult<ReissueTokenMutation>;
export type ReissueTokenMutationOptions = Apollo.BaseMutationOptions<ReissueTokenMutation, ReissueTokenMutationVariables>;
export const OrganizationOwnersDocument = gql`
    query OrganizationOwners($id: String!) {
  organization(orgId: $id) {
    ...OwnerData
  }
}
    ${OwnerDataFragmentDoc}`;

/**
 * __useOrganizationOwnersQuery__
 *
 * To run a query within a React component, call `useOrganizationOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOwnersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationOwnersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationOwnersQuery, OrganizationOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationOwnersQuery, OrganizationOwnersQueryVariables>(OrganizationOwnersDocument, options);
      }
export function useOrganizationOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationOwnersQuery, OrganizationOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationOwnersQuery, OrganizationOwnersQueryVariables>(OrganizationOwnersDocument, options);
        }
export type OrganizationOwnersQueryHookResult = ReturnType<typeof useOrganizationOwnersQuery>;
export type OrganizationOwnersLazyQueryHookResult = ReturnType<typeof useOrganizationOwnersLazyQuery>;
export type OrganizationOwnersQueryResult = Apollo.QueryResult<OrganizationOwnersQuery, OrganizationOwnersQueryVariables>;
export function refetchOrganizationOwnersQuery(variables: OrganizationOwnersQueryVariables) {
      return { query: OrganizationOwnersDocument, variables: variables }
    }
export const TransactionsForOrgDocument = gql`
    query TransactionsForOrg {
  transactionsForOrg {
    ...FullTransactionData
  }
}
    ${FullTransactionDataFragmentDoc}`;

/**
 * __useTransactionsForOrgQuery__
 *
 * To run a query within a React component, call `useTransactionsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsForOrgQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionsForOrgQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsForOrgQuery, TransactionsForOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsForOrgQuery, TransactionsForOrgQueryVariables>(TransactionsForOrgDocument, options);
      }
export function useTransactionsForOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsForOrgQuery, TransactionsForOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsForOrgQuery, TransactionsForOrgQueryVariables>(TransactionsForOrgDocument, options);
        }
export type TransactionsForOrgQueryHookResult = ReturnType<typeof useTransactionsForOrgQuery>;
export type TransactionsForOrgLazyQueryHookResult = ReturnType<typeof useTransactionsForOrgLazyQuery>;
export type TransactionsForOrgQueryResult = Apollo.QueryResult<TransactionsForOrgQuery, TransactionsForOrgQueryVariables>;
export function refetchTransactionsForOrgQuery(variables?: TransactionsForOrgQueryVariables) {
      return { query: TransactionsForOrgDocument, variables: variables }
    }
export const OrganizationByIdBalancesDocument = gql`
    query OrganizationByIdBalances($orgId: String!, $timeframe: BalancesTimeframe) {
  organization(orgId: $orgId) {
    id
    balances(timeframe: $timeframe) {
      period
      balance {
        amount
        display
      }
    }
  }
}
    `;

/**
 * __useOrganizationByIdBalancesQuery__
 *
 * To run a query within a React component, call `useOrganizationByIdBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByIdBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByIdBalancesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useOrganizationByIdBalancesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByIdBalancesQuery, OrganizationByIdBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByIdBalancesQuery, OrganizationByIdBalancesQueryVariables>(OrganizationByIdBalancesDocument, options);
      }
export function useOrganizationByIdBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByIdBalancesQuery, OrganizationByIdBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByIdBalancesQuery, OrganizationByIdBalancesQueryVariables>(OrganizationByIdBalancesDocument, options);
        }
export type OrganizationByIdBalancesQueryHookResult = ReturnType<typeof useOrganizationByIdBalancesQuery>;
export type OrganizationByIdBalancesLazyQueryHookResult = ReturnType<typeof useOrganizationByIdBalancesLazyQuery>;
export type OrganizationByIdBalancesQueryResult = Apollo.QueryResult<OrganizationByIdBalancesQuery, OrganizationByIdBalancesQueryVariables>;
export function refetchOrganizationByIdBalancesQuery(variables: OrganizationByIdBalancesQueryVariables) {
      return { query: OrganizationByIdBalancesDocument, variables: variables }
    }
export const OrganizationByIdDocument = gql`
    query OrganizationById($orgId: String!) {
  organization(orgId: $orgId) {
    ...OrgData
    ...OwnerData
    externalBalance {
      display
      amount
    }
    totalBalance {
      display
      amount
    }
    availableBalance {
      display
      amount
    }
    deposits {
      display
      amount
    }
    spent {
      display
      amount
    }
  }
}
    ${OrgDataFragmentDoc}
${OwnerDataFragmentDoc}`;

/**
 * __useOrganizationByIdQuery__
 *
 * To run a query within a React component, call `useOrganizationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByIdQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useOrganizationByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
      }
export function useOrganizationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByIdQuery, OrganizationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByIdQuery, OrganizationByIdQueryVariables>(OrganizationByIdDocument, options);
        }
export type OrganizationByIdQueryHookResult = ReturnType<typeof useOrganizationByIdQuery>;
export type OrganizationByIdLazyQueryHookResult = ReturnType<typeof useOrganizationByIdLazyQuery>;
export type OrganizationByIdQueryResult = Apollo.QueryResult<OrganizationByIdQuery, OrganizationByIdQueryVariables>;
export function refetchOrganizationByIdQuery(variables: OrganizationByIdQueryVariables) {
      return { query: OrganizationByIdDocument, variables: variables }
    }
export const OrganizationUsersDocument = gql`
    query OrganizationUsers($orgId: String!, $selectedUserId: String) {
  organization(orgId: $orgId) {
    id
    role
    users(selectedId: $selectedUserId) {
      id
      email
      firstName
      lastName
      orgRole
      status
      selected
      isThisMe
      cards {
        ...CardData
      }
    }
  }
}
    ${CardDataFragmentDoc}`;

/**
 * __useOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationUsersQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      selectedUserId: // value for 'selectedUserId'
 *   },
 * });
 */
export function useOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationUsersQuery, OrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, options);
      }
export function useOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationUsersQuery, OrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationUsersQuery, OrganizationUsersQueryVariables>(OrganizationUsersDocument, options);
        }
export type OrganizationUsersQueryHookResult = ReturnType<typeof useOrganizationUsersQuery>;
export type OrganizationUsersLazyQueryHookResult = ReturnType<typeof useOrganizationUsersLazyQuery>;
export type OrganizationUsersQueryResult = Apollo.QueryResult<OrganizationUsersQuery, OrganizationUsersQueryVariables>;
export function refetchOrganizationUsersQuery(variables: OrganizationUsersQueryVariables) {
      return { query: OrganizationUsersDocument, variables: variables }
    }
export const RevokeOrgInviteDocument = gql`
    mutation RevokeOrgInvite($userId: String!) {
  revokeInviteToOrg(input: {userId: $userId}) {
    success
  }
}
    `;
export type RevokeOrgInviteMutationFn = Apollo.MutationFunction<RevokeOrgInviteMutation, RevokeOrgInviteMutationVariables>;

/**
 * __useRevokeOrgInviteMutation__
 *
 * To run a mutation, you first call `useRevokeOrgInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOrgInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOrgInviteMutation, { data, loading, error }] = useRevokeOrgInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRevokeOrgInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeOrgInviteMutation, RevokeOrgInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeOrgInviteMutation, RevokeOrgInviteMutationVariables>(RevokeOrgInviteDocument, options);
      }
export type RevokeOrgInviteMutationHookResult = ReturnType<typeof useRevokeOrgInviteMutation>;
export type RevokeOrgInviteMutationResult = Apollo.MutationResult<RevokeOrgInviteMutation>;
export type RevokeOrgInviteMutationOptions = Apollo.BaseMutationOptions<RevokeOrgInviteMutation, RevokeOrgInviteMutationVariables>;
export const RemoveOrgUserDocument = gql`
    mutation RemoveOrgUser($userId: String!) {
  removeOrgUser(userId: $userId) {
    success
  }
}
    `;
export type RemoveOrgUserMutationFn = Apollo.MutationFunction<RemoveOrgUserMutation, RemoveOrgUserMutationVariables>;

/**
 * __useRemoveOrgUserMutation__
 *
 * To run a mutation, you first call `useRemoveOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrgUserMutation, { data, loading, error }] = useRemoveOrgUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveOrgUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOrgUserMutation, RemoveOrgUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOrgUserMutation, RemoveOrgUserMutationVariables>(RemoveOrgUserDocument, options);
      }
export type RemoveOrgUserMutationHookResult = ReturnType<typeof useRemoveOrgUserMutation>;
export type RemoveOrgUserMutationResult = Apollo.MutationResult<RemoveOrgUserMutation>;
export type RemoveOrgUserMutationOptions = Apollo.BaseMutationOptions<RemoveOrgUserMutation, RemoveOrgUserMutationVariables>;
export const FreezeOrgUserDocument = gql`
    mutation FreezeOrgUser($userId: String!) {
  freezeOrgUser(userId: $userId) {
    success
  }
}
    `;
export type FreezeOrgUserMutationFn = Apollo.MutationFunction<FreezeOrgUserMutation, FreezeOrgUserMutationVariables>;

/**
 * __useFreezeOrgUserMutation__
 *
 * To run a mutation, you first call `useFreezeOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreezeOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freezeOrgUserMutation, { data, loading, error }] = useFreezeOrgUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFreezeOrgUserMutation(baseOptions?: Apollo.MutationHookOptions<FreezeOrgUserMutation, FreezeOrgUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreezeOrgUserMutation, FreezeOrgUserMutationVariables>(FreezeOrgUserDocument, options);
      }
export type FreezeOrgUserMutationHookResult = ReturnType<typeof useFreezeOrgUserMutation>;
export type FreezeOrgUserMutationResult = Apollo.MutationResult<FreezeOrgUserMutation>;
export type FreezeOrgUserMutationOptions = Apollo.BaseMutationOptions<FreezeOrgUserMutation, FreezeOrgUserMutationVariables>;
export const ThawOrgUserDocument = gql`
    mutation ThawOrgUser($userId: String!) {
  thawOrgUser(userId: $userId) {
    success
  }
}
    `;
export type ThawOrgUserMutationFn = Apollo.MutationFunction<ThawOrgUserMutation, ThawOrgUserMutationVariables>;

/**
 * __useThawOrgUserMutation__
 *
 * To run a mutation, you first call `useThawOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useThawOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [thawOrgUserMutation, { data, loading, error }] = useThawOrgUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useThawOrgUserMutation(baseOptions?: Apollo.MutationHookOptions<ThawOrgUserMutation, ThawOrgUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ThawOrgUserMutation, ThawOrgUserMutationVariables>(ThawOrgUserDocument, options);
      }
export type ThawOrgUserMutationHookResult = ReturnType<typeof useThawOrgUserMutation>;
export type ThawOrgUserMutationResult = Apollo.MutationResult<ThawOrgUserMutation>;
export type ThawOrgUserMutationOptions = Apollo.BaseMutationOptions<ThawOrgUserMutation, ThawOrgUserMutationVariables>;
export const EditOrgUserDocument = gql`
    mutation EditOrgUser($userId: String!, $role: Role!) {
  editOrgUserAccess(input: {userId: $userId, role: $role}) {
    success
  }
}
    `;
export type EditOrgUserMutationFn = Apollo.MutationFunction<EditOrgUserMutation, EditOrgUserMutationVariables>;

/**
 * __useEditOrgUserMutation__
 *
 * To run a mutation, you first call `useEditOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrgUserMutation, { data, loading, error }] = useEditOrgUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useEditOrgUserMutation(baseOptions?: Apollo.MutationHookOptions<EditOrgUserMutation, EditOrgUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrgUserMutation, EditOrgUserMutationVariables>(EditOrgUserDocument, options);
      }
export type EditOrgUserMutationHookResult = ReturnType<typeof useEditOrgUserMutation>;
export type EditOrgUserMutationResult = Apollo.MutationResult<EditOrgUserMutation>;
export type EditOrgUserMutationOptions = Apollo.BaseMutationOptions<EditOrgUserMutation, EditOrgUserMutationVariables>;
export const DeleteOrgDocument = gql`
    mutation DeleteOrg($id: String!) {
  deleteOrganization(input: {orgId: $id}) {
    success
  }
}
    `;
export type DeleteOrgMutationFn = Apollo.MutationFunction<DeleteOrgMutation, DeleteOrgMutationVariables>;

/**
 * __useDeleteOrgMutation__
 *
 * To run a mutation, you first call `useDeleteOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrgMutation, { data, loading, error }] = useDeleteOrgMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrgMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrgMutation, DeleteOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrgMutation, DeleteOrgMutationVariables>(DeleteOrgDocument, options);
      }
export type DeleteOrgMutationHookResult = ReturnType<typeof useDeleteOrgMutation>;
export type DeleteOrgMutationResult = Apollo.MutationResult<DeleteOrgMutation>;
export type DeleteOrgMutationOptions = Apollo.BaseMutationOptions<DeleteOrgMutation, DeleteOrgMutationVariables>;
export const InviteUserToOrgDocument = gql`
    mutation InviteUserToOrg($permissionLevel: PermissionLevel!, $email: String!, $sendEmail: Boolean!) {
  inviteUserToOrg(
    input: {permissionLevel: $permissionLevel, email: $email, sendEmail: $sendEmail}
  ) {
    token
    userId
  }
}
    `;
export type InviteUserToOrgMutationFn = Apollo.MutationFunction<InviteUserToOrgMutation, InviteUserToOrgMutationVariables>;

/**
 * __useInviteUserToOrgMutation__
 *
 * To run a mutation, you first call `useInviteUserToOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserToOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserToOrgMutation, { data, loading, error }] = useInviteUserToOrgMutation({
 *   variables: {
 *      permissionLevel: // value for 'permissionLevel'
 *      email: // value for 'email'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useInviteUserToOrgMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserToOrgMutation, InviteUserToOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserToOrgMutation, InviteUserToOrgMutationVariables>(InviteUserToOrgDocument, options);
      }
export type InviteUserToOrgMutationHookResult = ReturnType<typeof useInviteUserToOrgMutation>;
export type InviteUserToOrgMutationResult = Apollo.MutationResult<InviteUserToOrgMutation>;
export type InviteUserToOrgMutationOptions = Apollo.BaseMutationOptions<InviteUserToOrgMutation, InviteUserToOrgMutationVariables>;
export const RequetAccreditationDocument = gql`
    mutation RequetAccreditation {
  requestAccreditation {
    success
  }
}
    `;
export type RequetAccreditationMutationFn = Apollo.MutationFunction<RequetAccreditationMutation, RequetAccreditationMutationVariables>;

/**
 * __useRequetAccreditationMutation__
 *
 * To run a mutation, you first call `useRequetAccreditationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequetAccreditationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requetAccreditationMutation, { data, loading, error }] = useRequetAccreditationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequetAccreditationMutation(baseOptions?: Apollo.MutationHookOptions<RequetAccreditationMutation, RequetAccreditationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequetAccreditationMutation, RequetAccreditationMutationVariables>(RequetAccreditationDocument, options);
      }
export type RequetAccreditationMutationHookResult = ReturnType<typeof useRequetAccreditationMutation>;
export type RequetAccreditationMutationResult = Apollo.MutationResult<RequetAccreditationMutation>;
export type RequetAccreditationMutationOptions = Apollo.BaseMutationOptions<RequetAccreditationMutation, RequetAccreditationMutationVariables>;
export const AllocateRepaymentAccountIdDocument = gql`
    mutation allocateRepaymentAccountId($accountId: String!) {
  allocateRepaymentAccountId(accountId: $accountId) {
    ...OrgData
  }
}
    ${OrgDataFragmentDoc}`;
export type AllocateRepaymentAccountIdMutationFn = Apollo.MutationFunction<AllocateRepaymentAccountIdMutation, AllocateRepaymentAccountIdMutationVariables>;

/**
 * __useAllocateRepaymentAccountIdMutation__
 *
 * To run a mutation, you first call `useAllocateRepaymentAccountIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllocateRepaymentAccountIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allocateRepaymentAccountIdMutation, { data, loading, error }] = useAllocateRepaymentAccountIdMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAllocateRepaymentAccountIdMutation(baseOptions?: Apollo.MutationHookOptions<AllocateRepaymentAccountIdMutation, AllocateRepaymentAccountIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AllocateRepaymentAccountIdMutation, AllocateRepaymentAccountIdMutationVariables>(AllocateRepaymentAccountIdDocument, options);
      }
export type AllocateRepaymentAccountIdMutationHookResult = ReturnType<typeof useAllocateRepaymentAccountIdMutation>;
export type AllocateRepaymentAccountIdMutationResult = Apollo.MutationResult<AllocateRepaymentAccountIdMutation>;
export type AllocateRepaymentAccountIdMutationOptions = Apollo.BaseMutationOptions<AllocateRepaymentAccountIdMutation, AllocateRepaymentAccountIdMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($input: CreatePaymentInput!) {
  createPayment(input: $input) {
    id
    amount {
      amount
      display
    }
    description
  }
}
    `;
export type CreatePaymentMutationFn = Apollo.MutationFunction<CreatePaymentMutation, CreatePaymentMutationVariables>;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const GetInstitutionInfoDocument = gql`
    query GetInstitutionInfo($routingNumber: String!) {
  institutionInfo(routingNumber: $routingNumber) {
    routingNumber
    name
    address
    isAchSupported
    isWireSupported
  }
}
    `;

/**
 * __useGetInstitutionInfoQuery__
 *
 * To run a query within a React component, call `useGetInstitutionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstitutionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstitutionInfoQuery({
 *   variables: {
 *      routingNumber: // value for 'routingNumber'
 *   },
 * });
 */
export function useGetInstitutionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInstitutionInfoQuery, GetInstitutionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstitutionInfoQuery, GetInstitutionInfoQueryVariables>(GetInstitutionInfoDocument, options);
      }
export function useGetInstitutionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstitutionInfoQuery, GetInstitutionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstitutionInfoQuery, GetInstitutionInfoQueryVariables>(GetInstitutionInfoDocument, options);
        }
export type GetInstitutionInfoQueryHookResult = ReturnType<typeof useGetInstitutionInfoQuery>;
export type GetInstitutionInfoLazyQueryHookResult = ReturnType<typeof useGetInstitutionInfoLazyQuery>;
export type GetInstitutionInfoQueryResult = Apollo.QueryResult<GetInstitutionInfoQuery, GetInstitutionInfoQueryVariables>;
export function refetchGetInstitutionInfoQuery(variables: GetInstitutionInfoQueryVariables) {
      return { query: GetInstitutionInfoDocument, variables: variables }
    }
export const RecipientsDocument = gql`
    query Recipients {
  recipients {
    recipients {
      id
      nickname
      accountHolderName
      accountNumber
      routingNumber
      organizationId
      transferType
      street
      city
      state
      zipCode
      country
      wireDescription
    }
  }
}
    `;

/**
 * __useRecipientsQuery__
 *
 * To run a query within a React component, call `useRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<RecipientsQuery, RecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipientsQuery, RecipientsQueryVariables>(RecipientsDocument, options);
      }
export function useRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipientsQuery, RecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipientsQuery, RecipientsQueryVariables>(RecipientsDocument, options);
        }
export type RecipientsQueryHookResult = ReturnType<typeof useRecipientsQuery>;
export type RecipientsLazyQueryHookResult = ReturnType<typeof useRecipientsLazyQuery>;
export type RecipientsQueryResult = Apollo.QueryResult<RecipientsQuery, RecipientsQueryVariables>;
export function refetchRecipientsQuery(variables?: RecipientsQueryVariables) {
      return { query: RecipientsDocument, variables: variables }
    }
export const RecipientDocument = gql`
    query Recipient($recipientId: String!) {
  recipient(recipientId: $recipientId) {
    id
    nickname
    accountHolderName
    accountNumber
    routingNumber
    organizationId
    transferType
    street
    city
    state
    zipCode
    country
    wireDescription
  }
}
    `;

/**
 * __useRecipientQuery__
 *
 * To run a query within a React component, call `useRecipientQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientQuery({
 *   variables: {
 *      recipientId: // value for 'recipientId'
 *   },
 * });
 */
export function useRecipientQuery(baseOptions: Apollo.QueryHookOptions<RecipientQuery, RecipientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipientQuery, RecipientQueryVariables>(RecipientDocument, options);
      }
export function useRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipientQuery, RecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipientQuery, RecipientQueryVariables>(RecipientDocument, options);
        }
export type RecipientQueryHookResult = ReturnType<typeof useRecipientQuery>;
export type RecipientLazyQueryHookResult = ReturnType<typeof useRecipientLazyQuery>;
export type RecipientQueryResult = Apollo.QueryResult<RecipientQuery, RecipientQueryVariables>;
export function refetchRecipientQuery(variables: RecipientQueryVariables) {
      return { query: RecipientDocument, variables: variables }
    }
export const CreateRecipientDocument = gql`
    mutation CreateRecipient($input: CreateRecipientInput!) {
  createRecipient(input: $input) {
    id
  }
}
    `;
export type CreateRecipientMutationFn = Apollo.MutationFunction<CreateRecipientMutation, CreateRecipientMutationVariables>;

/**
 * __useCreateRecipientMutation__
 *
 * To run a mutation, you first call `useCreateRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecipientMutation, { data, loading, error }] = useCreateRecipientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecipientMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecipientMutation, CreateRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecipientMutation, CreateRecipientMutationVariables>(CreateRecipientDocument, options);
      }
export type CreateRecipientMutationHookResult = ReturnType<typeof useCreateRecipientMutation>;
export type CreateRecipientMutationResult = Apollo.MutationResult<CreateRecipientMutation>;
export type CreateRecipientMutationOptions = Apollo.BaseMutationOptions<CreateRecipientMutation, CreateRecipientMutationVariables>;
export const DeleteRecipientDocument = gql`
    mutation DeleteRecipient($recipientId: String!) {
  deleteRecipient(recipientId: $recipientId) {
    success
  }
}
    `;
export type DeleteRecipientMutationFn = Apollo.MutationFunction<DeleteRecipientMutation, DeleteRecipientMutationVariables>;

/**
 * __useDeleteRecipientMutation__
 *
 * To run a mutation, you first call `useDeleteRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecipientMutation, { data, loading, error }] = useDeleteRecipientMutation({
 *   variables: {
 *      recipientId: // value for 'recipientId'
 *   },
 * });
 */
export function useDeleteRecipientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecipientMutation, DeleteRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecipientMutation, DeleteRecipientMutationVariables>(DeleteRecipientDocument, options);
      }
export type DeleteRecipientMutationHookResult = ReturnType<typeof useDeleteRecipientMutation>;
export type DeleteRecipientMutationResult = Apollo.MutationResult<DeleteRecipientMutation>;
export type DeleteRecipientMutationOptions = Apollo.BaseMutationOptions<DeleteRecipientMutation, DeleteRecipientMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserData
    checks {
      type
      status
      comments
    }
  }
}
    ${UserDataFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export function refetchMeQuery(variables?: MeQueryVariables) {
      return { query: MeDocument, variables: variables }
    }
export const CreateUserDocument = gql`
    mutation CreateUser($firstName: String!, $lastName: String!, $email: String, $phone: String!, $password: String!, $referralCode: String, $netWorth: String!, $inviteCode: String, $partnershipType: PartnershipType) {
  createUser(
    input: {firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, password: $password, referralCode: $referralCode, netWorth: $netWorth, inviteCode: $inviteCode, partnershipType: $partnershipType}
  ) {
    token
    ...CreatedUserData
  }
}
    ${CreatedUserDataFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      referralCode: // value for 'referralCode'
 *      netWorth: // value for 'netWorth'
 *      inviteCode: // value for 'inviteCode'
 *      partnershipType: // value for 'partnershipType'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: ID!, $firstName: String!, $lastName: String!, $phone: String!, $netWorth: String!) {
  editBasicUserInformation(
    input: {userId: $userId, firstName: $firstName, lastName: $lastName, phone: $phone, netWorth: $netWorth}
  ) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      netWorth: // value for 'netWorth'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AddPersonalInfoDocument = gql`
    mutation AddPersonalInfo($userId: ID!, $DOB: String!, $SSN: String!, $streetAddress: String!, $city: String!, $state: String!, $zip: String!) {
  addPersonalInformationToUser(
    input: {userId: $userId, DOB: $DOB, SSN: $SSN, streetAddress: $streetAddress, city: $city, state: $state, zip: $zip}
  ) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type AddPersonalInfoMutationFn = Apollo.MutationFunction<AddPersonalInfoMutation, AddPersonalInfoMutationVariables>;

/**
 * __useAddPersonalInfoMutation__
 *
 * To run a mutation, you first call `useAddPersonalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonalInfoMutation, { data, loading, error }] = useAddPersonalInfoMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      DOB: // value for 'DOB'
 *      SSN: // value for 'SSN'
 *      streetAddress: // value for 'streetAddress'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useAddPersonalInfoMutation(baseOptions?: Apollo.MutationHookOptions<AddPersonalInfoMutation, AddPersonalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPersonalInfoMutation, AddPersonalInfoMutationVariables>(AddPersonalInfoDocument, options);
      }
export type AddPersonalInfoMutationHookResult = ReturnType<typeof useAddPersonalInfoMutation>;
export type AddPersonalInfoMutationResult = Apollo.MutationResult<AddPersonalInfoMutation>;
export type AddPersonalInfoMutationOptions = Apollo.BaseMutationOptions<AddPersonalInfoMutation, AddPersonalInfoMutationVariables>;
export const TriggerVerificationDocument = gql`
    mutation TriggerVerification($type: UserVerificationType!) {
  triggerVerification(input: {type: $type}) {
    success
  }
}
    `;
export type TriggerVerificationMutationFn = Apollo.MutationFunction<TriggerVerificationMutation, TriggerVerificationMutationVariables>;

/**
 * __useTriggerVerificationMutation__
 *
 * To run a mutation, you first call `useTriggerVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerVerificationMutation, { data, loading, error }] = useTriggerVerificationMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTriggerVerificationMutation(baseOptions?: Apollo.MutationHookOptions<TriggerVerificationMutation, TriggerVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerVerificationMutation, TriggerVerificationMutationVariables>(TriggerVerificationDocument, options);
      }
export type TriggerVerificationMutationHookResult = ReturnType<typeof useTriggerVerificationMutation>;
export type TriggerVerificationMutationResult = Apollo.MutationResult<TriggerVerificationMutation>;
export type TriggerVerificationMutationOptions = Apollo.BaseMutationOptions<TriggerVerificationMutation, TriggerVerificationMutationVariables>;
export const AddVerificationToUserDocument = gql`
    mutation AddVerificationToUser($userId: ID!, $verificationType: UserVerificationType, $verificationImage: Upload, $idVerificationName: UserIdVerificationName, $token: String, $organizationId: String) {
  addVerificationToUser(
    input: {userId: $userId, verificationType: $verificationType, verificationImage: $verificationImage, idVerificationName: $idVerificationName, token: $token, organizationId: $organizationId}
  ) {
    verified {
      wealth
      id
      mfa
      survey
      phone
      email
      face
      _userId
    }
  }
}
    `;
export type AddVerificationToUserMutationFn = Apollo.MutationFunction<AddVerificationToUserMutation, AddVerificationToUserMutationVariables>;

/**
 * __useAddVerificationToUserMutation__
 *
 * To run a mutation, you first call `useAddVerificationToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVerificationToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVerificationToUserMutation, { data, loading, error }] = useAddVerificationToUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      verificationType: // value for 'verificationType'
 *      verificationImage: // value for 'verificationImage'
 *      idVerificationName: // value for 'idVerificationName'
 *      token: // value for 'token'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAddVerificationToUserMutation(baseOptions?: Apollo.MutationHookOptions<AddVerificationToUserMutation, AddVerificationToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVerificationToUserMutation, AddVerificationToUserMutationVariables>(AddVerificationToUserDocument, options);
      }
export type AddVerificationToUserMutationHookResult = ReturnType<typeof useAddVerificationToUserMutation>;
export type AddVerificationToUserMutationResult = Apollo.MutationResult<AddVerificationToUserMutation>;
export type AddVerificationToUserMutationOptions = Apollo.BaseMutationOptions<AddVerificationToUserMutation, AddVerificationToUserMutationVariables>;
export const CancelAccountDocument = gql`
    mutation CancelAccount {
  cancelAccount {
    success
  }
}
    `;
export type CancelAccountMutationFn = Apollo.MutationFunction<CancelAccountMutation, CancelAccountMutationVariables>;

/**
 * __useCancelAccountMutation__
 *
 * To run a mutation, you first call `useCancelAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAccountMutation, { data, loading, error }] = useCancelAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelAccountMutation(baseOptions?: Apollo.MutationHookOptions<CancelAccountMutation, CancelAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAccountMutation, CancelAccountMutationVariables>(CancelAccountDocument, options);
      }
export type CancelAccountMutationHookResult = ReturnType<typeof useCancelAccountMutation>;
export type CancelAccountMutationResult = Apollo.MutationResult<CancelAccountMutation>;
export type CancelAccountMutationOptions = Apollo.BaseMutationOptions<CancelAccountMutation, CancelAccountMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(input: {email: $email}) {
    success
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($password: String!, $token: String!) {
  resetPassword(input: {password: $password, token: $token}) {
    email
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const OpenAccountDocument = gql`
    mutation OpenAccount {
  openAccount {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type OpenAccountMutationFn = Apollo.MutationFunction<OpenAccountMutation, OpenAccountMutationVariables>;

/**
 * __useOpenAccountMutation__
 *
 * To run a mutation, you first call `useOpenAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openAccountMutation, { data, loading, error }] = useOpenAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useOpenAccountMutation(baseOptions?: Apollo.MutationHookOptions<OpenAccountMutation, OpenAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenAccountMutation, OpenAccountMutationVariables>(OpenAccountDocument, options);
      }
export type OpenAccountMutationHookResult = ReturnType<typeof useOpenAccountMutation>;
export type OpenAccountMutationResult = Apollo.MutationResult<OpenAccountMutation>;
export type OpenAccountMutationOptions = Apollo.BaseMutationOptions<OpenAccountMutation, OpenAccountMutationVariables>;
export const UnlockAccountDocument = gql`
    mutation UnlockAccount {
  unlockAccount {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type UnlockAccountMutationFn = Apollo.MutationFunction<UnlockAccountMutation, UnlockAccountMutationVariables>;

/**
 * __useUnlockAccountMutation__
 *
 * To run a mutation, you first call `useUnlockAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockAccountMutation, { data, loading, error }] = useUnlockAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnlockAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlockAccountMutation, UnlockAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockAccountMutation, UnlockAccountMutationVariables>(UnlockAccountDocument, options);
      }
export type UnlockAccountMutationHookResult = ReturnType<typeof useUnlockAccountMutation>;
export type UnlockAccountMutationResult = Apollo.MutationResult<UnlockAccountMutation>;
export type UnlockAccountMutationOptions = Apollo.BaseMutationOptions<UnlockAccountMutation, UnlockAccountMutationVariables>;
export const EditUserDeviceTokenDocument = gql`
    mutation EditUserDeviceToken($deviceToken: String!) {
  editUserDeviceToken(input: {deviceToken: $deviceToken}) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type EditUserDeviceTokenMutationFn = Apollo.MutationFunction<EditUserDeviceTokenMutation, EditUserDeviceTokenMutationVariables>;

/**
 * __useEditUserDeviceTokenMutation__
 *
 * To run a mutation, you first call `useEditUserDeviceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserDeviceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserDeviceTokenMutation, { data, loading, error }] = useEditUserDeviceTokenMutation({
 *   variables: {
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */
export function useEditUserDeviceTokenMutation(baseOptions?: Apollo.MutationHookOptions<EditUserDeviceTokenMutation, EditUserDeviceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserDeviceTokenMutation, EditUserDeviceTokenMutationVariables>(EditUserDeviceTokenDocument, options);
      }
export type EditUserDeviceTokenMutationHookResult = ReturnType<typeof useEditUserDeviceTokenMutation>;
export type EditUserDeviceTokenMutationResult = Apollo.MutationResult<EditUserDeviceTokenMutation>;
export type EditUserDeviceTokenMutationOptions = Apollo.BaseMutationOptions<EditUserDeviceTokenMutation, EditUserDeviceTokenMutationVariables>;
export const EditUserNotificationSettingsDocument = gql`
    mutation EditUserNotificationSettings($receivePush: Boolean!, $receiveSms: Boolean!) {
  editUserNotificationSettings(
    input: {receivePush: $receivePush, receiveSms: $receiveSms}
  ) {
    ...UserData
  }
}
    ${UserDataFragmentDoc}`;
export type EditUserNotificationSettingsMutationFn = Apollo.MutationFunction<EditUserNotificationSettingsMutation, EditUserNotificationSettingsMutationVariables>;

/**
 * __useEditUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useEditUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserNotificationSettingsMutation, { data, loading, error }] = useEditUserNotificationSettingsMutation({
 *   variables: {
 *      receivePush: // value for 'receivePush'
 *      receiveSms: // value for 'receiveSms'
 *   },
 * });
 */
export function useEditUserNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditUserNotificationSettingsMutation, EditUserNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserNotificationSettingsMutation, EditUserNotificationSettingsMutationVariables>(EditUserNotificationSettingsDocument, options);
      }
export type EditUserNotificationSettingsMutationHookResult = ReturnType<typeof useEditUserNotificationSettingsMutation>;
export type EditUserNotificationSettingsMutationResult = Apollo.MutationResult<EditUserNotificationSettingsMutation>;
export type EditUserNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<EditUserNotificationSettingsMutation, EditUserNotificationSettingsMutationVariables>;
export const ValidatePasswordResetTokenDocument = gql`
    mutation ValidatePasswordResetToken($token: String!) {
  validatePasswordResetToken(input: {token: $token}) {
    valid
  }
}
    `;
export type ValidatePasswordResetTokenMutationFn = Apollo.MutationFunction<ValidatePasswordResetTokenMutation, ValidatePasswordResetTokenMutationVariables>;

/**
 * __useValidatePasswordResetTokenMutation__
 *
 * To run a mutation, you first call `useValidatePasswordResetTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordResetTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validatePasswordResetTokenMutation, { data, loading, error }] = useValidatePasswordResetTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidatePasswordResetTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidatePasswordResetTokenMutation, ValidatePasswordResetTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidatePasswordResetTokenMutation, ValidatePasswordResetTokenMutationVariables>(ValidatePasswordResetTokenDocument, options);
      }
export type ValidatePasswordResetTokenMutationHookResult = ReturnType<typeof useValidatePasswordResetTokenMutation>;
export type ValidatePasswordResetTokenMutationResult = Apollo.MutationResult<ValidatePasswordResetTokenMutation>;
export type ValidatePasswordResetTokenMutationOptions = Apollo.BaseMutationOptions<ValidatePasswordResetTokenMutation, ValidatePasswordResetTokenMutationVariables>;
export const RequestMoreReferralsDocument = gql`
    mutation RequestMoreReferrals {
  requestMoreReferrals {
    success
  }
}
    `;
export type RequestMoreReferralsMutationFn = Apollo.MutationFunction<RequestMoreReferralsMutation, RequestMoreReferralsMutationVariables>;

/**
 * __useRequestMoreReferralsMutation__
 *
 * To run a mutation, you first call `useRequestMoreReferralsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMoreReferralsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMoreReferralsMutation, { data, loading, error }] = useRequestMoreReferralsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestMoreReferralsMutation(baseOptions?: Apollo.MutationHookOptions<RequestMoreReferralsMutation, RequestMoreReferralsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMoreReferralsMutation, RequestMoreReferralsMutationVariables>(RequestMoreReferralsDocument, options);
      }
export type RequestMoreReferralsMutationHookResult = ReturnType<typeof useRequestMoreReferralsMutation>;
export type RequestMoreReferralsMutationResult = Apollo.MutationResult<RequestMoreReferralsMutation>;
export type RequestMoreReferralsMutationOptions = Apollo.BaseMutationOptions<RequestMoreReferralsMutation, RequestMoreReferralsMutationVariables>;